<template >
  <div @mouseup="mouseUp" ref="xx">
    <el-row style="padding-top: 10px">
      <el-button size="mini" type="primary" @click="updateMapData" v-if="isGis">更新数据</el-button>
      <el-button size="mini" type="primary" @click="openFiles">导出</el-button>
      <el-button size="mini" type="primary" @click="config" v-if="false">配置</el-button>
      <el-button size="mini" type="primary" @click="configWg" v-if="!isGis">生成等值图</el-button>
      <el-button ref="isoBig" size="mini" type="primary" :disabled="isSizeChange!=true" @click="zoomIn">放大</el-button>
      <el-button ref="isoSmall" size="mini" type="primary" :disabled="isSizeChange!=true" @click="zoomOut">缩小</el-button>
      <el-button size="mini" type="primary" :disabled="isSizeChange!=true" @click="vectorBack">复原</el-button>
      <el-button size="mini" type="primary" @click="refresh">刷新</el-button>
      <el-button size="mini" type="primary" @click="reInit" v-if="!isGis">重置</el-button>
      <el-button size="mini" type="primary" @click="imageConfig" v-if="isGis">底图配置</el-button>
      <el-button size="mini" type="primary" @click="enlarge">拉框放大</el-button>
      <el-button size="mini" type="primary" @click="block" v-if="!isGis">绘制边界</el-button>
      <!--<el-button size="mini" type="primary" @click="blockDown">选中区块</el-button>-->
      <!--<el-button size="mini" type="primary" @click="clearBlock">clear</el-button>-->
      <el-button id="cx" type="primary" size="mini"  @click="()=>{layerShow=!layerShow;isGis?layer_activeNames=['2']:layer_activeNames=layer_activeNames;}">图层管理</el-button>

      <el-card shadow="hover" :body-style="{padding:'5px'}" style="margin-left: 10px">
        <span style="margin-left: 10px;font-size: 14px;vertical-align:middle">选井方式:</span>
        <el-radio-group v-model="selectType" style="margin-left: 10px">
          <el-radio :label="1">单选</el-radio>
          <el-radio :label="2">多选</el-radio>
          <el-radio :label="3">框选</el-radio>
        </el-radio-group>
      </el-card>

      <el-card shadow="hover" :body-style="{padding:'5px'}" style="margin-left: 10px">
        <span v-if="isGis" style="margin-left: 10px;font-size: 14px;vertical-align:middle">数据关联:</span>
        <el-switch
            v-model="isPointJump"
            v-if="isGis"
            class="switchDemo"
            active-text="否"
            inactive-text="是"
        ></el-switch>
      </el-card>

      <!--      <el-button id="cx" type="primary" icon="el-icon-setting" size="mini" circle style="height:28px;float: right"  @click="layerShow=!layerShow"></el-button>-->
      <!--<el-button size="mini" type="primary" @click="changeSize">缩放</el-button>-->
    </el-row>
    <el-divider v-if="isIosLiseName">{{iosLiseName}}</el-divider>
    <!--<el-divider >{{temporaryPoint}}</el-divider>-->
    <!--<el-divider >{{pointNow}}</el-divider>-->
    <div class="">
      <el-row ref="row" id="row">
        <el-col :span="1" ref="scale" v-show="false">
          <el-tag effect="plain" size="small">缩放</el-tag>
          <el-slider v-if="sizeChangeType==0" v-model="scale" :format-tooltip="tooltip" :show-tooltip="true"
                     :disabled="isSizeChange!=true" :min="0" :max="10" :step="0.1" vertical :height="sliderHeight"
                     @input="changeSize(0,0)"/>
          <el-slider v-else v-model="big" :format-tooltip="tooltip" :show-tooltip="true"
                     :disabled="isSizeChange!=true" :min="1" :step="1" vertical :height="sliderHeight"
                     @input="vectorChange"/>
        </el-col>
        <el-col :span="22" ref="container" id="canvasShow">
          <canvas ref="iosLise" id="iosLise" :width="canvasWidth+200" :height="canvasHeight+45"></canvas>
          <!--v-mouse-menu="options"   @contextmenu.prevent="canvasMenu"-->
          <canvas ref="pointCheck" id="pointCheck" :width="canvasWidth+200" :height="canvasHeight+45"></canvas>
          <canvas ref="blockDraw" id="blockDraw" :width="canvasWidth+200" :height="canvasHeight+45"></canvas>
          <canvas ref="pointShow" id="pointShow" :width="canvasWidth+200" :height="canvasHeight+45" @dblclick.stop="blockOk"
                  @contextmenu.prevent="openMenu($event)" @wheel="canvasWheel($event)"
                  @mouseup="canvasUp($event)" @mousemove="canvasMove($event)"
                  @mousedown="canvasDown($event)"></canvas>

          <!--<canvas ref="vector"  :width="canvasWidth" :height="canvasHeight" @mousemove="canvasMove($event)" @contextmenu.prevent="canvasMenu"></canvas>-->
        </el-col>
        <el-col :span="1" v-show="big>1||difference>0" class="cc2"
                :style="[{'width':ssWidth+'px'},{'height':ssHeight+'px'},{'left':ssLeft+'px'}]">
          <!--<div class="cc1">-->
          <!--<el-slider v-show="sizeChangeType!=0" @input="vectorY" v-model="vectorMoveY" :show-tooltip="false" vertical height="500px"/>-->
          <!--</div>-->
          <!--<div class="cc2" :style="[{'width':ssWidth+'px'},{'height':ssHeight+'px'},{'left':ssLeft+'px'},{'top':ssTop+'px'}]">-->
          <div>
            <el-scrollbar ref="scrollbarY" :height="canvasHeight" always :native="true" @scroll="scrollbarY">
              <!--<div ref="scrollbarYS" :style="{height:canvasHeight*big+difference*big*scale+'px'}"></div>-->
              <div ref="scrollbarYS" :style="{height:canvasHeight*big+'px'}"></div>
            </el-scrollbar>
          </div>
        </el-col>
        <!--<el-col :span="1">-->
        <!--<div :style="[{'height':ssBottom+'px'},{'width':'12px'},{'background':'red'}]"></div>-->
        <!--</el-col>-->
        <el-col  :span="22" v-show="big>1">
          <div class="cc1" ref="cc1">
            <!--<el-slider v-show="sizeChangeType!=0" @input="vectorX" v-model="vectorMoveX" :show-tooltip="false"/>-->
            <div :style="[{'width':canvasWidth+'px'}]" class="cc3">
              <el-scrollbar ref="scrollbarX" always :native="true" @scroll="scrollbarX">
                <div class="scrollbar-demo-item-1" ref="scrollbarXS" :style="{'width':canvasWidth*big+'px'}"></div>
                <!--                    <div class="scrollbar-demo-item-1" ref="scrollbarXS" style="width: 11092.883523293129px"></div>-->
              </el-scrollbar>
            </div>
          </div>

        </el-col>
      </el-row>
    </div>
    <div class="float_div" style="position: absolute;right: 0px;top: 65px;filter: alpha(Opacity=100);-moz-opacity: 1.0;opacity: 1.0">
      <input type="file" style="display: none" name="file" ref="upload" accept=".xls,.xlsx"
             @change="takeExcelInfo()"/>
      <el-tabs type="border-card" v-show="layerShow" style="width: 350px">
        <el-collapse v-model="layer_activeNames" accordion>
          <el-collapse-item name="1">
            <template #title>
              <i class="el-icon-menu"></i>
              <span>图层管理</span>
            </template>
            <div>
              <el-row style="margin-bottom: 10px">
                <!--                        <el-col :span="8"><el-button size="mini" type="primary">添加</el-button></el-col>-->
                <!--                        <el-col :span="8"><el-button size="mini" type="primary">删除</el-button></el-col>-->
                <el-col :span="6" :offset="18">
                  <el-button size="mini" type="primary" @click="overViewDialogVisible=true">数据查看</el-button>
                </el-col>
              </el-row>
              <el-table :data="layer_tableData" border>
                <el-table-column label="类型" prop="type" key="type" width="60px" align="center">
                  <template #default="scope">
                    <div v-if="layer_tableData[scope.$index].type !== '断层'">
                      <span>{{layer_tableData[scope.$index].type}}</span>
                    </div>
                  </template>
                </el-table-column>
                <!--                    <el-table-column label="名称" prop="name" key="name" width="65%" align="center"></el-table-column>-->
                <el-table-column label="显示" prop="show" key="show" width="60px" align="center">
                  <template #default="scope">
                    <div v-if="layer_tableData[scope.$index].type !== '断层'">
                      <el-switch v-model="layer_tableData[scope.$index].show" :disabled="scope.$index==3"></el-switch>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="数据" prop="data" key="data" align="center" >
                  <template #default="scope">
                    <div v-if="layer_tableData[scope.$index].type !== '断层'">
                      <div v-if="layer_tableData[scope.$index].type=='标题'">
                        <el-input v-model="iosLiseName"></el-input>
                      </div>
                      <div v-else-if="layer_tableData[scope.$index].type=='底图'">
                        <el-button size="mini" type="primary" @click="imageConfig">底图配置</el-button>
                      </div>
                      <div v-else>
                        <!--                      <el-select v-model="layer_tableData[scope.$index].dataType" style="width: 60%;margin-right: 2%">-->
                        <!--                        <el-option-->
                        <!--                            v-for="item in layer_selectList"-->
                        <!--                            :key="item.value"-->
                        <!--                            :label="item.label"-->
                        <!--                            :value="item.value">-->
                        <!--                        </el-option>-->
                        <!--                      </el-select>-->
                        <el-input size="small" disabled v-model="layer_tableData[scope.$index].fileName" placeholder="未设置" style="width: 100px"/>
                        <el-button v-if="layer_tableData[scope.$index].dataType=='systemDefault'" size="mini"
                                   type="primary" disabled>设置
                        </el-button>
                        <el-button v-else size="mini" type="primary" @click="layerDataSet(scope.$index,scope.row)">设置
                        </el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-row v-if="false" style="margin-top: 10px">
                <el-col :span="6">
                  <el-button size="mini" type="primary">上移</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button size="mini" type="primary">下移</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button size="mini" type="primary">置顶</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button size="mini" type="primary">置底</el-button>
                </el-col>
              </el-row>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template #title>
              <i class="el-icon-menu"></i>
              <span>图层属性</span>
            </template>
            <el-form>
              <el-form-item label="等值线粗细" style="margin-bottom: 5px;">
                <el-input-number v-model="linesWidth" :min="1"  size="mini"/>
              </el-form-item>
              <el-form-item label="色标值步长" style="margin-bottom: 5px;">
                <el-input-number v-model="colorCodeSpacing" :min="1" size="mini"/>
              </el-form-item>
              <!--              <el-form-item label="断层线粗细" style="margin-bottom: 5px;">-->
              <!--                <el-input-number v-model="faultLineWidth" :min="1" size="mini"/>-->
              <!--              </el-form-item>-->
              <el-form-item label="井标识大小" style="margin-bottom: 5px;">
                <el-input-number v-model="pointSize" :min="1" size="mini"/>
              </el-form-item>
              <el-form-item label="差值柱宽度" style="margin-bottom: 5px;">
                <el-input-number v-model="czSymbolWidth" :min="1" size="mini"/>
              </el-form-item>
              <el-form-item label="差值柱高度" style="margin-bottom: 5px;">
                <el-input-number v-model="czSymbolHeight" :min="1" size="mini"/>
              </el-form-item>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="差值最大值" style="margin-bottom: 5px;">
                    <el-switch v-model="czSymbolMaxNeed"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="" style="margin-bottom: 5px;">
                    <el-input-number v-model="czSymbolMaxVal" size="mini" :disabled="czSymbolMaxNeed?false:true"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="差值最小值" style="margin-bottom: 5px;">
                    <el-switch v-model="czSymbolMinNeed"></el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="" style="margin-bottom: 5px;">
                    <el-input-number v-model="czSymbolMinVal" size="mini" :disabled="czSymbolMinNeed?false:true"/>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="图例每行个数" style="margin-bottom: 5px;">
                <el-input-number v-model="tlColCnt" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="单个图例宽度" style="margin-bottom: 5px;">
                <el-input-number v-model="tlSymbolWidth" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="单个图例高度" style="margin-bottom: 5px;">
                <el-input-number v-model="tlSymbolHeight" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="图例间隔" style="margin-bottom: 5px;">
                <el-input-number v-model="tlGapSize" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="图例内符号大小" style="margin-bottom: 5px;">
                <el-input-number v-model="tlSymbolSize" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="图例字体大小" style="margin-bottom: 5px;">
                <el-input-number v-model="tlFontSize" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="图例标题大小" style="margin-bottom: 5px;">
                <el-input-number v-model="tlTileSize" :min="0" size="mini"/>
              </el-form-item>
              <el-form-item label="是否展示图例" style="margin-bottom: 5px;">
                <el-switch v-model="tlShow"></el-switch>
                <span style="margin-left: 10px">{{ tlShow == true ? "展示" : "不展示" }}</span>
              </el-form-item>

              <el-form-item label="是否展示等值线" style="margin-bottom: 5px;">
                <el-switch v-model="linesShow"></el-switch>
                <span style="margin-left: 10px">{{ linesShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
              <el-form-item label="是否展示等值面" style="margin-bottom: 5px;">
                <el-switch v-model="surfaceShow" :disabled="colorCode.length>1?false:true"></el-switch>
                <span style="margin-left: 10px">{{ surfaceShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
              <el-form-item label="是否展示标签" style="margin-bottom: 5px;">
                <el-switch v-model="labelShow"></el-switch>
                <span style="margin-left: 10px">{{ labelShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
              <el-form-item label="是否展示差值柱" style="margin-bottom: 5px;">
                <el-switch v-model="czSymbolShow"></el-switch>
                <span style="margin-left: 10px">{{ czSymbolShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="等值线颜色" style="margin-bottom: 5px;">
                    <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="linesColor"></el-color-picker>
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="12">-->
                <!--                  <el-form-item label="断层颜色" style="margin-bottom: 5px;">-->
                <!--                    <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="faultColor"></el-color-picker>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="正差值颜色" style="margin-bottom: 5px;">
                    <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="czSymbolColorInc"></el-color-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="负差值颜色" style="margin-bottom: 5px;">
                    <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="czSymbolColorDec"></el-color-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="是否展示色标" style="margin-bottom: 5px;">
                <el-switch v-model="colorCodeShow" :disabled="colorCode.length>1?false:true"></el-switch>
                <span style="margin-left: 10px">{{ colorCodeShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
              <el-form-item label="色标颜色模板" style="margin-bottom: 5px;">
                <el-select v-model="colorCodeTemp" @change="selectcoloTemp" style="width: 40%;margin-right: 5%" size="small">
                  <el-option
                      v-for="item in colorTemplate"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                <el-button size="mini" type="primary" @click="setColorTemplate">设置</el-button>
              </el-form-item>

              <el-row>
                <el-col :span="12" v-if="false">
                  <el-form-item label="是否缩放" style="margin-bottom: 5px;">
                    <el-switch v-model="isSizeChange"></el-switch>
                    <span style="margin-left: 10px">{{ isSizeChange == true ? "是" : "否" }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="!isGis">
                  <el-form-item style="margin-bottom: 5px;">
                    <el-button size="mini" type="primary" @click="blockDel">删除边界</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-tabs>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="filesDialogVisible"
          title="导出"
          width="500px"
          @close="fileName=''"
      >
        <el-form>
          <el-form-item label="请输入文件名">
            <el-input v-model="fileName"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
              <el-button @click="filesDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="files">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="configDialogVisible"
          title="配置"
          width="750px"
      >
        <el-form>
          <el-row>
            <el-col :span="24">
              <el-form-item label="请输入名称">
                <el-input v-model="iosLiseName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="等值线粗细">
                <el-input-number v-model="linesWidth" :min="1" :max="10"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示标签">
                <el-switch v-model="labelShow"></el-switch>
                <span style="margin-left: 10px">{{ labelShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="色标值步长">
                <el-input-number v-model="colorCodeSpacing" :min="1"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="等值线颜色">
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="linesColor"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示井位">
                <el-switch v-model="pointShow"></el-switch>
                <span style="margin-left: 10px">{{ pointShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示色标">
                <el-switch v-model="colorCodeShow" :disabled="colorCode.length>1?false:true"></el-switch>
                <span style="margin-left: 10px">{{ colorCodeShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示断层">
                <el-switch v-model="faultShow"></el-switch>
                <span style="margin-left: 10px">{{ faultShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="色标颜色插值">
                <el-tag
                    v-for="(tag,index) in colorCode"
                    :key="tag"
                    :color="tag"
                    closable
                    class="a1"
                    @close="handleClose(tag)"
                >{{ index + 1 }}
                </el-tag>
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="colorAdd" @change="colorAddChange"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示等值面">
                <el-switch v-model="surfaceShow" :disabled="colorCode.length>1?false:true"></el-switch>
                <span style="margin-left: 10px">{{ surfaceShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否展示等值线">
                <el-switch v-model="linesShow"></el-switch>
                <span style="margin-left: 10px">{{ linesShow == true ? "需要" : "不需要" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="断层颜色">
                <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="faultColor"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否缩放">
                <el-switch
                    v-model="isSizeChange"
                ></el-switch>
                <span style="margin-left: 10px">{{ isSizeChange == true ? "是" : "否" }}</span>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="是否展示底图">
                <el-switch
                    v-model="imageShow"
                ></el-switch>
                <span style="margin-left: 10px">{{ imageShow == true ? "是" : "否" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-button size="mini" type="primary" @click="imageConfig">底图配置</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="加载区块边界">
                <el-switch
                    v-model="blockShow"
                ></el-switch>
                <span style="margin-left: 10px">{{ blockShow == true ? "是" : "否" }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <el-button size="mini" type="primary" @click="blockDel">删除区块</el-button>
              </el-form-item>
            </el-col>
            <!--<el-col :span="12">-->
            <!--<el-form-item label="缩放类型">-->
            <!--<el-switch-->
            <!--v-model="sizeChangeType"-->
            <!--:disabled="isSizeChange!=true"-->
            <!--&gt;</el-switch>-->
            <!--<span style="margin-left: 10px">{{ sizeChangeType == 0 ? "位图" : "矢量图" }}</span>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
              <el-button @click="configDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="configOk">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="pointDialogVisible"
          title="当前井信息"
          width="750px"
      >
        <el-scrollbar max-height="400px">
          <el-collapse accordion>
            <el-collapse-item :title="index+1" :name="index+1" v-for="(item,index) in pointNow" :key="item.id">
              <el-form>
                <el-row>
                  <el-col :offset="5" :span="14">
                    <el-form-item label="井名">
                      <el-input v-model="item.text" :readonly="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :offset="5" :span="6">
                    <el-form-item label="类型">
                      <el-input v-model="item.mqjb" :readonly="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :offset="2" :span="6">
                    <el-form-item label="颜色">
                      <el-color-picker show-alpha size="small" :predefine="predefineColors" v-model="item.color" @change="pointColor"/>
                    </el-form-item>
                  </el-col>
                  <el-col :offset="5" :span="6">
                    <el-form-item label="X值">
                      <el-input type="number" v-model="item.x" :readonly="true"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :offset="2" :span="6">
                    <el-form-item label="Y值">
                      <el-input type="number" v-model="item.y" :readonly="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-scrollbar>
        <template #footer>
          <span class="dialog-footer">
              <el-button @click="pointNowClick">取消</el-button>
              <el-button type="primary" @click="pointNowClick">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="configWgDialogVisible"
          title="成图参数设置"
          width="750px"
      >
        <el-form>
          <el-row v-if="configWgNum" style="margin-bottom: 15px">
            <el-col :span="22" :offset="2">
              <el-radio-group v-model="generateType" class="ml-4">
                <!--                <el-radio :label=1 size="medium">在线系统数据</el-radio>-->
                <el-radio :label=2 size="medium">个人本地数据</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row v-if="configWgNum">
            <el-col v-if="generateType==1" :span="8">
              <el-form-item label="数据源">
                <el-select v-model="dataSource" filterable placeholder="请选择" @change="dataSourceChange">
                  <el-option
                      v-for="item in dataSourceOptions"
                      :key="item.DATSRC_ID"
                      :label="item.DATSRC_NAME"
                      :value="item.DATSRC_ID"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="generateType==1" :span="6">
              <el-form-item label="数据字段">
                <el-select v-model="dataSourceHeader" placeholder="请选择">
                  <el-option
                      v-for="item in dataSourceHeaderOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.COLUMN_NAME"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="generateType==1" :span="6">
              <el-form-item label="井名字段">
                <el-select v-model="dataSourceJHHeader" placeholder="请选择">
                  <el-option
                      v-for="item in dataSourceHeaderOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.COLUMN_NAME"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="generateType==1" :span="4">
              <el-form-item>
                <el-button size="mini" type="primary" @click="dataSourceQuery">数据筛选</el-button>
              </el-form-item>
            </el-col>

            <el-col v-if="generateType==1" :span="12" style="text-align: center">
              <el-form-item>
                <el-checkbox v-model="borderValue" label="边界数据" size="large"/>
              </el-form-item>
            </el-col>
            <el-col v-if="generateType==1" :span="12" style="text-align: center">
              <el-form-item>
                <el-checkbox v-model="faultValue" label="断层数据" size="large"/>
              </el-form-item>
            </el-col>
            <!--            <el-col :span="8" v-if="faultValue">-->
            <!--              <el-form-item label="断层影响">-->
            <!--                <el-input type="number" v-model="faultRange"></el-input>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="插值算法">
                <el-select v-model="isoModel" placeholder="请选择">
                  <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="数据可信度">
                <el-input type="number" v-model="valueReliability" :min="0"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="8">
              <el-form-item label="最 大 值">
                <el-input type="number" v-model="gridMax" :min="0" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="最 小 值">
                <el-input type="number" v-model="gradMin" :min="0" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="等值间隔">
                <el-input type="number" v-model="gradInterval" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="网格步长">
                <el-input type="number" v-model="gridSpacing" :min="0"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="加密次数">
                <el-input type="number" v-model="encryptionNum" :min="0"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="平滑次数">
                <el-input type="number" v-model="smoothNum" :min="0"></el-input>
              </el-form-item>
            </el-col>
            <!--                    <el-col :span="8">-->
            <!--                        <el-form-item label="标注字体">-->
            <!--                            <el-select v-model="taggingFont"  placeholder="请选择">-->
            <!--                                <el-option-->
            <!--                                        v-for="item in fontOptions"-->
            <!--                                        :key="item.value"-->
            <!--                                        :label="item.label"-->
            <!--                                        :value="item.value"-->
            <!--                                />-->
            <!--                            </el-select>-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <!--                    <el-col :span="8">-->
            <!--                        <el-form-item label="开始位置">-->
            <!--                            <el-input type="number" v-model="start" :min="0"></el-input>-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <!--                    <el-col :span="8">-->
            <!--                        <el-form-item label="色标模板">-->
            <!--                            <el-select v-model="colorCodeModel"  placeholder="请选择">-->
            <!--                                <el-option-->
            <!--                                        v-for="item in colorCodeOptions"-->
            <!--                                        :key="item.value"-->
            <!--                                        :label="item.label"-->
            <!--                                        :value="item.value"-->
            <!--                                />-->
            <!--                            </el-select>-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <!--                    <el-col :span="8">-->
            <!--                        <el-form-item label="标注间隔">-->
            <!--                            <el-input type="number" v-model="taggingSpacing" :min="0" @input="wgInput"></el-input>-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <!--                    <el-col :span="8">-->
            <!--                        <el-form-item label="小数位置">-->
            <!--                            <el-input type="number" v-model="decimalPosition" :min="0" @input="wgInput"></el-input>-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <el-col :span="11">
              <el-form-item label="简化系数">
                <el-slider v-model="thinningNum" :step="1" :max="10" :min="0"/>
              </el-form-item>
            </el-col>
            <!--                    <el-col :offset="2" :span="11">-->
            <!--                        <el-form-item label="等值线图层">-->
            <!--                            <el-input v-model="iosLiseName"></el-input>-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
<!--              <el-button v-if="configWgNum" @click.stop="configWgNum=!configWgNum">下一步</el-button>-->
              <el-button v-if="configWgNum" @click="ShowISOStepPage">下一步</el-button>
              <el-button v-else @click.stop="configWgNum=!configWgNum">上一步</el-button>
              <el-button @click="configWgDialogVisible = false">取消</el-button>
              <el-button type="primary" v-if="!configWgNum" @click="generateISO">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="refreshDialogVisible"
          title="数据筛选"
          width="680px"
      >
        <el-scrollbar max-height="300px">
          <queryConfig :theHeader="theHeader" ref="queryConfig" v-on:numChange="numChange"></queryConfig>
        </el-scrollbar>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="refreshDialogVisible = false">取消</el-button>
            <el-button @click="refreshReset">置空</el-button>
            <el-button type="primary" @click="refreshOk">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <div v-dialogDrag>
      <el-dialog
          v-model="imageDialogVisible"
          title="底图配置"
          width="680px"
      >
        <el-form>
          <el-row>
            <el-col :span="13">
              <el-form-item label="底&nbsp;&nbsp;&nbsp;图">
                <input type="file" size="mini" multiple @change="imageUpload" accept="image/*"/>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-image
                  style="width:50px;height:50px"
                  :src="imageSrc2"
                  :preview-src-list="imageList"
                  :initial-index="0"
                  fit="cover"
              >
                <template #error>
                  <div class="image-slot">
                    图片未添加
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </template>
              </el-image>
            </el-col>
            <el-col :span="12">
              <el-form-item label="上边界">
                <el-input type="number" v-model="imageTop"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="下边界">
                <el-input type="number" v-model="imageBottom"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="左边界">
                <el-input type="number" v-model="imageLeft"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="右边界">
                <el-input type="number" v-model="imageRight"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-alert title="*底图右边界必须大于左边边界,上边界必须大于下边界" type="error" :closable="false"/>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="imageDialogVisible = false">取消</el-button>
            <el-button @click="uploadOk">提交至服务器</el-button>
            <el-button @click="imageDel">删除服务器底图</el-button>
            <el-button type="primary" @click="imageConfigOk">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>

    <!--  选择数据源弹窗  -->
    <div v-dialogDrag>
      <el-dialog
          v-model="isLayerDataSrc"
          title="选择数据源"
          width="680px">
        <el-form>
          <el-row>
            <el-col :span="8">
              <el-form-item label="数据源">
                <el-select v-model="dataSource" filterable placeholder="请选择" @change="dataSourceChange">
                  <el-option
                      v-for="item in dataSourceOptions"
                      :key="item.DATSRC_ID"
                      :label="item.DATSRC_NAME"
                      :value="item.DATSRC_ID"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数据字段">
                <el-select v-model="dataSourceHeader" placeholder="请选择">
                  <el-option
                      v-for="item in dataSourceHeaderOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.COLUMN_NAME"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="井名字段">
                <el-select v-model="dataSourceJHHeader" placeholder="请选择">
                  <el-option
                      v-for="item in dataSourceHeaderOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.COLUMN_NAME"

                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <el-button size="mini" type="primary" @click="dataSourceQuery">数据筛选</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="isLayerDataSrc = false">取消</el-button>
            <el-button type="primary">确定</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <!--数据导入弹窗-->
    <div v-dialogDrag>
      <el-dialog
          v-model="importDialogVisible"
          title="数据导入"
          width="680px"
          :close-on-click-modal="false"
      >
        <el-table
            :data="theHeaderFiles"
            width="100%"
            max-height="600px"

        >
          <el-table-column prop="label" label="目标字段" align="center" header-align="center">
            <template #default="scope">
              <span>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="Select" size="large">
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="to" label="上传字段" align="center" header-align="center">
            <template #default="scope">
              <el-select v-model="scope.row[scope.column.property]" placeholder="请选择" size="large"
                         @change="dataChange">
                <el-option
                    v-for="item in xlsHeader"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="importDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="dataModify">预览</el-button>
            <el-button type="primary" @click="modifyOk">确认</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!-- 数据预览弹窗-->
    <div v-dialogDrag>
      <el-dialog
          v-model="modifyDialogVisible"
          title="数据预览"
          fullscreen
          :close-on-click-modal="false">
        <el-table
            :data="xlsData"
            stripe
            height="800"
            style="width: 100%"
        >
          <el-table-column
              v-for="item in theHeaderFiles"
              :prop="item.to"
              :key="item.to"
              :label="item.label"
              align="center"
              header-align="center">
            <template #default="scope">
              <span>{{ scope.row[scope.column.property] }}</span>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="modifyDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="modifyOk">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!-- 数据查看弹窗-->
    <div v-dialogDrag>
      <el-dialog
          v-model="overViewDialogVisible"
          title="数据查看"
          width="1000px"
          :close-on-click-modal="false">
        <el-tabs type="border-card">
          <template v-for="item in layer_tableData">
            <el-tab-pane
                v-if="item.header.length!=0"
                :key="item.type"
                :label="item.type">
              <el-table
                  :data="item.data"
                  border stripe
                  max-height="500"
                  @cell-dblclick="editData"
              >
                <el-table-column label="序号" align="center">
                  <template #default="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                    v-for="ite in item.header"
                    :prop="ite.value"
                    :key="ite.label"
                    :label="ite.label"
                    align="center"
                    header-align="center">
                  <template #default="scope">
                    <el-input v-if="scope.row[scope.column.property + 'isShow']"
                              :ref="scope.column.property"
                              v-model="scope.row[scope.column.property]"
                              @click="console.log('abcdef',scope.row,scope.column)"
                              @blur="alterData(scope.row,scope.column)"></el-input>
                    <span v-else-if="scope.column.property=='y'">
                    {{ scope.row[scope.column.property] * -1 }}
                  </span>
                    <span v-else>
                    {{ scope.row[scope.column.property] }}
                  </span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </template>
        </el-tabs>
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="overViewDialogVisible = false">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
    <!-- 色标模板设置弹窗-->
    <div v-dialogDrag>
      <el-dialog
          v-model="colorSetDialogVisible"
          title="色标模板设置"
          width="680px"
          :close-on-click-modal="false">
        <div>
          <span>模板</span>
          <span class="icon">
            <el-button icon="el-icon-plus" type="text" size="mini" @click.stop="addColorTemplate()"></el-button>
            <el-button icon="el-icon-minus" type="text" size="mini" @click.stop="deleteColorTemplate()"></el-button>
          </span>
        </div>
        <div style="height: 300px">
          <el-tabs v-model="colorTemplateValue" :tab-position="'left'" class="demo-tabs">
            <el-tab-pane
                v-for="itme in colorTemplate"
                :label="itme.label"
                :name="itme.value"
                :key="itme.value">
              <template #default>
                <el-row>
                  <el-button type="primary" size="mini"  @click="addColor">添加</el-button>
                  <el-button type="primary" size="mini"  @click="deleteColor">删除</el-button>
                </el-row>
                <el-row>
                  <el-table
                      v-if="itme.type===undefined?true:itme.type===1"
                      :data="itme.data"
                      border stripe
                      max-height="250px" row-style="height:30px" cell-style="height:30px">
                    <el-table-column label="序号" key="number" prop="number" align="center">
                      <template #default="scope">
                        <span>{{ scope.row[scope.column.property] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="颜色" key="color" prop="color" align="center">
                      <template #default="scope">
                        <el-color-picker show-alpha size="small" :predefine="predefineColors"
                                         v-model="scope.row[scope.column.property]"></el-color-picker>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table
                      v-else
                      :data="itme.data"
                      border stripe
                      max-height="250px" row-style="height:30px" cell-style="height:30px">
                    <el-table-column label="序号" key="number" prop="number" align="center">
                      <template #default="scope">
                        <span>{{ scope.row[scope.column.property] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="名称" key="label" prop="label" align="center">
                      <template #default="{row, column, $index }">
                        <el-input size="mini"  v-model="itme.data[$index].label" placeholder="请输入名称"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="起始值(>)" key="beginNumber" prop="beginNumber" align="center">
                      <template #default="{row, column, $index }">
                        <el-input size="mini"  v-model="itme.data[$index].beginNumber" placeholder="起始值（第一个可为空)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="结束值(<=)" key="endNumber" prop="endNumber" align="center">
                      <template #default="{row, column, $index }">
                        <el-input size="mini"  v-model="itme.data[$index].endNumber" placeholder="结束值(最后一个可为空)"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="颜色" key="color" prop="color" align="center">
                      <template #default="scope">
                        <el-color-picker show-alpha size="small" :predefine="predefineColors"
                                         v-model="scope.row[scope.column.property]"></el-color-picker>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="colorSetDialogVisible = false;colorTemplate=colorTemplateCopy">取消</el-button>
            <el-button @click="resetColorTemp">重置</el-button>
            <el-button type="primary" @click="colorSetDialogVisible = false;selectcoloTemp()">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>

    <ul v-show="visible" ref="contextMenu" :style="{left:menuLeft+'px',top:menuTop+'px'}" class="contextMenu">
      <li @mouseover="openMenuSon(index)" v-for="(item,index) in navigationData" :key="item" :index="index">
        <span>{{item.name}}</span>
        <i style="float: right" v-if="item.children!=undefined" class="el-icon-arrow-right"></i>
      </li>
    </ul>
    <ul v-show="MenuSonVisible&&menuSon.length!=0" :style="{left:menuLeft+145+'px',top:menuTop+menuSonNum*30+'px'}" class="contextMenu">
      <li v-for="(item,index) in menuSon" :index="index" :key="item" @click.stop="routeJump(index)">{{item.name}}</li>
    </ul>
  </div>
</template>
<script>
import XLSX from "xlsx";

let elementResizeDetectorMaker = require("element-resize-detector")
import queryConfig from "@/components/queryConfig.vue";
import {ElMessage,ElMessageBox} from 'element-plus'
import axios from 'axios'
import * as changedpi from 'changedpi'
export default {
  name: "ios-lise",
  components:{
    queryConfig
  },
  props:{
    mapData:{
      default:{
        mapName:"",
        baseMap:{},
        isoRegions:[],
        isoLines:[],
        faults:[],
        points:[],
        blkBoundary:[],
        boundary:{
          left:0,
          right:0,
          top:0,
          bottom:0
        },
        height:0,
        imageShow:false
      }
    },
    isGis:{
      default:false
    }
  },
  data(){
    return {
      isMoveMode:true,//GIS的移动模式
      moveBeginAnchor:{
        offsetX:0,
        offsetY:0,
        scrollX:0,
        scrollY:0
      },//canvas鼠标移动模式鼠标点击坐标
      generateType:2,//成图类型 在线  个人
      isPointJump:true,//井联动开关
      configWgNum:true,//网格设置是否是第一页
      dataSource:"",//等值线数据源
      dataSourceHeader:"",//等值线数据源值字段
      dataSourceJHHeader:"",//等值线数据源井名字段
      borderValue:true,//边界数据
      faultValue:true,//断层数据
      faultRange:1,//断层影响范围
      isoModel:1,//插值算法
      gridSpacing:300,//网格步长
      gridSpacingAuto:false,//自动计算网格步长
      encryptionNum:1,//加密次数
      smoothNum:1,//平滑次数
      valueReliability:10,//数据可信度
      gridMax:0,//网格最大值
      gradMin:0,//网格最小值
      gradInterval:200,//等值间隔
      taggingFont:"宋体",//标注字体
      start:0,//开始位置
      colorCodeModel:1,//色标模板
      taggingSpacing:0,//标注间隔
      decimalPosition:0,//小数位置
      thinningNum:0,//简化系数
      needShowProblemMenu:true,//是否需要右键菜单
      dataSourceOptions:[],//数据源列表
      dataSourceHeaderOptions:[],//选中数据源列
      theHeader:[],//筛选列表
      queryFilter:[],//查询条件
      blockPoint:[],//自定义绘制的区块点
      colorCodeOptions:[
        {
          value: 1,
          label: "彩虹模板1"
        }, {
          value: 2,
          label: "彩虹模板2"
        }, {
          value: 3,
          label: "彩虹模板3"
        }, {
          value: 4,
          label: "彩虹模板4"
        }],
      fontOptions:[
        {
          value: "宋体",
          label: "宋体"
        }, {
          value: "微软雅黑",
          label: "微软雅黑"
        }, {
          value: "黑体",
          label: "黑体"
        }, {
          value: "楷体",
          label: "楷体"
        }, {
          value: "隶书",
          label: "隶书"
        }],
      options:[
        {
          value: 1,
          label: "GSM-最小曲率"
        }, {
          value: 2,
          label: "反距离加权"
        }, {
          value: 3,
          label: "普通径向基函数"
        }, {
          value: 4,
          label: "倒数径向基函数"
        }, {
          value: 5,
          label: "Log径向基函数"
        }],
      iosLiseHeight:Number,
      isEnlarge:false,//拉框放大
      isBlock:false,//绘制区块
      vectorNum:0,//缩放次数
      //imageTop:-4592577.149962,//底图边界
      //imageBottom:-4596610.500185,//底图边界
      //imageLeft:14674808.883895,//底图边界
      //imageRight:14679969.60941,//底图边界
      imageTop:0,//底图边界
      imageBottom:0,//底图边界
      imageLeft:0,//底图边界
      imageRight:0,//底图边界
      ssTop:0,//右滚动条的偏移量
      ssLeft:0,//右滚动条的偏移量
      ssHeight:100,//canvas距离上边的最大距离
      ssWidth:100,//canvas距离左边的最大距离
      ssBottom:0,//屏幕的最大显示高度
      difference:0,//屏幕与数据的高度差
      sliderHeight:"500px",//缩放高度
      big:1,//矢量放大系数
      left:0,//canvas图层定位
      // dataLeft:65.6147,//数据偏移量
      // dataRight:993.822,//数据偏移量
      // dataTop:624.19,//数据偏移量
      //dataTop:1220,//数据偏移量
      // dataBottom:127.155,//数据偏移量
      canvasHeight:0,//canvas高度
      canvasWidth:0,//canvas宽度
      canvasWidthNum:1,//宽度缩放比例
      canvasHeightNum:1,//高度缩放比例
      vectorMoveX:0,//矢量x进度条
      vectorMoveY:100,//矢量y进度条
      vectorMoveXX:0,//矢量拖拽偏移量
      vectorMoveYY:0,//矢量拖拽偏移量
      vectorMoveXXScale:0,//矢量拖拽偏移量占比
      vectorMoveYYScale:0,//矢量拖拽偏移量占比
      canvasMoveX:0,//原始数据转换偏移量
      canvasMoveY:0,//原始数据转换偏移量
      url:"",//缩放切图
      imageSrc:"",
      imageSrc2:"",
      imageType:"",
      imageList:[],//图片预览
      canvasShow:false,//缩放切图图层
      iosLiseClickState:false,//canvas鼠标点击状态
      iosLiseClick:{
        offsetX:0,
        offsetY:0
      },//canvas鼠标点击状态
      isBlockCheck:false,//是否选中区块
      pointIsCheck:false,//井点是否被选中
      JumpType:1,//区块或井选中跳转 1是井 0是区块
      visible: false,//右键菜单
      MenuSonVisible:false,////右键子菜单
      menuTop:0,//右键菜单位置
      menuLeft:0,//右键菜单位置
      menuBottom:0,//右键菜单位置
      navigationData:[],//右键菜单内容
      menuSon:[],//右键菜单子内容
      menuSonNum:0,//右键菜单子序号
      configWgDialogVisible:false,//网格参数弹窗
      pointDialogVisible:false,//井选择弹窗
      filesDialogVisible:false,//导出弹窗
      configDialogVisible:false,//配置弹窗
      refreshDialogVisible:false,//数据筛选
      imageDialogVisible:false,//底图配置
      //colorAdd:true,//色标添加临时值
      fileName:"",//导出文件名
      iosLiseName:"等值线图",
      Participants:{
        edit:"",
        make:"",
        examine:""
      },
      selectType:1,//多选类型
      selectWidth:0,//框选宽度
      selectHeight:0,//框选高度
      scale:1,//缩放倍率
      linesColor:"#000000",//等值线颜色
      linesWidth:1,//等值线粗细
      faultLineWidth:1,//断层线粗细
      sizeChangeType:1,//缩放类型
      czSymbolWidth:15,//差值柱宽度
      czSymbolHeight:30,//差值柱最大高度
      czSymbolShow:false,//是否显示差值柱
      czSymbolColorInc:"#f00",//差值柱正值颜色
      czSymbolColorDec:"#00F",//差值柱负值颜色
      czSymbolMaxNeed:false,//差值最大值是否需要限制
      czSymbolMinNeed:false,//差值最小值是否需要限制
      czSymbolMaxVal:0,//差值显示最大值
      czSymbolMinVal:0,//差值显示最小值
      icCzNeedNewSize:false,//差值柱采用czSymbolWidth和czSymbolHeight的值

      tlSymbolWidth:0,//图例宽
      tlSymbolHeight:0,//图例高
      tlSymbolSize:0,//图例内符号大小
      tlFontSize:0,//图例字体大小
      tlTileSize:0,//图例标题大小
      tlColCnt:2,//图例每行符号个数
      tlGapSize:0,//图例符号间隔
      tlShow:true,//图例是否显示

      pointSize:30,//井位大小
      isGisNeedNewPointSizeNow:false,//GIS采用pointSize值
      isSizeChange:true,//是否缩放
      imageShow:true,//是否展示底图
      linesShow:true,//是否展示线
      pointShow:true,//是否展示点
      faultShow:true,//是否展示断层
      surfaceShow:true,//是否展示面
      signTextShow:true,//文字标注
      blockShow:true,//是否展示区块
      labelShow:false,//等值线标签
      colorCodeShow:false,//色标
      colorCodeSpacing:5,//色标步长
      colorCode:["#FFD700","#FFFF00","#5f5"],//色标颜色
      colorAdd:"#5f5",//色标颜色添加值
      colorCodeMax:0,//色标最大值
      colorCodeMin:0,//色标最小值
      faultColor:"#FFFFFF",//断层颜色
      pointNow:[],//选中的当前井
      temporaryPoint:{},//临时选中的井
      beginX:0,//缩放开始位置
      beginY:0,//缩放开始位置
      endX:600,//缩放后宽度
      endY:400,//缩放后高度
      colorCodeSpace:0,
      onResize:0,
      linesTest:[],
      isoRegionColor:{},//等值面颜色
      flag: true,//防抖初次点击触发一次
      timer: null,//防抖时间
      currentTime: 0, //节流中间时间
      dataLeft:0,//数据偏移量
      dataRight:0,//数据偏移量
      dataTop:0,//数据偏移量
      dataBottom:0,//数据偏移量
      blkBoundary:[],//区块
      isoRegion:[],//等值面
      linesData:[],//等值面
      fault:[],//等值面
      points:[],//等值面f
      curFileName:"",
      queryConfigNum:{
        num1:1,
        num2:1
      },//条件查询的唯一标识

      layerShow:false,//图层菜单显示标识
      layer_activeNames: ["1"],//默认展开id 图层
      scatterDataMaxValue:0,//散点最大值
      scatterDataMinValue:0,//散点最小值
      jbMap:{},//井别颜色字典-图例需要
      jbAry:[],//井别列表-图例需要
      layer_tableData:[
        {
          type: "井位",
          name: "points",
          show: false,
          dataType: "localFile",
          header:[
            {
              label:"颜色",
              value:"color",
              type:"string",
            },{
              label:"x轴",
              value: "x",
              type:"number",
            },{
              label:"y轴",
              value: "y",
              type:"number",
            },{
              label:"井名",
              value: "text",
              type:"string",
            },{
              label:"类型",
              value: "type",
              type:"string",
            }
          ],
          data:[],
          fileName:""
        },
        {
          type: "断层",
          name: "faults",
          show: false,
          dataType: "localFile",
          header: [
            {
              label: "名称",
              value: "name",
              type: "string",
            }, {
              label: "类型",
              value: "type",
              type: "string",
            },{
              label: "x轴",
              value: "x",
              type: "number",
            }, {
              label: "y轴",
              value: "y",
              type: "number",
            }
          ],
          data:[],
          fileName:""
        },
        {
          type: "边界",
          name: "blkBoundary",
          show: false,
          dataType: "localFile",
          header:[
            {
              label:"序号",
              value:"xh",
              type:"number",
            },{
              label:"x轴",
              value:"x",
              type:"number",
            },{
              label:"y轴",
              value:"y",
              type:"number",
            }
          ],
          data:[],
          fileName:""
        },
        {
          type: "数据",
          name: "数据",
          show: false,
          dataType: "localFile",
          header:[
            {
              label:"x坐标",
              value: "x",
              type:"number",
            },{
              label:"y坐标",
              value: "y",
              type:"number",
            },{
              label:"值",
              value: "value",
              type:"number",
            }
          ],
          data:[],
          fileName:""
        },
        {
          type: "底图",
          name: "底图",
          show: false,
          dataType: "",
          header: [],
          data: [],
          fileName:""
        },
        {
          type: "标题",
          name: "标题",
          show: true,
          dataType: "",
          header: [],
          data: []
        }
      ],//图层管理数据
      layer_selectList:[
        {
          label:"数据源",
          value:"dataSrc",
        },
        {
          label:"本地文件",
          value:"localFile",
        },
        {
          label:"系统默认",
          value:"systemDefault",
        },
      ],//图层管理的数据列表
      isIosLiseName:true,//标题显示控制
      isLayerDataSrc:false,//控制选择数据源弹窗
      layerIndex:0,//记录点击图层设置位置
      myFiles:"",//记录上传excel文件内容
      theHeaderFiles:[],//对应图层表头
      xlsData:[],//上传excel文件数据
      xlsHeader:[],//上传excel文件表头
      importDialogVisible:false,//数据导入弹窗标识
      modifyDialogVisible:false,//数据预览弹窗标识
      typeOptions: [
        {
          label: "字符串",
          value: "string"
        }, {
          label: "日期",
          value: "date"
        }, {
          label: "数值",
          value: "number"
        }],//数据导入类型列表
      overViewDialogVisible:false,//查看数据弹窗标识
      colorCodeTemp:1,//记录当前选择的色标模板
      colorDefaultTemplate:[
        {
          value: 1,
          label: "黄绿色板模板",
          type: 1,//类型 1色板  2起止值
          data:[
            {
              number:"1",
              color:"#FFD700"
            },
            {
              number:"2",
              color:"#FFFF00"
            },
            {
              number:"3",
              color:"#5f5"
            },
          ]
        }, {
          value: 2,
          label: "红蓝色板模板",
          type: 1,//类型 1色板  2起止值
          data:[
            {
              number:"5",
              color:"#0000FF"
            },
            {
              number:"4",
              color:"#00FFFF"
            },
            {
              number:"3",
              color:"#00FF00"
            },
            {
              number:"2",
              color:"#FFFF00"
            },
            {
              number:"1",
              color:"#FF0000"
            },
          ]
        }, {
          value: 3,
          label: "压力区间模板",
          type: 2,//类型 1色板  2起止值
          data:[
            {
              number:"1",
              label:"1",
              beginNumber:"",
              endNumber:"60",
              color:"rgb(255,255,0)"
            },
            {
              number:"2",
              label:"2",
              beginNumber:"60",
              endNumber:"80",
              color:"rgb(255,215,0)"
            },
            {
              number:"3",
              label:"3",
              beginNumber:"80",
              endNumber:"100",
              color:"rgb(255,192,203)"
            },
            {
              number:"4",
              label:"4",
              beginNumber:"100",
              endNumber:"120",
              color:"rgb(242,20,249)"
            },
            {
              number:"5",
              label:"5",
              beginNumber:"120",
              endNumber:"",
              color:"rgb(255,0,0)"
            },
          ]
        }
      ],//色标模板
      colorTemplate:[
        {
          value: 1,
          label: "黄绿色板模板",
          type: 1,//类型 1色板  2起止值
          data:[
            {
              number:"1",
              color:"#FFD700"
            },
            {
              number:"2",
              color:"#FFFF00"
            },
            {
              number:"3",
              color:"#5f5"
            },
          ]
        }, {
          value: 2,
          label: "红蓝色板模板",
          type: 1,//类型 1色板  2起止值
          data:[
            {
              number:"5",
              color:"#0000FF"
            },
            {
              number:"4",
              color:"#00FFFF"
            },
            {
              number:"3",
              color:"#00FF00"
            },
            {
              number:"2",
              color:"#FFFF00"
            },
            {
              number:"1",
              color:"#FF0000"
            },
          ]
        }, {
          value: 3,
          label: "压力区间模板",
          type: 2,//类型 1色板  2起止值
          data:[
            {
              number:"1",
              label:"1",
              beginNumber:"",
              endNumber:"60",
              color:"rgb(255,255,0)"
            },
            {
              number:"2",
              label:"2",
              beginNumber:"60",
              endNumber:"80",
              color:"rgb(255,215,0)"
            },
            {
              number:"3",
              label:"3",
              beginNumber:"80",
              endNumber:"100",
              color:"rgb(255,192,203)"
            },
            {
              number:"4",
              label:"4",
              beginNumber:"100",
              endNumber:"120",
              color:"rgb(242,20,249)"
            },
            {
              number:"5",
              label:"5",
              beginNumber:"120",
              endNumber:"",
              color:"rgb(255,0,0)"
            },
          ]
        }
      ],//色标模板
      colorTemplateCopy:null,//色标模板备份
      colorSetDialogVisible:false,//色标模板配置弹窗标识
      colorTemplateValue:1,//记录选中色标模板——色标模板设置界面
      predefineColors : ["#ffffff","#000000","#e7e6e6","#44546a","#5b9bd5","#ed7d31","#a5a5a5","#ffc000",
        "#4472c4","#70ad47","#7f7f7f","#0c0c0c","#171616","#222a35","#1e4e79","#833c0b","#525252",
        "#7f6000","#1f3864","#375623","#c00000","#ff0000","#ffc000","#ffff00","#92d050","#00b050",
        "#00b0f0","#0070c0","#002060","#7030a0"],//颜色板常用颜色设置
    }
  },
  mounted(){
    //初始化赋值
    this.layer_tableData[0].show=this.pointShow;//井位
    this.layer_tableData[1].show=this.faultShow;//断层
    this.layer_tableData[2].show=this.blockShow;//边界
    this.layer_tableData[4].show=this.imageShow;//底图
    this.layer_tableData[5].show=this.isIosLiseName;//名称

    this.fetchNavigateData()
    let _this = this;
    window.addEventListener("message", function(event){
      if(event.data.type === "generateIos")
      {
        console.log("listener:",event.data);
        let data ={
          clientID:event.data.clientID,
          clientSecret:event.data.clientSecret,//用户token令牌
          jwt:event.data.jwt,//区块类型银行  1期
          dspStep:event.data.dspStep,//300,//网格步长
          sbRefineTimes:event.data.sbRefineTimes,//1,//加密次数
          dsbFaultAffectRange:1,//断层影响范围
          sbSmoothTimes:event.data.sbSmoothTimes,//3,//平滑次数
          spDataRelable:event.data.spDataRelable,//10,//数据可信度
          sldSmooth:event.data.sldSmooth,//1,//简化系数
          dsbIntv:event.data.dsbIntv,//200,//等值线间隔
          isNeedBorder:event.data.isNeedBorder,//true,//是否依赖边界，无边界则自动计算矩形边界
          isNeedFaul:false,//是否依赖断层
          cbInterMethod:1,//插值算法
          wellData:event.data.wellData,
          gridBody:event.data.iosdata//1//插值算法
        }
        _this.$store.state.origin = event.data.origin
        _this.clearCanvas();
        _this.clearPoint();
        _this.clearBlock();
        _this.$emit('generateLocalISO',data);

      }
    })

    window.parent.postMessage({
      'type': 'IOSLoaded',    // 自定义事件名
      'value':JSON.stringify(true) // 数据，只能是字符串
    }, '*');
  },
  methods:{
    zoomIn(){
      if(this.big>=100)
      {
        ElMessage('已放至最大比例');
      }
      else
      {
        this.big+=1;
      }
    },
    zoomOut(){
      console.log(this.big)
      this.big==2?this.vectorBack():this.big-=1;
    },
    stopProp: function (e) {e.stopPropagation()},
    initMap(){
      this.$nextTick(()=>{
        var erd = elementResizeDetectorMaker();//监听屏幕大小尺寸变化
        erd.listenTo(document.getElementById("row"),this.resizeFunc);
        this.containerChange();
        this.isoRegionColorAdd();
        this.$nextTick(()=>{
          this.draw();
          let that=this;
          let run=function(){
            that.configOk(1);
          }
          setTimeout(run,100)
          // this.$nextTick(()=>{
          //   this.draw();
          // },100)
        },100)
        //this.configDialogVisible=true;
      })
    },
    //获取数据
    getData(){
      console.log("触发了getData")
      console.log(this.mapData)
      if(JSON.stringify(this.mapData.baseMap)!= '{}'){
        this.imageSrc2 = this.mapData.baseMap.src;
        this.imageList[0] = this.mapData.baseMap.src;
        this.imageTop = this.mapData.baseMap.top;
        this.imageBottom = this.mapData.baseMap.bottom;
        this.imageLeft = this.mapData.baseMap.left;
        this.imageRight = this.mapData.baseMap.right;
      }else{
        this.imageTop = this.mapData.boundary.bottom * -1;
        this.imageTop -= this.mapData.boundary.y;
        this.imageBottom = this.mapData.boundary.top * -1;
        this.imageBottom += this.mapData.boundary.y;
        this.imageLeft = this.mapData.boundary.left;
        this.imageLeft += this.mapData.boundary.x;
        this.imageRight = this.mapData.boundary.right;
        this.imageRight -= this.mapData.boundary.x;
        this.imageSrc2="";
        this.imageList = [];
      }
      this.dataLeft = this.mapData.boundary.left;
      this.dataRight = this.mapData.boundary.right;
      this.dataTop = this.mapData.boundary.top;
      this.dataBottom = this.mapData.boundary.bottom;
      // this.blkBoundary = this.mapData.blkBoundary;
      this.isoRegion = this.mapData.isoRegions;
      this.linesData = this.mapData.isoLines;
      this.fault = this.mapData.faults;
      this.points = this.mapData.points;
      this.iosLiseName = this.mapData.mapName;

      //this.imageShow = this.mapData.imageShow;
      //this.imageShow = true;
      this.iosLiseHeight = 800;
      console.log("mapData:",this.mapData);
      this.initMap();
      console.log("--------",this.$refs.isoBig)
      this.$nextTick(()=>{
        this.big+=1;
        this.big-=1;
        // this.$nextTick(()=>{
        //   this.$refs.isoBig.$el.click();
        //   this.$refs.isoSmall.$el.click();
        //   console.log("触发了放大缩小")
        // })
      })
      this.getDataSource();
    },
    //获取数据列表
    getDataSource(){
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasource",
        method: 'GET',
      }).then(res => {
        console.log("data在这里",res)
        //this.dataSourceOptions = res.data.datas;
        for(let i in res.data.datas){
          if(res.data.datas[i].HEAD.length!=0){
            if(res.data.datas[i].DATSRC_NAME!=null && res.data.datas[i].DATSRC_NAME.indexOf("一期")<0)
              this.dataSourceOptions.push(res.data.datas[i])
          }
        }
        //DATSRC_NAME
      })
    },
    dataSourceChange(val){
      console.log(val)
      for(let i in this.dataSourceOptions){
        if(this.dataSourceOptions[i].DATSRC_ID==val){
          console.log(this.dataSourceOptions[i])
          this.dataSourceHeaderOptions =  this.dataSourceOptions[i].HEAD
          this.dataSourceHeader="";
          this.dataSourceJHHeader = "";
          this.theHeader=this.dataSourceOptions[i].HEAD;
          console.log("curDatSrcHead",this.dataSourceHeaderOptions)
          for(let j in this.dataSourceHeaderOptions){
            if(this.dataSourceHeaderOptions[j].COLUMN_NAME.toUpperCase() == "WELL_LEGAL_NAME"){
              this.dataSourceJHHeader = this.dataSourceHeaderOptions[j].COLUMN_NAME;
            }
          }
          // COLUMN_NAME: "DSID"
          // COMMENTS: "DSID"
          // TABLE_COMMENTS: "钻井取心筒次数据"
          // TABLE_NAME: "X_ML_ACH_CORE"
          // data: "DSID"
          // edit: false
          // id: "0"
          // label: "DSID"
          // type: "text"
        }
      }
    },
    //获取右键列表
    fetchNavigateData() {
      let that = this;
      //"511029F7F507403FAB16414EEE68653D"
      let strpid = '511029F7F507403FAB16414EEE68653D';
      let strmode = 'rootidmode';
      let strnavigateUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/navigateData";
      if (strpid.length > 0 && strmode.length > 0)
        strnavigateUrl += "?pid=" + strpid + "&mode=" + strmode;
      axios({
        url: strnavigateUrl,
        method: 'GET'
      }).then(res => {
        if (res.status === 200) {
          that.navigationData = res.data;
          if (that.navigationData.length > 0) that.curNavigateId = that.navigationData[0];
          console.log("--------------------",res);
        }
        that.loading = false;
      }).catch((err) => {
        alert('Error');
        console.log(err)
        that.loading = false;
      })
    },
    vectorBack(){
      this.big=1;
      this.vectorNum=0;
      this.vectorMoveXXScale=0;
      this.vectorMoveYYScale=0;
      this.vectorMoveXX=0;
      this.vectorMoveYY=0;
      this.$refs.scrollbarY.setScrollTop(0);
      this.$refs.scrollbarX.setScrollLeft(0);
      this.clearCanvas();
      this.clearPoint();
      this.clearBlock();
      this.$nextTick(()=> {
        this.draw();
        this.$nextTick(()=> {
          this.draw();
        })
      })
    },
    //监听页面尺寸
    resizeFunc(){
      //this.containerChange()
      //if(this.big==1){this.vectorBack()}
      this.$nextTick(()=>{
        this.xxoo(this.$refs.iosLise);
        // let left = this.$refs.scale.$el.offsetWidth;
        // let h = this.$refs.pointShow.height;
        let ww = this.$refs.container.$el.offsetWidth;
        let col01 = this.$refs.row.$el.offsetWidth;
        col01/=24;
        console.log(this.$refs.container.$el,this.$refs.row.$el,this.$refs.pointShow)
        let w = this.$refs.iosLise.width;
        if(this.colorCodeShow){
          this.$nextTick(()=>{
            ww-=w;
            ww-=200;
            ww/=2;
            ww+=col01
            this.$refs.iosLise.style.marginLeft=ww+"px";
            this.$refs.cc1.style.left=ww+"px"
            this.ssLeft+=ww;
            // ww+=this.$refs.scale.$el.offsetWidth
            this.$refs.pointShow.style.left=ww+"px";
            this.$refs.pointCheck.style.left=ww+"px";
            this.$refs.blockDraw.style.left=ww+"px";
            //console.log(this.$refs.pointShow.style)
            //this.updateMapData();
          })

        }else{
          this.$nextTick(()=>{
            console.log(">>>>>",this.$refs.scale)
            ww-=this.$refs.pointShow.width;
            ww/=2;

            ww+=col01*2;
            this.ssLeft += ww;
            this.$refs.iosLise.style.marginLeft = ww+"px";
            this.$refs.cc1.style.left = ww+"px"
            //ww+=this.$refs.scale.$el.offsetWidth
            // ww+=col01;
            this.$refs.pointShow.style.left = ww + "px";
            this.$refs.pointCheck.style.left = ww + "px";
            this.$refs.blockDraw.style.left = ww + "px";
          })

          //this.updateMapData();
        }
      })
    },
    //获取当前canvas位置
    xxoo(element){
      let top = element.offsetTop;
      // let left = element.offsetLeft;
      let bottom = window.screen.height;
      console.log(element)
      var current = element.offsetParent;
      while(current!==null){
        top+=current.offsetTop;
        // left+=current.offsetLeft;
        current = current.offsetParent;
      }
      //console.log(this.$refs.xxx)
      this.ssTop=top;
      this.ssLeft=0;
      bottom-=top;
      if(this.iosLiseHeight!=undefined){
        bottom = this.iosLiseHeight;
      }
      bottom-=72;//logo的高度
      bottom-=19;//导航条的高度
      bottom-=20;//组建的padding
      bottom-=95;//预留责任人与滚动条高度

      //console.log("bottom",bottom)
      this.ssBottom=bottom;
      this.ssLeft+=this.canvasWidth;
      this.ssLeft+=this.$refs.scale.$el.offsetWidth;
      this.ssHeight=this.canvasHeight;
    },
    //横向滚动条
    scrollbarX(val){
      console.log(val)
      this.$nextTick(()=>{
        this.vectorMoveXX=val.scrollLeft*(this.canvasWidth*10-this.canvasWidth)/900.5820530829125;
        console.log("scrollLeft:",val.scrollLeft,this.canvasWidth,this.canvasWidth*this.big);
        let ss= this.vectorMoveXX;
        let nn = this.canvasWidth;
        nn*=this.big;
        nn-=this.canvasWidth;
        ss/=nn;
        this.vectorMoveXXScale=ss;
        console.log(this.vectorMoveXXScale)
        this.clearCanvas()
        this.clearPoint()
        this.clearBlock()
        this.draw();
        // this.pointDraw();
      })

    },
    //纵向滚动条
    scrollbarY(val){
      this.$nextTick(()=>{
        this.vectorMoveYY=val.scrollTop*(this.canvasHeight*10-this.canvasHeight)/900.2020530829125;
        console.log("scrollTop:",val.scrollTop,this.canvasHeight,this.canvasHeight*this.big);
        let ss= this.vectorMoveYY;
        let nn = this.canvasHeight;
        nn*=this.big;
        nn-=this.canvasHeight;
        ss/=nn;
        console.log(this.$refs.scrollbarYS)
        this.vectorMoveYYScale=ss;
        this.clearCanvas()
        this.clearPoint()
        this.clearBlock()
        this.draw();
        // this.pointDraw()

      })
    },
    vectorX(val){
      this.vectorMove("x",val)
    },
    vectorY(val){
      this.vectorMove("y",val)
    },//之前的滚动条
    vectorMove(dire,val){
      if(this.vectorMoveX==0&&this.vectorMoveX==100){
        let x= 0;
        let y= 0;
        let seeX = this.canvasWidth;
        let seeY = this.canvasHeight;
        let scale = this.big;
        let moveX = seeX;
        let moveY = seeY;
        moveX*=scale;
        moveX-=seeX;
        moveY*=scale;
        moveY-=seeY;
        if(dire =="y"){
          y=100;
          y-=val;
        }else{
          x=val
        }
        x*=0.01;
        y*=0.01;
        moveX*=x;
        moveY*=y;
        this.vectorMoveXX=moveX
        this.vectorMoveYY=moveY
        console.log(111)
      }
      if(dire =="y"){
        let seeY = this.canvasHeight;
        let y = 0;
        let scale = this.big;
        let moveY = seeY;
        moveY*=scale;
        moveY-=seeY;
        y=100;
        y-=val;
        y*=0.01;
        moveY*=y;
        this.vectorMoveYY=moveY
        console.log("dire ==y",this.vectorMoveXX,this.vectorMoveYY)
      }else{
        let seeX = this.canvasWidth;
        let x = 0;
        let scale = this.big;
        let moveX = seeX;
        moveX *= scale;
        moveX -= seeX;
        x = val;
        x *= 0.01;
        moveX *= x;
        this.vectorMoveXX = moveX
        console.log("dire ==X",this.vectorMoveXX,this.vectorMoveYY)

      }
      this.draw();
    },
    //屏幕尺寸变化
    containerChange(){
      this.xxoo(this.$refs.iosLise);
      let This = this;
      let left = this.$refs.scale.$el.offsetWidth;
      left+="px";
      this.$nextTick(()=>{
        This.$refs.pointShow.style.position="absolute";
        This.$refs.pointShow.style.left=left;
        This.$refs.pointShow.style.top=0;
        This.$refs.pointCheck.style.position="absolute";
        This.$refs.pointCheck.style.left=left;
        This.$refs.pointCheck.style.top=0;
        This.$refs.blockDraw.style.position="absolute";
        This.$refs.blockDraw.style.left=left;
        This.$refs.blockDraw.style.top=0;
      });
      let cH = 0;
      let cW = this.$refs.container.$el.offsetWidth;
      let cX = 0;
      let cY = 0;
      let h = this.dataTop;
      let w = this.dataRight;
      let canvasWidthNum =1;
      let canvasHeightNum =1;
      h -= this.dataBottom;
      w -= this.dataLeft;
      cH = this.mapData.height;
      cH-=45;//预留责任人位置
      cH-=48;
      cH-=28;
      cW-=200;//预留色标位置
      canvasWidthNum = cW;
      canvasWidthNum/=w;
      canvasHeightNum= cH;
      canvasHeightNum/=h;
      this.canvasWidthNum=canvasWidthNum;
      this.canvasHeightNum=canvasHeightNum;
      console.log("----------------------")
      console.log(this.canvasWidthNum)
      console.log(this.canvasHeightNum)
      console.log("----------------------")
      this.canvasHeight=cH;
      this.canvasWidth=cW;
      // if(w>h) {
      //   cW -= 200;//预留色标位置
      //   let aspectRatio = h;
      //   aspectRatio /= w;
      //   console.log(aspectRatio)
      //   cH = cW;
      //   cH *= aspectRatio;
      //   canvasWidthNum = cW;
      //   canvasWidthNum /= w;
      //   canvasHeightNum = cH;
      //   canvasHeightNum /= h;
      //   console.log(canvasHeightNum, canvasWidthNum)
      //   this.canvasHeight = cH;
      //   this.canvasWidth = cW;
      // }else
      //{

      // cW -= 200;
      // let aspectRatio = w;
      // aspectRatio /= h;
      // console.log(aspectRatio)
      // cH = this.ssBottom;
      // cW = cH;
      // cW *= aspectRatio;
      // canvasWidthNum = cW;
      // canvasWidthNum /= w;
      // canvasHeightNum = cH;
      // canvasHeightNum /= h;
      //
      // this.canvasHeight = cH;
      // this.canvasWidth = cW;
      //}
      // console.log(this.ssBottom)
      // if(this.canvasHeight>this.ssBottom){
      //   this.canvasHeight=this.ssBottom
      // }
      // let difference = cH;
      // difference -= this.ssBottom;
      // this.difference = difference;
      console.log("看这里",this.difference)
      console.log("看这里",this.ssWidth)
      //this.canvasHeightNum=canvasHeightNum;
      //this.canvasWidthNum=canvasWidthNum;
      cX=this.dataLeft;
      cY=this.dataBottom;
      cX*=this.canvasWidthNum;
      cY*=this.canvasHeightNum;
      this.canvasMoveX=cX;
      this.canvasMoveY=cY;
      this.endX=this.canvasWidth;
      this.endY=this.canvasHeight;
    },
    //鼠标点击状态释放
    mouseUp(){
      this.iosLiseClickState=false;
    },
    //色标添加颜色成功
    colorAddChange(){
      console.log(this.colorAdd);
      if(this.colorAdd!=null){
        this.colorCode.push(this.colorAdd);
        this.colorAdd="";
      }
    },
    //色标颜色删除
    handleClose(tag){
      console.log(tag)
      this.colorCode.splice(this.colorCode.indexOf(tag), 1)
    },
    //井选择确定
    pointNowClick(){
      this.pointNow=[];
      this.pointDialogVisible=false;
    },
    configWg(){
      if(this.dataSourceOptions.length==0){
        this.getDataSource()
        this.configWgDialogVisible=true;
      }else{
        this.configWgDialogVisible=true;
      }
    },
    //数据源筛选
    dataSourceQuery(){
      this.refreshDialogVisible=true;
      let num1 = 0;
      let num2 = 0;
      let arr1 = [];
      let arr2 = [];
      for(let i in this.queryFilter){
        arr2.push(this.queryFilter[i].code)
        for(let j in this.queryFilter[i].children){
          arr1.push(this.queryFilter[i].children[j].code)
        }
      }
      arr1=arr1.sort()
      arr2=arr2.sort()
      num1=arr1[arr1.length-1];
      num2=arr2[arr2.length-1];
      console.log(num1,num2)
      this.$nextTick(()=>{
        this.$refs.queryConfig.queryFilter = this.queryFilter;
        this.$refs.queryConfig.num1 = num1;
        this.$refs.queryConfig.num2 = num2;
        console.log(this.queryFilter);
        if(this.queryFilter.length<=0)
        {
          this.$refs.queryConfig.addGroup();
          this.$refs.queryConfig.activeGrp = [0];
        }
      },100)
    },
    //监听数据筛选
    numChange(data){
      this.queryConfigNum.num1=data.num1;
      this.queryConfigNum.num2=data.num2;
    },
    //查询条件置空
    refreshReset(){
      this.$refs.queryConfig.queryFilter=[{
        code:0,//组别唯一序列号
        logic:"",//与其他组别的关系
        show:false,//折叠状态
        children:[{
          logic:"",//逻辑
          field:"",//字段
          symbol:"",//条件
          value:"",//值
          code:0//条件唯一序列号
        }],
      }];
      this.$refs.queryConfig.num1=1;
      this.$refs.queryConfig.num2=1;
      // let user_id = "0000001";
      // let userInfoSession = localStorage.getItem("lyqtUserInfo");
      // if (userInfoSession == null) userInfoSession = {};
      // // let curUserId = "";
      // let curUserEmplyeeId = "";
      // if (userInfoSession.length > 0) {
      //   let jsonUserInfo = JSON.parse(userInfoSession);
      //   // user_id = jsonUserInfo.userId;
      //   curUserEmplyeeId = jsonUserInfo.employeeId;
      // }
      this.queryFilter = [];
    },
    //等值线网格配置步长设置页面
    ShowISOStepPage(){
      if(this.generateType == 2){//个人数据成图
        console.log("generateLocalData",this.layer_tableData)
        if(this.layer_tableData[3].data.length<=0){
          ElMessageBox('本地成图数据未设置！');
          return;
        }
        this.gradMin = this.layer_tableData[3].data[0].value;
        this.gridMax = this.layer_tableData[3].data[0].value;
        console.log(this.gradMin,this.gridMax)
        for(let idx=0;idx<this.layer_tableData[3].data.length;idx++){
          if(this.gradMin>this.layer_tableData[3].data[idx].value) this.gradMin = this.layer_tableData[3].data[idx].value;
          if(this.gridMax<this.layer_tableData[3].data[idx].value) this.gridMax = this.layer_tableData[3].data[idx].value;
        }
        console.log(this.gradMin,this.gridMax)
        this.gradInterval = Math.round((this.gridMax - this.gradMin)/10,2);
        this.colorCodeSpacing = Math.round((this.gridMax - this.gradMin)/5,2);
        this.configWgNum=!this.configWgNum;
        return;
      }
      //todo
      // if(this.dataSource == "" || this.dataSourceHeader == "" || this.dataSourceJHHeader == ""){
      //   ElMessage("请先设置数据源和相应的成图字段!");
      //   return;
      // }
      if(this.dataSource == "" || this.dataSourceHeader=="" || this.dataSourceJHHeader == ""){
        ElMessageBox('数据源、成图数据和井名字段必须设置！');
        return;
      }
      this.configWgNum=!this.configWgNum;

      //获取并设置最大最小值
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId==undefined) blkTypeId = "02";
      let checkedBlock = localStorage.getItem("checkedBlock");
      if (checkedBlock == null) {
        checkedBlock = {};
      }
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let checkedBlkIdAry = [];
      for (let key in jsonCheckedBlk) {
        checkedBlkIdAry.push(key);
      }
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      let gridCfgData = {
        jwt:jwtSession,//用户token令牌
        blkType:blkTypeId,//区块类型银行  1期
        blkTypeID:blkTypeId,//区块类型银行  1期
        checkedBlk:checkedBlkIdAry,//选中区块
        valueColumn:this.dataSourceHeader,//"YCYL",
        datSrcID:this.dataSource,//"C3B3A3E6511D42A1894EE5D84AF600CF",
        queryFilter:this.queryFilter//[{"logic":"","show":false,"children":[{"logic":"","field":"NY","symbol":"=","value":"201012"},{"logic":"AND","field":"YCYL","symbol":">","value":"0"}]}],//过滤条件
      };
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getISOMinMaxData",gridCfgData)
          .then(res=>{
            if(res.data.success){
              this.gradMin = res.data.min
              this.gridMax = res.data.max
              this.gradInterval = Math.round((this.gridMax - this.gradMin)/10,2);
              this.colorCodeSpacing = Math.round((this.gridMax - this.gradMin)/5,2);
            }
          }).catch(err=>{
        ElMessageBox('Error');
        console.log(err);
      })
    },
    reInit(){//重置
      if(this.isSizeChange==true){
        this.scale=1;
        this.big=1;
      }
      this.beginX=0;
      this.beginY=0;
      let isoData = this.mapData;
      isoData.baseMap={};
      isoData.isoRegions=[];
      isoData.isoLines=[];
      isoData.faults=[];
      isoData.points=[];
      isoData.blkBoundary=[];
      isoData.boundary={
        left:0,
        right:0,
        top:0,
        bottom:0
      };
      isoData.height=0;
      this.clearCanvas();
      this.clearPoint();
      this.clearBlock();
      this.getData();
    },
    //网格确定按钮响应，开始生成等值线
    generateISO(){
      if(this.isSizeChange==true){
        this.scale=1;
        this.big=1;
      }
      this.beginX=0;
      this.beginY=0;
      let jwtSession = localStorage.getItem("lyqtJwt");
      if (jwtSession == null) jwtSession = "";
      //图例在成图时重置初始值
      this.tlSymbolWidth=0;//图例宽
      this.tlSymbolHeight=0;//图例高
      this.tlSymbolSize=0;//图例内符号大小
      this.tlFontSize=0;//图例字体大小
      this.tlTileSize=0;//图例标题大小
      this.tlGapSize=0;//图例符号间隔

      if(this.generateType == 2){//本地数据成图
        //demoBody
        //{"scatter":[{"x":4,"y":5,"data":10,"label":"井1","prop":"type:'unknow',color:'#F00'"},{"x":8,"y":9,"data":3,"label":"井1","prop":"type:'unknow',color:'#00F'"}],
        //    "bound":[{"xh":1,"x":0,"y":0},{"xh":2,"x":0,"y":10},{"xh":3,"x":10,"y":10},{"xh":4,"x":10,"y":0},{"xh":5,"x":0,"y":0}],
        //    "fault":[{"faultclass":"surface","data":[{"x":2,"y":2},{"x":3,"y":4},{"x":4,"y":5},{"x":2,"y":2}]},{"faultclass":"line","data":[{"x":4,"y":6},{"x":7,"y":8}]}]
        //}
        console.log("个人数据最终成图")
        console.log(this.mapData)
        console.log(this.layer_tableData)
        let scatterData = this.layer_tableData[3].data;
        for(let idx=0;idx<scatterData.length;idx++){
          scatterData[idx].label = "data"+idx;
          scatterData[idx].type = "unknow";
          scatterData[idx].color = "#FFF";
        }
        let boundData = this.layer_tableData[2].data;
        let faultData = this.mapData.faults;
        let gridBody = {};
        gridBody.scatter = scatterData;
        gridBody.bound = boundData;
        gridBody.fault = faultData;

        let gridCfgLocalData = {
          jwt:jwtSession,//用户token令牌
          dspStep:this.gridSpacing,//300,//网格步长
          sbRefineTimes:this.encryptionNum,//1,//加密次数
          dsbFaultAffectRange:this.faultRange,//1,//断层影响范围
          sbSmoothTimes:this.smoothNum,//3,//平滑次数
          spDataRelable:this.valueReliability,//10,//数据可信度
          sldSmooth:this.thinningNum,//1,//简化系数
          dsbIntv:this.gradInterval,//200,//等值线间隔
          isNeedBorder:this.borderValue,//true,//是否依赖边界，无边界则自动计算矩形边界
          isNeedFaul:this.faultValue,//true,//是否依赖断层
          cbInterMethod:this.isoModel,//1//插值算法
          wellData:this.mapData.points,
          gridBody:gridBody//成图数据体
        };
        this.configWgDialogVisible = false
        this.clearCanvas();
        this.clearPoint();
        this.clearBlock();
        // console.log("wellDataForISO:",JSON.stringify(this.mapData.points))
        this.$emit('generateLocalISO',gridCfgLocalData);
        return;
      }
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId==undefined) blkTypeId = "02";
      let checkedBlock = localStorage.getItem("checkedBlock");
      if (checkedBlock == null) {
        checkedBlock = {};
      }
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let checkedBlkIdAry = [];
      for (let key in jsonCheckedBlk) {
        checkedBlkIdAry.push(key);
      }

      let boundData = this.layer_tableData[2].data;
      let faultData = this.mapData.faults;

      let gridCfgData = {
        jwt:jwtSession,//用户token令牌
        blkType:blkTypeId,//区块类型银行  1期
        blkTypeID:blkTypeId,//区块类型银行  1期
        checkedBlk:checkedBlkIdAry,//选中区块
        labelColumn:this.dataSourceJHHeader,//"JH",
        valueColumn:this.dataSourceHeader,//"YCYL",
        datSrcID:this.dataSource,//"C3B3A3E6511D42A1894EE5D84AF600CF",
        queryFilter:this.queryFilter,//[{"logic":"","show":false,"children":[{"logic":"","field":"NY","symbol":"=","value":"201012"},{"logic":"AND","field":"YCYL","symbol":">","value":"0"}]}],//过滤条件
        dspStep:this.gridSpacing,//300,//网格步长
        sbRefineTimes:this.encryptionNum,//1,//加密次数
        dsbFaultAffectRange:this.faultRange,//1,//断层影响范围
        sbSmoothTimes:this.smoothNum,//3,//平滑次数
        spDataRelable:this.valueReliability,//10,//数据可信度
        sldSmooth:this.thinningNum,//1,//简化系数
        dsbIntv:this.gradInterval,//200,//等值线间隔
        isNeedBorder:this.borderValue,//true,//是否依赖边界，无边界则自动计算矩形边界
        isNeedFaul:this.faultValue,//true,//是否依赖断层
        cbInterMethod:this.isoModel,//1//插值算法
        localBound:boundData,//本地边界
        localFault:faultData//本地断层
      };
      this.configWgDialogVisible = false
      this.clearCanvas();
      this.clearPoint();
      this.clearBlock();
      this.$emit('generateISO',gridCfgData);
    },
    //查询页面点击提交
    refreshOk(){
      let queryFilter = this.$refs.queryConfig.queryFilter;
      queryFilter[0].logic="";
      for(let i in queryFilter){
        for(let j in queryFilter[i].children){
          for(let k in queryFilter[i].children[j]){
            //console.log(k+"="+queryFilter[i].children[j][k])
            if(queryFilter[i].children[j][k]===""){
              if(j==0&&k=="logic"){
                continue
              }else{
                ElMessage("您有未填写查询条件,请补全后再提交")
                return
              }
            }
          }
        }
      }
      console.log("查询条件",queryFilter);
      this.queryFilter = queryFilter;
      this.refreshDialogVisible = false;
    },
    //底图选择
    imageUpload(e){
      //var form = document.getElementById('imageUpload'),
      //  formData = new FormData(form);
      let This = this;
      if(e.target.files.length==0){
        This.imageSrc2 = "";
        This.imageList = [];
        This.imageType = ""
      }
      if(e.target.files && e.target.files.length){
        if(e.target.files[0].size > 1024 * 1024 * 5){
          ElMessage({
            message: '图片大小不得超过5M',
            type: 'warning',
          })
          return
        }
        let image = e.target.files[0];
        console.log(image)
        this.imageType = e.target.files[0].type;
        this.imageType = this.imageType.slice(6);
        let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = function (){
          console.log(this.result);
          This.imageSrc2 = this.result;
          This.imageList=[];
          This.imageList.push(this.result)
        }
      }
    },
    blockDel(){
      let checkUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/checkBlkBoundary";
      let deleteUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/delBlkBoundary";
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      let checkData ={};
      checkData.blkIDS = this.getBlock();
      console.log(checkData)
      console.log(checkUrl)
      axios.post(checkUrl,checkData)
          .then(res=>{
            console.log(res)
            if(res.data.success){
              if(res.data.result){
                ElMessageBox.confirm(
                    '真的要删除区块数据吗?',
                    '提示',
                    {
                      confirmButtonText: '是',
                      cancelButtonText: '否',
                      type: 'warning',
                    }
                ).then(()=>{
                  axios.post(deleteUrl,checkData,{
                    headers: {
                      authorization: `Bearer ${token}`,
                    }
                  }).then(ress=>{
                    console.log(ress)
                    ElMessage("区块删除成功")
                    this.updateMapData()
                  })
                }).catch(()=>{
                  console.log(123)
                })
              }else{
                ElMessage("暂无可删除区块")
              }
            }

          })


    },
    getBlock(){
      let checkedBlock = localStorage.getItem("checkedBlock");
      if (checkedBlock == null) {
        checkedBlock = {};
      }
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let checkedBlkIdAry = [];
      for (let key in jsonCheckedBlk) {
        checkedBlkIdAry.push(key);
      }
      return checkedBlkIdAry
    },
    //底图配置
    imageConfig(){
      this.imageDialogVisible=true;
    },
    imageConfigOk(){
      if(this.imageSrc2===""){
        ElMessage({
          message: '请选择底图',
          type: 'warning',
        })
        return 1
      }
      if(this.imageTop==0||this.imageBottom==0||this.imageLeft==0||this.imageRight==0){
        ElMessage({
          message: '您有未填写的底图数据',
          type: 'warning',
        })
        return 1
      }
      if(this.imageTop<this.imageBottom||this.imageRight<this.imageLeft||this.imageTop==this.imageBottom||this.imageRight==this.imageLeft){
        ElMessage({
          message: '坐标范围不符合要求',
          type: 'warning',
        })
        return 1
      }
      // if((-1*this.imageBottom)>this.mapData.boundary.top){
      //   this.dataTop = (-1*this.imageBottom);
      //
      // }
      // if((-1*this.imageTop)<this.mapData.boundary.bottom){
      //   this.dataBottom = (-1*this.imageTop)
      // }
      // if(this.imageLeft<this.mapData.boundary.left){
      //   this.dataLeft = this.imageLeft
      // }
      // if(this.imageRight>this.mapData.boundary.right){
      //   this.dataRight = this.imageRight
      // }
      // let aspectRatio = this.canvasWidth;
      // aspectRatio/=this.canvasHeight;
      // if(this.dataRight-this.dataLeft>this.dataTop-this.dataBottom){
      //   let y = this.dataRight-this.dataLeft;
      //   y /= aspectRatio;
      //   y-= (this.dataTop-this.dataBottom);
      //   y/=2;
      //   this.dataTop+=y;
      //   this.dataBottom-=y;
      //
      // }else{
      //   let x = this.dataTop-this.dataBottom;
      //   x*=aspectRatio;
      //   x-= (this.dataRight-this.dataLeft);
      //   x/=2;
      //   this.dataLeft-=x;
      //   this.dataRight+=x;
      // }
      this.imageDialogVisible=false;
      return 2
    },
    imageDel(){
      let checkUrl = process.env.VUE_APP_SERVER + "/fileprocesser/blkBaseMap";
      let deleteUrl = process.env.VUE_APP_SERVER + "/fileprocesser/delBlkBaseMap";
      let checkData = {};
      checkData.blkIDS = this.getBlock();
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      axios.post(checkUrl,checkData,{
        headers: {
          authorization: `Bearer ${token}`
        }
      }).then(res=>{
        console.log(res)
        if(res.data.success){
          ElMessageBox.confirm(
              '确认要删除底图吗',
              '提示',
              {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
              }
          ).then(()=>{
            axios.post(deleteUrl,checkData,{
              headers: {
                authorization: `Bearer ${token}`
              }
            }).then(ress=>{
              console.log(ress)
              ElMessage(ress.data.msg)
            })
          })
        }else{
          ElMessage("暂无可删除的底图数据")
        }
      }).catch(err=>{
        ElMessage(err)
      })
      //this.updateMapData();

    },
    uploadOk(){
      if(this.imageConfigOk()==2){
        // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
        let token = localStorage.getItem("lyqtJwt");
        let checkedBlock = localStorage.getItem("checkedBlock");
        if (checkedBlock == null) {
          checkedBlock = {};
        }
        let jsonCheckedBlk;
        try {
          jsonCheckedBlk = JSON.parse(checkedBlock);
        } catch {
          jsonCheckedBlk = JSON.parse("{}");
        }
        let checkedBlkIdAry = [];
        for (let key in jsonCheckedBlk) {
          checkedBlkIdAry.push(key);
        }
        //console.log(checkedBlkIdAry)

        let imageData = {};
        imageData.blkIDS = checkedBlkIdAry;
        imageData.src = this.imageSrc2;
        imageData.top = this.imageTop;
        imageData.bottom = this.imageBottom;
        imageData.left = this.imageLeft;
        imageData.right = this.imageRight;
        imageData.suffix = this.imageType;
        console.log(imageData)
        let url = process.env.VUE_APP_SERVER + "/fileprocesser/saveBlkBaseMap";
        axios.post(url,imageData,{
          headers: {
            authorization: `Bearer ${token}`,
          }
        }).then(res=>{
          console.log("图片")
          console.log(imageData.blkIDS)
          console.log(res)
          ElMessage("提交成功")

        })
        //this.$emit('imageConfigOk',"ok");
      }
    },
    config(){
      this.configDialogVisible=true;
    },
    configOk(val){
      console.log(val)
      // if(this.isSizeChange==true){
      //   this.scale=1;
      //   this.big=1;
      // }
      // this.beginX=0;
      // this.beginY=0;
      this.isoRegionColorAdd();
      this.draw();
      this.configDialogVisible=false;
    },
    //缩放
    vectorChange(){
      if(this.sizeChangeType==1&&this.big==1)
      {
        this.vectorMoveXX=0;
        this.vectorMoveYY=0;
        this.$refs.scrollbarY.setScrollTop(0);
        this.$refs.scrollbarX.setScrollLeft(0);
        this.vectorNum=0;
      }
      this.draw();
      if(this.big>1){
        if(this.vectorNum==0){
          let w = this.canvasWidth;
          let h = this.canvasHeight;
          w*=this.big;
          w-=this.canvasWidth;
          w/=2;
          h*=this.big;
          h-=this.canvasHeight;
          h/=2;
          this.vectorMoveXX=w;
          this.vectorMoveYY=h;
          this.vectorMoveXXScale=0.5;
          this.vectorMoveYYScale=0.5;
          this.$nextTick(()=>{
            this.$refs.scrollbarY.setScrollTop(this.vectorMoveYY);
            this.$refs.scrollbarX.setScrollLeft(this.vectorMoveXX);
          })
          this.vectorNum++;
        }else{

          let hh = this.canvasHeight;
          hh *= this.big;
          let ww = this.canvasWidth;
          ww*=this.big;
          hh-=this.canvasHeight;
          ww-=this.canvasWidth;
          ww*=this.vectorMoveXXScale;
          hh*=this.vectorMoveYYScale;
          console.log("vectorMoveXXScale",this.vectorMoveXXScale)
          console.log("vectorMoveYYScale",this.vectorMoveYYScale)
          this.vectorMoveYY=hh;
          this.vectorMoveXX=ww;
          this.$nextTick(()=>{
            this.$refs.scrollbarY.setScrollTop(this.vectorMoveYY);
            this.$refs.scrollbarX.setScrollLeft(this.vectorMoveXX);
          })
          this.vectorNum++;
        }
      }
    },
    //绘制底图
    imageDraw(image){
      let h = this.imageTop;
      h -= this.imageBottom;
      let w = this.imageRight;
      w -= this.imageLeft;
      let originX = this.imageLeft;
      let originY = this.imageTop;
      originY *= -1;
      originX -= this.dataLeft;
      originY -= this.dataBottom;
      originX *= this.canvasWidthNum;
      originY *= this.canvasHeightNum;
      h *= this.canvasHeightNum;
      w *= this.canvasWidthNum;
      //this.$nextTick(()=>{
      let c = this.$refs.iosLise;
      let ctx=c.getContext("2d");
      ctx.save();
      ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
      //ctx.stroke();
      ctx.clip();
      ctx.translate(-this.vectorMoveXX,-this.vectorMoveYY);
      ctx.scale(this.big,this.big);
      ctx.globalCompositeOperation="source-atop";
      ctx.globalAlpha=1;//透明度
      ctx.drawImage(image,originX,originY,w,h)
      console.log("底图绘制了",image,originX,originY,w,h)
      //ctx.drawImage(image,0,0,this.canvasWidth,this.canvasHeight)
      ctx.restore();
      //this.getCanvas();
      // this.ctx.drawImage(img, 0, 0, img.width, img.height);
      // 在这之后才能继续绘制其他图片
      // this.addImage(xxx);
      this.drawWithoutImg();
    },
    //绘图
    draw(){
      console.log(134,this.canvasWidth)
      let c = this.$refs.iosLise;
      let ctx=c.getContext("2d");
      var w = c.width;
      var h = c.height;
      ctx.save();
      ctx.clearRect(0, 0, w, h);
      ctx.lineWidth=2;
      ctx.strokeStyle ="black";
      //ctx.strokeRect(0,0,this.canvasWidth,this.canvasHeight);
      ctx.fillStyle="#fff";
      ctx.globalAlpha=0.8;
      // ctx.fillRect(0,0,this.canvasWidth,this.canvasHeight)
      ctx.rect(0,0,this.canvasWidth,this.canvasHeight)
      // ctx.fill();
      // ctx.stroke();
      ctx.restore();

      let isDrawImage = this.imageShow;
      if(isDrawImage){
        isDrawImage = this.imageSrc2 != undefined && this.imageSrc2 != null && this.imageSrc2 != {} && this.imageSrc2 != "";
      }
      if(isDrawImage){
        let This = this;
        //console.log("image:",This.imageSrc2,This.imageSrc2 != undefined && This.imageSrc2 != null && This.imageSrc2 != {} && This.imageSrc2 != "")
        this.$nextTick(()=>{
          //let image = new Image();
          //image.src = This.imageSrc2;
          //image.onload=function(){
          this.addImage(This.imageSrc2)
              .then((image) => {
                this.imageDraw(image)
              });
          // let image = new Image();
          // image.src=This.imageSrc2;
          // image.onload=function(){
          //   let h = This.imageTop;
          //   h -= This.imageBottom;
          //   let w = This.imageRight;
          //   w -= This.imageLeft;
          //   let originX = This.imageLeft;
          //   let originY = This.imageTop;
          //   originY *= -1;
          //   originX -= This.dataLeft;
          //   originY -= This.dataBottom;
          //   originX *= This.canvasWidthNum;
          //   originY *= This.canvasHeightNum;
          //   h *= This.canvasHeightNum;
          //   w *= This.canvasWidthNum;
          //   //this.$nextTick(()=>{
          //   let c = This.$refs.iosLise;
          //   let ctx=c.getContext("2d");
          //   ctx.save();
          //   ctx.rect(0,0,This.canvasWidth,This.canvasHeight);
          //   //ctx.stroke();
          //   ctx.clip();
          //   ctx.translate(-This.vectorMoveXX,-This.vectorMoveYY);
          //   ctx.scale(This.big,This.big);
          //   ctx.globalCompositeOperation="source-atop";
          //   ctx.globalAlpha=1;//透明度
          //   ctx.drawImage(image,originX,originY,w,h)
          //   console.log("底图绘制了",image,originX,originY,w,h)
          //   //ctx.drawImage(image,0,0,this.canvasWidth,this.canvasHeight)
          //   ctx.restore();
          //   //this.getCanvas();
          // }

        })
        //},500)
      }else{
        this.drawWithoutImg();
        // this.drawWithoutImg(ctx);
      }
      ctx.restore();
    },
    drawWithoutImg(){
      console.log("到底绘制了没")
      //this.linesShow = false;
      // this.surfaceShow = false;
      let drawtk = this.isGis?false:true;
      let drawfxb = this.isGis?false:true;
      let drawczSymbol = this.czSymbolShow;
      let drawTlSymbol = this.tlShow;
      let drawblcSymbol = true;//绘制比例尺
      let blcDrawCnt = 3;//绘制比例尺的段数
      let tlColNum = this.tlColCnt;//图例一行显示几列
      let tlSymbolWidth = this.tlSymbolWidth;//图例单符号宽度
      let tlSymbolHeight = this.tlSymbolHeight;//图例单符号宽度
      let tlSymbolCnt = this.jbAry.length;//图例个数
      let tlSymbolGap = this.tlGapSize;//图例符号间隔
      if((this.scatterDataMaxValue===0 && this.scatterDataMinValue===0)) drawczSymbol=false;//散点值一样为0不绘差值
      // let drawVal = 2;
      let fxbXOffset = 11.81/(Math.min(this.canvasHeightNum,this.canvasWidthNum));
      let fxbYOffset = 11.81/(Math.min(this.canvasHeightNum,this.canvasWidthNum))*2;
      let tkxCnt = 5;
      let tkyCnt = 4;
      // if(this.surfaceShow){
      //   let c8 = this.$refs.iosLise;
      //   let ctx8=c8.getContext("2d");
      //   ctx8.save();
      //   ctx8.rect(0,0,this.canvasWidth,this.canvasHeight);
      //   //ctx8.stroke();
      //   ctx8.clip();
      //   //ctx8.globalAlpha=0.1;
      //   ctx8.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
      //   ctx8.scale(this.canvasWidthNum*this.big,this.canvasHeightNum*this.big);
      //   //ctx8.globalCompositeOperation="destination-over";
      //   for(let i in this.isoRegion){
      //     //console.log(this.isoRegion[i])
      //     for(let j in this.isoRegion[i].polygons){
      //       ctx8.fillStyle=this.isoRegionColor[this.isoRegion[i].value];
      //       ctx8.beginPath();
      //       for(let k in this.isoRegion[i].polygons[j]){
      //         if(k==0){
      //
      //           // ctx8.strokeStyle =this.linesColor;
      //           // ctx8.strokeStyle =ctx8.fillStyle;
      //           // ctx8.lineJoin="round";
      //           ctx8.moveTo(this.isoRegion[i].polygons[j][k].x,this.isoRegion[i].polygons[j][k].y)
      //         }
      //         else{
      //           ctx8.bezierCurveTo(this.isoRegion[i].polygons[j][k].cp1x,this.isoRegion[i].polygons[j][k].cp1y,this.isoRegion[i].polygons[j][k].cp2x,this.isoRegion[i].polygons[j][k].cp2y,this.isoRegion[i].polygons[j][k].x,this.isoRegion[i].polygons[j][k].y);
      //         }
      //       }
      //       ctx8.closePath();
      //       // let iddx=this.isoRegion[i].polygons[j].length-1;
      //       // console.log(iddx);
      //       //  ctx8.lineTo(this.isoRegion[i].polygons[j][0].x,this.isoRegion[i].polygons[j][0].y)
      //       // ctx8.stroke();
      //       // ctx8.fill();
      //     }
      //   }
      //   ctx8.restore();
      // }
      //等值线
      if(this.linesShow||this.surfaceShow){
        let c1 = this.$refs.iosLise;
        let ctx1=c1.getContext("2d");
        // var scale = window.devicePixelRatio;
        // c1.width*=scale;
        // c1.height*=scale;
        // ctx1.scale(scale,scale);
        ctx1.save();
        // ctx1.rect(0,0,this.canvasWidth,this.canvasHeight);
        //console.log(this.canvasWidth,this.canvasHeight,this.canvasMoveX,this.vectorMoveXX,this.canvasMoveY,this.vectorMoveYY)
        //ctx1.stroke();
        // ctx1.clip();

        ctx1.rect(0,0,this.canvasWidth,this.canvasHeight);
        // ctx1.fill()
        ctx1.clip();

        //ctx1.fillStyle="red";
        //ctx1.fillRect(0,0,this.canvasWidth,this.canvasHeight);
        ctx1.lineWidth = this.linesWidth;
        ctx1.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx1.scale(this.canvasWidthNum*this.big,this.canvasHeightNum*this.big);

        // let tkWidth = this.mapData.boundary.tkWidth;
        // ctx1.rect(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y,
        //     this.mapData.boundary.right-tkWidth-this.mapData.boundary.x-(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x),
        //     this.mapData.boundary.top-tkWidth-this.mapData.boundary.y-(this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y))
        // ctx1.clip();

        for(let i in this.linesData){
          for(let j in this.linesData[i].lines){
            //console.log(this.linesData[i].lines[j])
            for(let k in this.linesData[i].lines[j]){
              if(k ==0){
                ctx1.beginPath();
                ctx1.strokeStyle =this.linesColor;
                let curColorTemplate = this.colorTemplate[this.colorCodeTemp-1];
                let colorTemplateType = curColorTemplate.type;
                if(colorTemplateType===undefined) colorTemplateType = 1;
                ctx1.fillStyle = this.isoRegionColor[this.isoRegion[i].value];
                if(colorTemplateType !== 1){
                  for(let ctempIdx = 0;ctempIdx<curColorTemplate.data.length;ctempIdx++){
                    let beginVal = curColorTemplate.data[ctempIdx].beginNumber;
                    let endVal = curColorTemplate.data[ctempIdx].endNumber;
                    if(beginVal===undefined||beginVal===null||beginVal===""){
                      if(endVal!==undefined&&endVal!==null&&endVal!==""&&this.isoRegion[i].value<=endVal){
                        ctx1.fillStyle = curColorTemplate.data[ctempIdx].color;
                        break;
                      }
                    }
                    else if(endVal===undefined||endVal===null||endVal===""){
                      if(this.isoRegion[i].value>beginVal){
                        ctx1.fillStyle = curColorTemplate.data[ctempIdx].color;
                        break;
                      }
                    }
                    else if(this.isoRegion[i].value>beginVal && this.isoRegion[i].value<=endVal){
                      ctx1.fillStyle = curColorTemplate.data[ctempIdx].color;
                      break;
                    }
                  }
                }



                // let calcLineWidth =Math.abs((this.dataRight-this.dataLeft)/4000);
                // let lineWidth = calcLineWidth;
                // console.log("wwwwwwwwwwww6666",calcLineWidth)
                // if(lineWidth>50){
                //   lineWidth = 50
                // }
                // if(lineWidth<5){
                //   lineWidth = 5;
                // }
                // ctx1.lineWidth = lineWidth;





                ctx1.lineJoin="round";
                ctx1.strokeStyle =this.linesColor;
                ctx1.moveTo(this.linesData[i].lines[j][k].x,this.linesData[i].lines[j][k].y)
              }
                  // else if(k<this.linesData[i].lines[j].length-1){
                  //   ctx1.bezierCurveTo(this.linesData[i].lines[j][k].cp1x,this.linesData[i].lines[j][k].cp1y,this.linesData[i].lines[j][k].cp2x,this.linesData[i].lines[j][k].cp2y,this.linesData[i].lines[j][k].x,this.linesData[i].lines[j][k].y)
              // }
              else{
                ctx1.bezierCurveTo(this.linesData[i].lines[j][k].cp1x,this.linesData[i].lines[j][k].cp1y,this.linesData[i].lines[j][k].cp2x,this.linesData[i].lines[j][k].cp2y,this.linesData[i].lines[j][k].x,this.linesData[i].lines[j][k].y)
              }
            }
            ctx1.closePath();
            if(this.surfaceShow) ctx1.fill();
            if(this.linesShow) ctx1.stroke();
          }
        }
        ctx1.restore();
      }

      if(this.labelShow){
        let c7 = this.$refs.iosLise;
        let ctx7=c7.getContext("2d");
        ctx7.save();
        ctx7.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx7.stroke();
        ctx7.clip();
        //ctx7.globalAlpha=0.1;
        ctx7.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx7.scale(this.canvasWidthNum,this.canvasHeightNum);
        ctx7.scale(this.big,this.big);
        // let fontSize = 80;
        // fontSize/=this.big;
        let fontSize = 5/(Math.min(this.canvasHeightNum,this.canvasWidthNum));

        fontSize+="px";
        fontSize += " ";
        fontSize +="'微软雅黑'";
        for(let i in this.linesData){
          //console.log(this.linesData[i])
          for(let j in this.linesData[i].lines){
            if(this.linesData[i].lines[j].length>2&&this.linesData[i].value!=null){
              let num =  Math.floor(this.linesData[i].lines[j].length/2);
              ctx7.beginPath();
              ctx7.strokeStyle='black';
              ctx7.fillStyle = "black";
              ctx7.font = fontSize;
              // ctx7.rotate(180*i * Math.PI / 180)
              let drawLabel = this.linesData[i].value;
              // const fix = ctx7.measureText(drawLabel).actualBoundingBoxAscent + ctx7.measureText(drawLabel).actualBoundingBoxDescent
              if(!isNaN(parseFloat(drawLabel)) && isFinite(drawLabel)){//是数值
                drawLabel = parseFloat(drawLabel).toFixed(2)+'';
              }
              let rotangle = 0;
              // if(this.linesData[i].lines[j].length>num+100){
              //   let k = (this.linesData[i].lines[j][num+100].y-this.linesData[i].lines[j][num].y)/(this.linesData[i].lines[j][num+100].x-this.linesData[i].lines[j][num].x);
              //   rotangle = Math.atan(k)*Math.PI/180;
              //   console.log("rotate",rotangle)
              //   // ctx7.fillText("I love you",0,0);
              //   // console.log("LOVEYOU",-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY,this.linesData[i].lines[j][num].x-ctx7.measureText(drawLabel).width/2,this.linesData[i].lines[j][num].y-fix/2)
              // }
              let k = (this.linesData[i].lines[j][num+1].y-this.linesData[i].lines[j][num].y)/(this.linesData[i].lines[j][num+1].x-this.linesData[i].lines[j][num].x);
              rotangle = Math.atan(k);
              //ctx7.translate(this.linesData[i].lines[j][num].x-ctx7.measureText(drawLabel).width/2,this.linesData[i].lines[j][num].y-fix/2);
              //if(rotangle!=0) {ctx7.rotate(1.5);}
              ctx7.save();
              ctx7.textBaseline="middle";
              // rotangle = 90*Math.PI/180;
              console.log("rotate",rotangle,this.linesData[i].lines[j][num].x,this.linesData[i].lines[j][num].y,this.linesData[i].lines[j][num+1].x,this.linesData[i].lines[j][num+1].y)
              ctx7.translate(this.linesData[i].lines[j][num].x,this.linesData[i].lines[j][num].y)
              if(rotangle!=0) ctx7.rotate(rotangle)
              ctx7.fillText(drawLabel,0,0);
              ctx7.restore()
              // ctx7.fillText(drawLabel,this.linesData[i].lines[j][num].x-ctx7.measureText(drawLabel).width/2,this.linesData[i].lines[j][num].y-fix/2);
              // if(rotangle!=0) ctx7.rotate(-1*rotangle);
            }
          }
        }
        ctx7.restore();
      }
      //断层
      if(this.faultShow){
        let c2 = this.$refs.iosLise;
        let ctx2=c2.getContext("2d");
        ctx2.save();
        ctx2.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx2.stroke();
        ctx2.clip();
        //ctx2.globalAlpha=0.1;
        ctx2.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx2.scale(this.canvasWidthNum*this.big,this.canvasHeightNum*this.big);
        ctx2.lineWidth = this.faultLineWidth;
        for(let i in this.fault){
          //console.log(1111,this.fault[i])
          for(let j in this.fault[i].point){
            if(j==0){
              //console.log(this.fault[i].point[j])
              ctx2.beginPath();
              ctx2.strokeStyle ="black";
              if(this.fault[i].type=="surface"){
                ctx2.fillStyle=this.faultColor;
              }else{
                // ctx2.strokeStyle ="black";
              }
              //ctx2.strokeStyle =this.faultColor;
              ctx2.moveTo(this.fault[i].point[j].x,this.fault[i].point[j].y)
            }else if(j<this.fault[i].point.length-1){
              ctx2.lineTo(this.fault[i].point[j].x,this.fault[i].point[j].y)
            }else{
              ctx2.lineTo(this.fault[i].point[j].x,this.fault[i].point[j].y);
              ctx2.stroke();
              if(this.fault[i].type=="surface"){
                ctx2.fill();
              }else{
                // ctx2.stroke();
              }
            }
          }
        }
        ctx2.restore();
      }
      //井位
      if(this.pointShow){
        let c3 = this.$refs.iosLise;
        let ctx3=c3.getContext("2d");
        ctx3.save();
        ctx3.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx3.stroke();
        ctx3.clip();
        ctx3.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx3.scale(this.canvasWidthNum,this.canvasHeightNum);
        ctx3.scale(this.big,this.big);

        let num1 = this.pointSize;
        // if(this.isGis)
        {
          // let calcNum1 = (this.dataRight - this.dataLeft) / 800;
          // num1 = calcNum1;
          // if (num1 * this.canvasWidthNum < 1) {
          //   num1 = 1 / this.canvasWidthNum;
          // }
          // if (num1 * this.big > calcNum1 * 4) {
          //   num1 = calcNum1 * 4 / this.big;
          // }
          // if (num1 < 0.01) {
          //   num1 = 0.1;
          // }
          let scalNum = (Math.min(this.canvasHeightNum,this.canvasWidthNum));
          if(scalNum<=0.001){
            num1 = 1/scalNum
          }
          else if(scalNum<=0.01){
            num1 = 2/scalNum
          }
          else{
            num1 = 3/scalNum;
          }

          if(!this.isGisNeedNewPointSizeNow){
            if(num1>20) this.pointSize = Math.floor(num1);
          }
        }
        if(this.isGisNeedNewPointSizeNow){
          num1 = this.pointSize;
        }
        console.log("GISPOINT:",num1)

        //let num1 = (this.dataRight-this.dataLeft)/800;
        // if(num1>10){
        //   num1=10
        // }
        console.log("num1是",num1)
        //let num1 = 8;
        for(let i in this.points){
          ctx3.beginPath();
          //ctx3.strokeStyle='black';
          let font = num1*2;
          font +="px '微软雅黑'";
          ctx3.font = font;
          let text = this.points[i].text;
          let num = ctx3.measureText(text).width/2;
          ctx3.fillStyle=this.points[i].color;
          ctx3.arc(this.points[i].x,this.points[i].y,num1,0,2*Math.PI);
          ctx3.textBaseline = "bottom";
          ctx3.fillText(text,this.points[i].x-num,this.points[i].y-num1);
          ctx3.stroke();
          ctx3.fill();
          ctx3.closePath();
        }
        ctx3.restore();
      }

      //差值柱子
      if(drawczSymbol){
        let c3 = this.$refs.iosLise;
        let ctx3=c3.getContext("2d");
        ctx3.save();
        ctx3.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx3.stroke();
        ctx3.clip();
        ctx3.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        console.log("whScale:",this.canvasWidthNum,this.canvasHeightNum)
        ctx3.scale(this.canvasWidthNum,this.canvasHeightNum);
        ctx3.scale(this.big,this.big);

        let num1 = this.pointSize;
        let scalNum = (Math.min(this.canvasHeightNum,this.canvasWidthNum));
        if(scalNum<=0.001){
          num1 = 1/scalNum
        }
        else if(scalNum<=0.01){
          num1 = 2/scalNum
        }
        else{
          num1 = 3/scalNum;
        }

        let symbolWidth = num1;
        let symbolHeight = num1;
        if(!this.icCzNeedNewSize){
          if(num1>20) {
            this.czSymbolWidth = Math.floor(num1/2);
            this.czSymbolHeight = Math.floor(num1)*2;
          }
        }
        if(this.icCzNeedNewSize) {
          symbolWidth = this.czSymbolWidth;
          symbolHeight = this.czSymbolHeight;
        }
        if(this.isGisNeedNewPointSizeNow) {
          num1 = this.pointSize;
        }
        let scatterData = this.layer_tableData[3].data;
        let maxCzSymbolHeight = this.scatterDataMaxValue;
        for(let i in scatterData){
          let curAbsValue = Math.abs(scatterData[i].value);
          if(Number(this.czSymbolMinVal)>Number(this.czSymbolMaxVal) && this.czSymbolMaxNeed && this.czSymbolMinNeed){
            if(Number(scatterData[i].value)<Number(this.czSymbolMinVal) && Number(scatterData[i].value)>Number(this.czSymbolMaxVal)) {continue;}
          }
          else{
            if(this.czSymbolMaxNeed && Number(scatterData[i].value)>Number(this.czSymbolMaxVal)) {continue;}
            if(this.czSymbolMinNeed && Number(scatterData[i].value)<Number(this.czSymbolMinVal)) {continue;}
          }

          //console.log("absvalue2:",scatterData[i].value,this.czSymbolMaxVal,this.czSymbolMaxNeed,this.czSymbolMinVal,this.czSymbolMinNeed,Number(scatterData[i].value)>=Number(this.czSymbolMinVal))
          let curValueSymbolHeight = curAbsValue;
          let HeightBL = curValueSymbolHeight/maxCzSymbolHeight*10;
          console.log("heightBl",maxCzSymbolHeight,curValueSymbolHeight,HeightBL)
          ctx3.beginPath();
          ctx3.strokeStyle="#333";
          ctx3.moveTo(scatterData[i].x+num1*2-symbolWidth,scatterData[i].y)
          ctx3.lineTo(scatterData[i].x+num1*2+symbolWidth*2,scatterData[i].y);
          ctx3.stroke();
          ctx3.closePath();
          ctx3.beginPath();
          //ctx3.strokeStyle='black';
          let font = num1*2;
          font +="px '微软雅黑'";
          ctx3.font = font;
          ctx3.fillStyle=scatterData[i].value>=0?this.czSymbolColorInc:this.czSymbolColorDec;
          ctx3.rect(scatterData[i].x+num1*2,scatterData[i].y,symbolWidth,HeightBL*symbolHeight*(scatterData[i].value>=0?-1:1));
          //ctx3.stroke();
          ctx3.fill();
          ctx3.closePath();
        }
        ctx3.restore();
      }

      //图例
      if(drawTlSymbol){
        let c3 = this.$refs.iosLise;
        let ctx3=c3.getContext("2d");
        ctx3.save();
        ctx3.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx3.stroke();
        ctx3.clip();
        ctx3.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        console.log("whScale:",this.canvasWidthNum,this.canvasHeightNum)
        ctx3.scale(this.canvasWidthNum,this.canvasHeightNum);
        ctx3.scale(this.big,this.big);

        let num1 = this.pointSize;
        let scalNum = (Math.min(this.canvasHeightNum,this.canvasWidthNum));
        if(scalNum<=0.001){
          num1 = 1/scalNum
        }
        else if(scalNum<=0.01){
          num1 = 2/scalNum
        }
        else{
          num1 = 3/scalNum;
        }
        if(tlSymbolWidth===0) this.tlSymbolWidth = Math.floor(num1*12*2);
        tlSymbolWidth = this.tlSymbolWidth;
        if(tlSymbolHeight===0) this.tlSymbolHeight = Math.floor(num1*6);
        tlSymbolHeight = this.tlSymbolHeight;
        if(tlSymbolGap===0) this.tlGapSize = Math.floor(num1*2);
        tlSymbolGap = this.tlGapSize;
        let curColorTemplate = this.colorTemplate[this.colorCodeTemp-1];
        let colorTemplateType = curColorTemplate.type;
        if(colorTemplateType===undefined) colorTemplateType = 1;
        tlSymbolCnt+=curColorTemplate.data.length;
        //console.log("curColorTemp:",curColorTemplate,tlSymbolCnt)

        let rowNum = Math.ceil(tlSymbolCnt/tlColNum);//图例行数
        ctx3.lineWidth = 5;
        let tkWidth = this.mapData.boundary.tkWidth;
        let tlWidth = tlSymbolWidth*tlColNum+tlSymbolGap*(tlColNum+1);
        let tlHeight = tlSymbolHeight*(rowNum+1)+tlSymbolGap*(rowNum+2);
        if(this.tlTileSize===0) this.tlTileSize = Math.floor(num1*5);
        let titleFontSize = this.tlTileSize;
        if(this.tlSymbolSize===0) this.tlSymbolSize = Math.floor(num1*2);
        let tlSymbolSize = this.tlSymbolSize;
        if(this.tlFontSize===0) this.tlFontSize = Math.floor(num1*3);
        let tlsymoblFontSize = this.tlFontSize;

        ctx3.textAlign="center";
        ctx3.textBaseline="top";

        ctx3.fillStyle = "black";
        ctx3.font = titleFontSize+"px '微软雅黑'";
        console.log("tl",ctx3.font)

        let baseX = this.mapData.boundary.right-tkWidth-this.mapData.boundary.x;
        let baseY = this.mapData.boundary.top-tkWidth-this.mapData.boundary.y;
        //画标题
        ctx3.fillText("图例",baseX-tlWidth/2,baseY-tlHeight+tlSymbolGap);

        //画外边框
        ctx3.beginPath();
        ctx3.moveTo(baseX-tlWidth,baseY)
        ctx3.lineTo(baseX-tlWidth,baseY-tlHeight)   //左竖线
        ctx3.lineTo(baseX,           baseY-tlHeight)  //上横线
        ctx3.lineTo(baseX,           baseY) //右竖线
        ctx3.lineTo(baseX-tlWidth,baseY) //下横线
        ctx3.closePath();
        ctx3.stroke();

        let isWell = true;
        //画图例框
        let drawCnt =0;
        for(let rowidx=0;rowidx<rowNum;rowidx++){//行
          for(let colIdx=0;colIdx<tlColNum;colIdx++){//列
            drawCnt++;
            if(drawCnt>tlSymbolCnt) break;//绘制不能超出总图例个数

            //画图例
            ctx3.beginPath();
            ctx3.rect(baseX-tlWidth+tlSymbolGap+(tlSymbolWidth+tlSymbolGap)*colIdx,baseY-tlHeight+(tlSymbolGap+titleFontSize)+tlSymbolGap+(tlSymbolHeight+tlSymbolGap)*rowidx,tlSymbolWidth*2/5,tlSymbolHeight);
            ctx3.closePath();
            ctx3.stroke();

            if(drawCnt>this.jbAry.length) isWell = false;
            if(isWell){
              ctx3.beginPath();
              ctx3.fillStyle=this.jbMap[this.jbAry[drawCnt-1]];
              ctx3.arc(baseX-tlWidth+tlSymbolGap+(tlSymbolWidth+tlSymbolGap)*colIdx+tlSymbolWidth/5,baseY-tlHeight+(tlSymbolGap+titleFontSize)+tlSymbolGap+(tlSymbolHeight+tlSymbolGap)*rowidx+tlSymbolHeight/2,tlSymbolSize,0,2*Math.PI);
              ctx3.closePath();
              ctx3.stroke();
              ctx3.fill();
            }
            else{
              //console.log("hehehehehehehe",drawCnt-this.jbAry.length-1)
              ctx3.fillStyle=curColorTemplate.data[drawCnt-this.jbAry.length-1].color;
              ctx3.fill();
            }
            //画图例文字
            ctx3.font = tlsymoblFontSize+"px '微软雅黑'";
            ctx3.fillStyle='#000';
            ctx3.textAlign="left";
            ctx3.textBaseline="middle";
            ctx3.fillText(isWell?this.jbAry[drawCnt-1]:colorTemplateType===1?curColorTemplate.data[drawCnt-this.jbAry.length-1].number:curColorTemplate.data[drawCnt-this.jbAry.length-1].label,baseX-tlWidth+tlSymbolGap+(tlSymbolWidth+tlSymbolGap)*colIdx+tlSymbolWidth*2/5+tlSymbolGap/2,baseY-tlHeight+(tlSymbolGap+titleFontSize)+tlSymbolGap+(tlSymbolHeight+tlSymbolGap)*rowidx+tlSymbolHeight/2);
          }
        }
        ctx3.restore();
      }

      //比例尺
      if(drawblcSymbol){
        let c3 = this.$refs.iosLise;
        let ctx3=c3.getContext("2d");
        ctx3.save();
        ctx3.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx3.stroke();
        ctx3.clip();
        ctx3.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        console.log("whScale:",this.canvasWidthNum,this.canvasHeightNum)
        ctx3.scale(this.canvasWidthNum,this.canvasHeightNum);
        ctx3.scale(this.big,this.big);

        let num1 = this.pointSize;
        let scalNum = (Math.min(this.canvasHeightNum,this.canvasWidthNum));
        if(scalNum<=0.001){
          num1 = 1/scalNum
        }
        else if(scalNum<=0.01){
          num1 = 2/scalNum
        }
        else{
          num1 = 3/scalNum;
        }
        ctx3.lineWidth = 5;
        let tkWidth = this.mapData.boundary.tkWidth;

        ctx3.textAlign="center";
        ctx3.textBaseline="bottom";

        ctx3.fillStyle = "black";
        ctx3.font = num1*3+"px '微软雅黑'";

        let baseX = this.mapData.boundary.right-tkWidth-this.mapData.boundary.x;
        let baseY = this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y;
        let tfWidth = Math.abs(baseX - (this.mapData.boundary.left+tkWidth+this.mapData.boundary.x));//图幅
        //求比例尺值
        let blcValue = Math.floor(tfWidth/15);
        let blcValueLen = 0;//比例尺值位数
        while(blcValue>=1){
          blcValue/=10;
          blcValueLen++;
        }
        blcValue = parseInt(blcValue*10)*Math.pow(10,blcValueLen)/10;//比例尺的值
        let blcHeight = Math.floor(blcValue/3);//比例尺高度

        //画标题
        ctx3.fillText("0",baseX-tfWidth/2-blcValue*blcDrawCnt/2,baseY+blcHeight);
        //竖线
        ctx3.beginPath();
        ctx3.moveTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2,baseY+blcHeight)
        ctx3.lineTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2,baseY+blcHeight*2)  //上横线
        ctx3.closePath();
        ctx3.stroke();
        let drawFillRect = false;
        for(let labelIdx=0;labelIdx<blcDrawCnt;labelIdx++){
          drawFillRect = !drawFillRect;
          //画标题
          ctx3.fillText(blcValue*(labelIdx+1),baseX-tfWidth/2-blcValue*blcDrawCnt/2+blcValue*(labelIdx+1),baseY+blcHeight);
          //竖线
          ctx3.beginPath();
          ctx3.moveTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2+blcValue*(labelIdx+1),baseY+blcHeight)
          ctx3.lineTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2+blcValue*(labelIdx+1),baseY+blcHeight*2)  //上横线
          ctx3.closePath();
          ctx3.stroke();
          if(drawFillRect){
            ctx3.beginPath();
            ctx3.fillStyle = "#000"
            ctx3.rect(baseX-tfWidth/2-blcValue*blcDrawCnt/2+blcValue*labelIdx,baseY+blcHeight+blcHeight*2/3,blcValue,blcHeight/3);
            ctx3.fill();
            ctx3.closePath();
          }
        }

        //画上横线
        ctx3.beginPath();
        ctx3.moveTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2,baseY+blcHeight+blcHeight/3)
        ctx3.lineTo(baseX-tfWidth/2+blcValue*blcDrawCnt/2,baseY+blcHeight+blcHeight/3)  //上横线
        ctx3.closePath();
        ctx3.stroke();

        //画中横线
        ctx3.beginPath();
        ctx3.moveTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2,baseY+blcHeight+blcHeight*2/3)
        ctx3.lineTo(baseX-tfWidth/2+blcValue*blcDrawCnt/2,baseY+blcHeight+blcHeight*2/3)  //上横线
        ctx3.closePath();
        ctx3.stroke();

        //画底横线
        ctx3.beginPath();
        ctx3.moveTo(baseX-tfWidth/2-blcValue*blcDrawCnt/2,baseY+blcHeight*2)
        ctx3.lineTo(baseX-tfWidth/2+blcValue*blcDrawCnt/2,baseY+blcHeight*2)  //上横线
        ctx3.closePath();
        ctx3.stroke();

        ctx3.restore();
      }
      //盖住超出范围的
      //ctx.fillStyle="#FFF";
      //ctx.fillRect(this.canvasWidth,0,200,this.canvasHeight+100);
      //ctx.fillRect(0,this.canvasHeight,this.canvasWidth,100);
      if(this.blockShow){
        let c = this.$refs.iosLise;
        let ctx=c.getContext("2d");
        ctx.save();
        ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
        ctx.clip();
        ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx.scale(this.canvasWidthNum,this.canvasHeightNum);
        ctx.scale(this.big,this.big);
        let num = (this.dataRight-this.dataLeft)/800;
        if(num>30){
          num =30
        }
        ctx.lineWidth = num;
        ctx.beginPath();
        for(let i in this.blkBoundary){
          if(i == 0){
            ctx.moveTo(this.blkBoundary[i].x,this.blkBoundary[i].y)
          }
          ctx.lineTo(this.blkBoundary[i].x,this.blkBoundary[i].y);
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
      }
      //文字标识
      if(this.signTextShow){
        let c4 = this.$refs.iosLise;
        let ctx4=c4.getContext("2d");
        ctx4.beginPath();
        ctx4.font = "15px '微软雅黑'";
        ctx4.textBaseline = "top";
        ctx4.fillStyle = "black";
        let text = "制图人:"+this.Participants.edit;
        text+=" 编辑人:";
        text+=this.Participants.make;
        text+=" 审核人:";
        text+=this.Participants.examine;
        text = "";
        let num = ctx4.measureText(text).width;
        ctx4.fillText(text,this.canvasWidth-num,this.canvasHeight+25);
        ctx4.stroke();
      }
      //色卡
      if(this.colorCodeShow){
        this.colorCodeDraw();
        let c6 = this.$refs.iosLise;
        let ctx6 = c6.getContext('2d');
        ctx6.textBaseline = "middle";
        var value = [];
        for(let i in this.linesData){
          value.push(this.linesData[i].value)
        }
        value = value.filter(Boolean);
        ctx6.fillStyle = 'black';
        var arr1 =[];
        let max = value.sort(function(a, b){return b - a})[0];
        let min = value.sort(function(a, b){return a - b})[0];
        //console.log(value)
        //console.log(max)
        //console.log(min)
        for(let i =max;i>=min;i-=this.colorCodeSpacing){
          arr1.push(i)
        }
        //console.log(arr1)
        var xxx = 300/arr1.length;
        //console.log(xxx)
        var num1 =0;
        for(let i =50;i<=350;i+=xxx){
          if(arr1[num1]){
            ctx6.fillText(Math.floor(arr1[num1]),this.canvasWidth+50+52,i);
          }else{
            ctx6.fillText(Math.floor(arr1[arr1.length-1]-this.colorCodeSpacing),this.canvasWidth+50+52,i);
          }
          num1++;
        }
      }
      //图框
      if(drawtk)
      {
        let c9 = this.$refs.iosLise;
        let ctx9=c9.getContext("2d");
        ctx9.save();
        ctx9.rect(0,0,this.canvasWidth,this.canvasHeight);
        //ctx2.stroke();
        ctx9.clip();
        //ctx2.globalAlpha=0.1;
        ctx9.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx9.scale(this.canvasWidthNum*this.big,this.canvasHeightNum*this.big);
        ctx9.lineWidth = 5;
        let tkWidth = this.mapData.boundary.tkWidth;
        ctx9.strokeStyle ="#000";
        ctx9.clearRect(this.mapData.boundary.left+this.mapData.boundary.x,this.mapData.boundary.bottom+this.mapData.boundary.y,
            tkWidth,
            this.mapData.boundary.top-this.mapData.boundary.y-(this.mapData.boundary.bottom+this.mapData.boundary.y));
        ctx9.clearRect(this.mapData.boundary.right-tkWidth-this.mapData.boundary.x,this.mapData.boundary.bottom+this.mapData.boundary.y,
            tkWidth,
            this.mapData.boundary.top-this.mapData.boundary.y-(this.mapData.boundary.bottom+this.mapData.boundary.y));
        ctx9.clearRect(this.mapData.boundary.left+this.mapData.boundary.x,this.mapData.boundary.bottom+this.mapData.boundary.y,
            this.mapData.boundary.right+this.mapData.boundary.x-(this.mapData.boundary.left+this.mapData.boundary.x),
            tkWidth);
        ctx9.clearRect(this.mapData.boundary.left+this.mapData.boundary.x,this.mapData.boundary.top-tkWidth-this.mapData.boundary.y,
            this.mapData.boundary.right+this.mapData.boundary.x-(this.mapData.boundary.left+this.mapData.boundary.x),
            tkWidth);
        // ctx9.fillStyle ="#FF0000";
        ctx9.beginPath();
        ctx9.moveTo(this.mapData.boundary.left+this.mapData.boundary.x,this.mapData.boundary.bottom+this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.left+this.mapData.boundary.x,this.mapData.boundary.top-this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.right-this.mapData.boundary.x,this.mapData.boundary.top-this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.right-this.mapData.boundary.x,this.mapData.boundary.bottom+this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.left+this.mapData.boundary.x,this.mapData.boundary.bottom+this.mapData.boundary.y)
        ctx9.closePath();
        ctx9.stroke();

        ctx9.beginPath();
        ctx9.moveTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x,this.mapData.boundary.top-tkWidth-this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.right-tkWidth-this.mapData.boundary.x,this.mapData.boundary.top-tkWidth-this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.right-tkWidth-this.mapData.boundary.x,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y)
        ctx9.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y)
        ctx9.closePath();
        ctx9.stroke();

        // let calcNum1 = (this.dataRight - this.dataLeft) / 800;
        // num1 = calcNum1;
        // if (num1 * this.canvasWidthNum < 1) {
        //   num1 = 1 / this.canvasWidthNum;
        // }
        // if (num1 * this.big > calcNum1 * 4) {
        //   num1 = calcNum1 * 4 / this.big;
        // }
        // if (num1 < 0.01) {
        //   num1 = 0.1;
        // }
        let font = 11.81/(Math.min(this.canvasHeightNum,this.canvasWidthNum));
        // let font = num1*2;
        font +="px '微软雅黑'";
        console.log(font)
        ctx9.font = font;
        ctx9.textBaseline="middle";


        let stepX = Math.floor(((this.mapData.boundary.right-tkWidth-this.mapData.boundary.x) - (this.mapData.boundary.left+tkWidth+this.mapData.boundary.x))/tkxCnt/10)*10;
        let leftVal = Math.floor((this.mapData.boundary.left+tkWidth+this.mapData.boundary.x)/10)*10;
        for(let i=1 ; i<tkxCnt;i++){
          ctx9.beginPath();
          ctx9.moveTo(leftVal+stepX*i,this.mapData.boundary.bottom+this.mapData.boundary.y)
          ctx9.textAlign = "left";
          ctx9.fillText(" "+(leftVal+stepX*i).toString().substring(2),leftVal+stepX*i,this.mapData.boundary.bottom+this.mapData.boundary.y+tkWidth/2);
          ctx9.textAlign = "right";
          ctx9.fillText((leftVal+stepX*i).toString().substring(0,2) + " ",leftVal+stepX*i,this.mapData.boundary.bottom+this.mapData.boundary.y+tkWidth/2);
          ctx9.lineTo(leftVal+stepX*i,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y)


          ctx9.moveTo(leftVal+stepX*i,this.mapData.boundary.top-this.mapData.boundary.y)
          ctx9.textAlign = "left";
          ctx9.fillText(" "+(leftVal+stepX*i).toString().substring(2),leftVal+stepX*i,this.mapData.boundary.top+this.mapData.boundary.y-tkWidth/2);
          ctx9.textAlign = "right";
          ctx9.fillText((leftVal+stepX*i).toString().substring(0,2)+" ",leftVal+stepX*i,this.mapData.boundary.top+this.mapData.boundary.y-tkWidth/2);
          ctx9.lineTo(leftVal+stepX*i,this.mapData.boundary.top-tkWidth-this.mapData.boundary.y)
          ctx9.closePath();
          ctx9.stroke();
        }

        let bottomVal = Math.floor((this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y)/10)*10;
        let stepY = Math.floor(((this.mapData.boundary.top-tkWidth-this.mapData.boundary.y) - (bottomVal))/tkyCnt/10)*10;
        for(let i=1 ; i<tkyCnt;i++){
          ctx9.beginPath();
          ctx9.moveTo(this.mapData.boundary.left+this.mapData.boundary.x,bottomVal+stepY*i)

          ctx9.save();
          ctx9.translate(this.mapData.boundary.left+this.mapData.boundary.x+tkWidth/2,bottomVal+stepY*i)
          ctx9.rotate(90*Math.PI/180)
          ctx9.textAlign = "left";
          ctx9.fillText(" "+((bottomVal+stepY*i)*-1).toString().substring(2),0,0);
          ctx9.restore();
          ctx9.save();
          ctx9.translate(this.mapData.boundary.left+this.mapData.boundary.x+tkWidth/2,bottomVal+stepY*i)
          ctx9.rotate(90*Math.PI/180)
          ctx9.textAlign = "right";
          ctx9.fillText(((bottomVal+stepY*i)*-1).toString().substring(0,2)+" ",0,0);
          ctx9.restore();
          ctx9.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x,bottomVal+stepY*i)

          ctx9.moveTo(this.mapData.boundary.right-+this.mapData.boundary.x,bottomVal+stepY*i)

          ctx9.save();
          ctx9.translate(this.mapData.boundary.right-this.mapData.boundary.x-tkWidth/2,bottomVal+stepY*i)
          ctx9.rotate(90*Math.PI/180)
          ctx9.textAlign = "left";
          ctx9.fillText(" "+((bottomVal+stepY*i)*-1).toString().substring(2),0,0);
          ctx9.restore();
          ctx9.save();
          ctx9.translate(this.mapData.boundary.right-this.mapData.boundary.x-tkWidth/2,bottomVal+stepY*i)
          ctx9.rotate(90*Math.PI/180)
          ctx9.textAlign = "right";
          ctx9.fillText(((bottomVal+stepY*i)*-1).toString().substring(0,2)+" ",0,0);
          ctx9.restore();
          ctx9.lineTo(this.mapData.boundary.right-tkWidth-this.mapData.boundary.x,bottomVal+stepY*i)
          ctx9.closePath();
          ctx9.stroke();
        }
        // ctx9.fill();
        ctx9.restore();
      }
      //方向标
      if(drawfxb){
        let c10 = this.$refs.iosLise;
        let ctx10=c10.getContext("2d");
        ctx10.save();
        ctx10.rect(0,0,this.canvasWidth,this.canvasHeight);
        ctx10.clip();
        ctx10.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        ctx10.scale(this.canvasWidthNum*this.big,this.canvasHeightNum*this.big);
        ctx10.lineWidth = 5;
        ctx10.textBaseline = "bottom"
        ctx10.textAlign = "center";
        let font = 11.81/(Math.min(this.canvasHeightNum,this.canvasWidthNum));
        font +="px '微软雅黑'";
        ctx10.font = font;
        let tkWidth = this.mapData.boundary.tkWidth;
        let stepX = Math.floor(((this.mapData.boundary.right-tkWidth-this.mapData.boundary.x) - (this.mapData.boundary.left+tkWidth+this.mapData.boundary.x))/20);

        ctx10.beginPath();
        ctx10.moveTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+fxbYOffset)
        ctx10.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+stepX+fxbYOffset)
        ctx10.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+stepX/2+fxbYOffset)
        ctx10.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+fxbYOffset)
        ctx10.closePath();
        ctx10.fill();

        ctx10.fillText("N",this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+fxbYOffset)
        ctx10.beginPath();
        ctx10.arc(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+stepX/2+fxbYOffset,stepX/3,0,2*Math.PI)
        ctx10.closePath();
        ctx10.stroke()

        ctx10.beginPath();
        ctx10.moveTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+fxbYOffset)
        ctx10.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+stepX/2+fxbYOffset)
        ctx10.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+stepX+fxbYOffset)
        ctx10.lineTo(this.mapData.boundary.left+tkWidth+this.mapData.boundary.x+stepX/2+fxbXOffset,this.mapData.boundary.bottom+tkWidth+this.mapData.boundary.y+fxbYOffset)
        ctx10.closePath();
        ctx10.stroke();

        ctx10.restore();
      }
    },
    addImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => {
          resolve(img);
        };
        img.onerror = () => {
          reject();
        };
        img.src = src;
        if (img.complete) {
          resolve(img);
        }
      }).catch((e)=>{console.log("promiseCatch",e)});
    },
    pointDraw(){
      let c = this.$refs.pointCheck;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
      console.log(this.pointNow)
      ctx.save();
      ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
      //ctx.stroke();
      ctx.clip();
      ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
      ctx.scale(this.canvasWidthNum,this.canvasHeightNum);
      ctx.scale(this.big,this.big);
      // let num1 = (this.dataRight-this.dataLeft)/800;
      // if(num1>30){
      //   num1 = 30
      // }
      // if(num1*this.canvasWidthNum<1){
      //   num1=1/this.canvasWidthNum;
      // }

      // let calcNum1 = (this.dataRight-this.dataLeft)/800;
      // let num1 = calcNum1;
      // if(num1>30){
      //   num1 = 30
      // }
      // if(num1*this.canvasWidthNum<1){
      //   num1=1/this.canvasWidthNum;
      // }
      // if(num1*this.big>calcNum1*4){
      //   num1 = calcNum1*4/this.big;
      // }
      // if(num1<0.01){
      //   num1 = 0.1;
      // }

      let num1 = this.pointSize;
      console.log("pointdraw:",num1)
      if(this.isGis) {
        // let calcNum1 = (this.dataRight - this.dataLeft) / 80;
        // num1 = calcNum1;
        // if (num1 > 35) {
        //   num1 = 35
        // }
        // if (num1 * this.canvasWidthNum < 1) {
        //   num1 = 1 / this.canvasWidthNum;
        // }
        // if (num1 * this.big > calcNum1 * 4) {
        //   num1 = calcNum1 * 4 / this.big;
        // }
        // if (num1 < 0.01) {
        //   num1 = 0.1;
        // }
        num1 = 1/(Math.min(this.canvasHeightNum,this.canvasWidthNum));
      }
      if(this.isGisNeedNewPointSizeNow){
        num1 = this.pointSize;
      }
      console.log("pointdraw:",num1)
      // if(num1*this.big>calcNum1*4){
      //   num1 = calcNum1*4/this.big;
      // }
      // if(num1<0.01)
      //   num1 = 0.1;
      //let num1 = 5;
      for(let i in this.pointNow){
        ctx.beginPath();
        ctx.fillStyle="#0F0";
        ctx.strokeStyle="black";
        let font = num1*2;
        //font*=this.canvasWidthNum;
        //font*=this.canvasWidthNum;
        font +="px '微软雅黑'";
        ctx.font = font;
        //let text = this.pointNow[i].text;
        //let num = ctx.measureText(text).width/2;
        //ctx.fillStyle=this.pointNow[i].color;
        ctx.arc(this.pointNow[i].x,this.pointNow[i].y,num1,0,2*Math.PI);
        ctx.textBaseline = "bottom";
        //ctx.fillText(text,this.pointNow[i].x-num,this.pointNow[i].y-5);
        ctx.fill();
        ctx.stroke();
        {
          let txtWidth = ctx.measureText(this.pointNow[i].text).width;
          // const txtHeight = ctx.measureText(text).actualBoundingBoxAscent + ctx.measureText(text).actualBoundingBoxDescent
          ctx.textBaseline = "bottom";
          ctx.fillText(this.pointNow[i].text,this.pointNow[i].x-txtWidth/2,this.pointNow[i].y-num1);
          // ctx.strokeText(text,point.x-txtWidth/2,point.y-num1);
        }
      }
      console.log("绘制了")
      ctx.restore();
    },
    //区块绘制
    blockDraw(){
      let c = this.$refs.blockDraw;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
      ctx.save();
      ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
      //ctx.stroke();
      ctx.clip();
      ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
      ctx.scale(this.canvasWidthNum,this.canvasHeightNum);
      ctx.scale(this.big,this.big);
      ctx.lineWidth=50;
      ctx.beginPath();
      ctx.strokeStyle="black";
      for(let i in this.blockPoint){
        if(i==0){
          ctx.moveTo(this.blockPoint[i].x,this.blockPoint[i].y)
        }
        ctx.lineTo(this.blockPoint[i].x,this.blockPoint[i].y)
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
      console.log("区块绘制了")
    },
    //区块绘制完成
    blockOk(){
      if(this.isBlock==false){
        return
      }
      this.isBlock = false;
      this.clearCanvas()
      this.clearPoint()
      this.clearBlock();
      this.blockDraw();
      // let token = "eyJhbGciOiJSUzI1NiJ9.eyJsb2dpbl9uYW1lIjoiMDA2OTk4OTMiLCJ1c2VyX2lkIjoiMWNwM2RsYWQ4cm9hNTRsc29jeWl0MTI2Iiwib3JnYW5pemF0aW9uIjoiT1JHQVRMMTEwMDA1ODgyIiwiaXNzIjoiYTM2YzMwNDliMzYyNDlhM2M5Zjg4OTFjYjEyNzI0M2MiLCJkaXNwbGF5X25hbWUiOiLmnY7lrrbph5EiLCJyZWdpb24iOiJUTCIsImlhdCI6MTY1MzQ3MjA3MCwiZXhwIjoxNjU2MDY0MDcwfQ.Wly0YfUnzHZEMbnzaOqXiDtOqieOKdSRQAkj6z6WHUrby4-7vCcLLf3SJhiOZkYIDI234OvNV9KPqFQm4rcHkubPOZwU2FHbSLUdPMCAe5cneDDCkhL_lWH8SDGV0prZh1jwcgoa5_jCyqVc0tJpen17M8bPIY3biLVavwUPUffYLjzWSqj-qgI8C395dJ6y2mwKtN7mSGxqlnZjW_LH-07M-1f6hcg6fJaKRE-Vdr6L4ngQ5Es_j4_7ExywP71nQbQxuKYPRpujv5RtK5vAXG4RT6uMmytjwVNc2DmRshSWFKaGow2DROpeVJlbQIN6tM_KRuRYwURsfH6ygbtjkA";
      let token = localStorage.getItem("lyqtJwt");
      let checkedBlock = localStorage.getItem("checkedBlock");
      if (checkedBlock == null) {
        checkedBlock = {};
      }
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let checkedBlkIdAry = [];
      for (let key in jsonCheckedBlk) {
        checkedBlkIdAry.push(key);
      }
      //console.log(checkedBlkIdAry)
      let data = {
        blkIDS:[],
        blkBounds:[]
      };
      data.blkIDS = checkedBlkIdAry;
      console.log(this.blockPoint)
      this.blockPoint.forEach((item,index)=>{
        item.y *= -1;
        item.xh = index+1;
        data.blkBounds.push(item)
      })
      let saveUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/saveBlkBoundary";
      let checkUrl = process.env.VUE_APP_SERVER + "/dataprovider/systemdata/checkBlkBoundary";
      let checkData = {};
      checkData.blkIDS = checkedBlkIdAry;
      console.log(checkData)
      ElMessageBox.confirm(
          '是否将已绘区块数据制提交至服务器',
          '提示',
          {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
          }
      ).then(()=>{
        axios.post(checkUrl,checkData)
            .then(res=>{
              if(res.data.success){
                if(res.data.result){
                  ElMessageBox.confirm(
                      res.data.msg+'是否覆盖?',
                      '提示',
                      {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning',
                      }
                  ).then(()=>{
                    axios.post(saveUrl,data,{
                      headers: {
                        authorization: `Bearer ${token}`,
                      },
                    })
                        .then(ress=>{
                          ElMessage({
                            type: 'success',
                            message: ress.data.msg,
                          })
                          this.updateMapData()
                        })
                  }).catch(()=>{
                    console.log(123)
                  })

                }else{
                  console.log(111111,localStorage.getItem("lyqtJwt"))
                  axios.post(saveUrl,data,{
                    headers: {
                      authorization: `Bearer ${token}`,
                    },
                  })
                      .then(Res=>{
                        console.log(11111111,Res.data.msg)
                        ElMessage({
                          message: Res.data.msg,
                          type: 'success',
                        })
                        this.updateMapData();
                      })
                }
              }
            })
        this.blockPoint=[];
      }).catch(()=>{
        //   console.log(111111111)
        //   this.clearBlock();
        //   this.clearPoint();
        //   this.clearCanvas();
        // this.blockDraw();
        this.blockPoint=[];
      })
      console.log(this.blockPoint)
    },
    //拉框放大绘制
    enlargeDraw(){
      if(this.big>=100){
        ElMessage("已放至最大比例")
        return;
      }
      let w = this.selectWidth;
      let h = this.selectHeight;
      let aspectRatio = this.canvasWidth;
      aspectRatio/=this.canvasHeight;
      let newBig = 1;
      if(w>h){
        h = w;
        h/=aspectRatio;
        newBig = this.canvasHeight/h;
      }else{
        w = h;
        w *=aspectRatio
        newBig = this.canvasWidth/w;
      }
      // let wBig = this.canvasWidth;
      // wBig/= w;
      // let hBig = this.canvasHeight;
      // hBig /= h;
      let moveX = this.iosLiseClick.offsetX;
      let moveY = this.iosLiseClick.offsetY;
      // let scrollX=this.iosLiseClick.scrollX;
      // let scrollY=this.iosLiseClick.scrollY;
      if(this.big>1){
        // wBig *= this.big;
        // hBig *= this.big;
        newBig *= this.big;
        if(newBig>100) newBig = 100;
        let yy = this.vectorMoveYY;
        let xx = this.vectorMoveXX;
        moveX += xx;
        moveY += yy;
        moveX /=this.big;
        moveY /=this.big;
      }
      // moveX *= wBig;
      // moveY *= hBig;
      moveX *= newBig;
      moveY *= newBig;
      this.vectorMoveXX = moveX;
      this.vectorMoveYY = moveY;
      console.log("ENlarge",moveX,moveY,this.big,newBig,this.vectorMoveXX,this.selectWidth,this.canvasWidth)
      // this.big = wBig;
      this.big = newBig;
      this.$nextTick(()=>{
        this.$nextTick(()=>{
          this.$refs.scrollbarY.setScrollTop(moveY);
          this.$refs.scrollbarX.setScrollLeft(moveX);
        })
      },100)
      this.selectWidth=0;
      this.selectHeight=0;
    },
    //拉框放大
    enlarge(){
      this.selectType=1;
      this.clearCanvas();
      this.isEnlarge=true;
    },
    block(){
      this.isBlock = true;
    },
    //选中区块
    blockDown(){
      let c = this.$refs.blockDraw;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
      ctx.save();
      //ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
      //ctx.clip();
      ctx.strokeStyle= "transparent";
      let blkBoundary=[];
      for(let i in this.blkBoundary){
        let x = this.blkBoundary[i].x;
        let y = this.blkBoundary[i].y;
        x -= this.dataLeft;
        y -= this.dataBottom;
        x *= this.canvasWidthNum;
        y *= this.canvasHeightNum;
        x = parseInt(x);
        y = parseInt(y);
        blkBoundary.push({x:x,y:y})
      }
      let point = [];
      this.points.forEach(item=>{
        let pointX = item.x;
        let pointY = item.y;
        pointX-=this.dataLeft;
        pointY-=this.dataBottom;
        pointX*=this.canvasWidthNum;
        pointY*=this.canvasHeightNum;
        pointX = parseInt(pointX);
        pointY = parseInt(pointY);
        point.push({
          x:pointX,
          y:pointY,
          id:item.id,
          mqjb:item.mqjb,
          text:item.text,
          type:item.type
        })
      })
      for(let i in blkBoundary){
        if(i ==0){
          ctx.moveTo(blkBoundary[i].x,blkBoundary[i].y)
        }
        ctx.lineTo(blkBoundary[i].x,blkBoundary[i].y)
      }
      ctx.closePath();
      console.log(ctx.isPointInPath(1,1))
      for(let i in point){
        if(ctx.isPointInPath(point[i].x,point[i].y)){
          console.log("这个点在",point[i],i)
        }
      }
      console.log(11111111)
      ctx.restore();
    },
    //获取canvas内容
    getCanvas(){
      let c8 = this.$refs.iosLise;
      let imgData =c8.toDataURL({format: 'png', quality:1, width:this.canvasWidth, height:this.canvasHeight});
      this.url = imgData;
    },
    //修改当前井颜色
    pointColor(val){
      console.log(val)
      // if(val==="null"){
      //   console.log("nnnnn")
      //   this.pointNow.color="#f00";
      // }
    },
    //色卡绘制
    colorCodeDraw(){
      let c5 = this.$refs.iosLise;
      let ctx5=c5.getContext("2d");
      var grd=ctx5.createLinearGradient(this.canvasWidth+50,50,this.canvasWidth+50,350);
      //var grd=ctx5.createLinearGradient(675,50,675,350);
      let color = this.colorCode;
      let num = 1/this.colorCode.length;
      for(let i in color){
        if(i== 0){
          grd.addColorStop(0,color[i]);
        }
        if(i!=0&&i<color.length-1){
          grd.addColorStop(i*num,color[i]);
        }
        if(i==color.length-1){
          grd.addColorStop(1,color[i]);
        }
      }
      ctx5.fillStyle=grd;
      ctx5.fillRect(this.canvasWidth+50,50,50,300);
      ctx5.beginPath();
      ctx5.lineJoin="round";
      ctx5.strokeStyle ="FF0000";
      ctx5.strokeStyle ="black";
      ctx5.fill();
      ctx5.stroke();
    },
    //等值面颜色获取
    isoRegionColorAdd(){
      this.colorCodeDraw();
      let c = this.$refs.iosLise;
      let ctx=c.getContext("2d");
      let arr =[];
      for(let i in this.isoRegion){
        arr.push(this.isoRegion[i].value);
      }
      console.log(arr)
      let max = arr.sort(function(a, b){return b - a})[0];
      let min = arr.sort(function(a, b){return a - b})[0];
      let length = max;
      length-=min;
      console.log(length)
      for(let i in arr){
        let num = max;
        num -= arr[i];
        num/=length;
        num*=300;
        let color="";
        if(50+num>=350){
          color = ctx.getImageData(this.canvasWidth+50,349,1,1).data;
        }else{
          color = ctx.getImageData(this.canvasWidth+50,50+num,1,1).data;
        }
        //console.log(color)
        var cc = "rgb(";
        cc+=color[0];
        cc+=",";
        cc+=color[1];
        cc+=",";
        cc+=color[2];
        cc+=")";
        this.isoRegionColor[arr[i]]=cc;
      }
      //console.log(this.isoRegionColor);
      ctx.clearRect(this.canvasWidth,40,150,350)
    },
    canvasWheel(e){
      if(!e.shiftKey) return;
      if(e.wheelDelta>0){
        if(this.big>=100)
        {
          ElMessage("已放至最大比例")
        }
        else {
          this.big += 1;
        }
      }
      else{
        if(this.big==2) {
          this.vectorBack()
        }
        else{
          if(this.big<2){
            this.big = 1;
          }
          else {
            this.big -= 1;
          }
        }
      }
      //this.visible=false;

    },
    //右键菜单
    openMenu(event){
      if(!this.isGis) return;
      // if(this.){
      //   this.this.temporaryPoint
      // }
      if((this.needShowProblemMenu&&JSON.stringify(this.temporaryPoint)!='{}')||(this.isBlockCheck==true)){
        // if(this.isBlockCheck){
        //   this.pointNow = {};
        //   this.temporaryPoint = {};
        // }
        let x = event.clientX;
        let y = event.clientY;
        console.log(x,y)
        let num = this.navigationData.length;
        num *= 30;
        if(window.screen.height-num<y){
          this.menuBottom=y
        }else{
          this.menuTop = y;
        }
        console.log(window.screen.height)
        this.menuTop = y;
        this.menuLeft = x;
        if(this.isBlockCheck){
          this.JumpType = 0;
        }else{
          this.JumpType = 1;
        }
        console.log(this.navigationData)
        this.visible = true;
      }else{
        this.visible = false;
      }
    },
    //右键子菜单
    openMenuSon(index){
      if(this.navigationData[index].children!=undefined){
        this.menuSon=this.navigationData[index].children;
        this.menuSonNum=index;
        this.MenuSonVisible=true;
      }else{
        this.MenuSonVisible=false;
      }
    },
    pointJump(){
      this.selectType=1;
      // if(this.$store.state.wellData[0].length>1){
      //   return
      // }
      let point = this.$store.state.wellData[0];
      console.log(point)
      let wellgroupData = this.$store.state.wellgroupData;
      console.log(wellgroupData)

      //let wellgroupData = this.$store.state.wellgroupData;
      for(let i in wellgroupData){
        for( let j in wellgroupData[i].children){
          for(let k in wellgroupData[i].children[j].children){
            if(wellgroupData[i].children[j].children[k].label==point){
              point = wellgroupData[i].children[j].children[k]
            }
          }
        }
      }
      var bbb= JSON.parse(JSON.stringify(point).replace(/label/g,"text"));
      bbb= JSON.parse(JSON.stringify(bbb).replace(/hzbx/g,"y"));
      bbb= JSON.parse(JSON.stringify(bbb).replace(/zzby/g,"x"));
      bbb.y*= -1;
      if(bbb.x==0||bbb.x==null||bbb.y==0||bbb.y==null){
        ElMessage("所选井位置信息有误，无法显示")
        this.temporaryPoint={};
        this.pointNow[0]={};
        this.clearPoint();
        this.clearCanvas()
        this.clearBlock()
        return
      }
      point = bbb;
      this.temporaryPoint=bbb;
      this.pointNow[0]=bbb;
      let pointX = point.x;
      let pointY = point.y;
      pointX-=this.dataLeft;
      pointY-=this.dataBottom;
      pointX*=this.canvasWidthNum;
      pointY*=this.canvasHeightNum;
      pointX=parseInt(pointX);
      pointY=parseInt(pointY);
      this.doCountDraw(pointX,pointY,0,0,point,point.text)
      this.pointDraw();
      console.log("isPointDraw")
    },
    //右键菜单跳转
    routeJump(index){
      console.log(this.menuSon[index])
      let idx = this.menuSon[index].idx;
      let drillObj = {};
      if(this.temporaryPoint.id!=undefined||this.pointNow.length!=0){
        drillObj.type = 1;
        if(this.pointNow.length!=0){
          drillObj.value = JSON.parse(JSON.stringify(this.pointNow))
        }else{
          drillObj.value = JSON.parse(JSON.stringify(this.temporaryPoint))
        }
      }else{
        drillObj.type = 0;
        let checkedBlock = localStorage.getItem("checkedBlock");
        if (checkedBlock == null){
          checkedBlock = {};
        }
        let jsonCheckedBlk;
        try {
          jsonCheckedBlk = JSON.parse(checkedBlock);
        } catch {
          jsonCheckedBlk = JSON.parse("{}");
        }
        let checkedBlkIdAry = [];
        for (let key in jsonCheckedBlk) {
          checkedBlkIdAry.push(key);
        }
        drillObj.value = checkedBlkIdAry;
      }
      this.$store.state.drillObj=drillObj;
      this.$store.state.isJump = true;
      this.$store.state.gisJumpRoute = idx;
      console.log("this.$store.state.drillObj",this.$store.state.drillObj)
      this.$router.push({path:"/home/"+idx})
      this.visible = false;
      this.MenuSonVisible=false;
      this.pointNow=[];
      this.temporaryPoint={}
      this.clearPoint();
      this.clearCanvas();
    },
    //canvas鼠标点击事件
    canvasDown(e){
      if(event.button==0){
        if(this.isSizeChange==false){
          return
        }
        if((this.selectType==2 && JSON.stringify(this.temporaryPoint)==='{}')||this.selectType != 2)
        {
          if(!e.shiftKey && !e.altKey && !e.ctrlKey) {
            this.pointNow = [];
            this.pointIsCheck = false;
            this.clearPoint()
          }
        }
        if(this.isBlock){
          //console.log(this.dataTop,this.dataBottom)
          //console.log(this.vectorMoveXX,this.vectorMoveYY)
          // let x = e.offsetX;
          // let y = e.offsetY;
          // let num = this.big;
          // let moveX = this.vectorMoveXX;
          // let moveY = this.vectorMoveYY;
          // let left = this.mapData.boundary.left
          // x /= this.canvasWidthNum;
          // y /= this.canvasHeightNum;
          // x /= num;
          // y /= num;
          // x = left +x;
          // y = this.mapData.boundary.bottom+y;
          // x += moveX;
          // y += moveY;
          let x = e.offsetX;
          let y = e.offsetY;
          let num = this.big;
          let moveX = this.vectorMoveXX;
          let moveY = this.vectorMoveYY;
          console.log(moveY)
          let left = this.mapData.boundary.left;
          x /= (this.canvasWidthNum*num);
          y /= (this.canvasHeightNum*num);
          x += left;
          y = this.mapData.boundary.bottom+y;
          x+=moveX/(this.canvasWidthNum*num);
          y+=moveY/(this.canvasHeightNum*num);
          this.blockPoint.push({x:x,y:y})
          let c = this.$refs.pointShow;
          let ctx=c.getContext("2d");
          ctx.save();
          ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
          ctx.clip();
          ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
          ctx.scale(this.canvasWidthNum*this.big,this.canvasHeightNum*this.big);
          ctx.beginPath();

          let num1 = (this.dataRight-this.dataLeft)/800;
          if(num1>30){
            num1 = 30
          }
          if(num1*this.canvasWidthNum<1){
            num1 = 1/this.canvasWidthNum
          }
          ctx.lineWidth=num1;
          if(this.blockPoint.length>1){
            for(let i in this.blockPoint){
              if(i==0){
                ctx.moveTo(this.blockPoint[i].x,this.blockPoint[i].y)
              }
              ctx.lineTo(this.blockPoint[i].x,this.blockPoint[i].y)
            }
            ctx.stroke();
          }else{
            ctx.arc(this.blockPoint[0].x,this.blockPoint[0].y,num1*10,0,2*Math.PI);
            ctx.stroke();
            ctx.fill();
          }
          ctx.restore();
          console.log(this.blockPoint)
          console.log(this.mapData.boundary)
        }
        if(this.selectType==3||this.isEnlarge==true || e.altKey){
          //this.iosLiseClick=e;
          this.iosLiseClick.offsetX=e.offsetX
          this.iosLiseClick.offsetY=e.offsetY
          this.iosLiseClick.scrollX=this.$refs.scrollbarX.moveX;
          this.iosLiseClick.scrollY=this.$refs.scrollbarY.moveY;
        }
        if(this.selectType==3&&this.isEnlarge==false&&!e.shiftKey && !e.altKey && !e.ctrlKey){
          this.pointNow=[];
          this.temporaryPoint={}
        }
        if(this.isGis) {
          if (JSON.stringify(this.temporaryPoint) != '{}' && this.selectType == 1) {
            this.pointNow[0] = JSON.parse(JSON.stringify(this.temporaryPoint));
            // 把单井信息传给NavigationView
            let value = JSON.parse(JSON.stringify(this.pointNow));
            this.$store.state.singleWell = value;

            // this.$store.state.singleWell=JSON.parse(JSON.stringify(this.pointNow));
            this.$store.state.singleWellNum++
            console.log("singleWell", this.$store.state.singleWell)
            console.log("singleWell", this.$store.state.singleWellNum)

            this.clearCanvas()
            this.pointDraw()
          }
          if (JSON.stringify(this.temporaryPoint) != '{}' && (this.selectType == 2 || this.selectType == 3)) {
            // if(this.pointNow.findIndex(JSON.parse(JSON.stringify(this.temporaryPoint))) == -1) {
            let selPt = JSON.parse(JSON.stringify(this.temporaryPoint));
            if(this.pointNow.findIndex(item=>item.text==selPt.text) == -1 || this.selectType == 3){
              this.pointNow.push(selPt);
            }
            else{
              console.log("removed")
              this.pointNow.splice(this.pointNow.findIndex(item=>item.text==selPt.text),1);
            }
            // }
            this.clearCanvas()
            this.pointDraw()
          }
        }
        if(this.isMoveMode){
          this.moveBeginAnchor.offsetX=e.offsetX
          this.moveBeginAnchor.offsetY=e.offsetY
          this.moveBeginAnchor.scrollX=this.$refs.scrollbarX.moveX;
          this.moveBeginAnchor.scrollY=this.$refs.scrollbarY.moveY;
        }
        this.visible = false;
        this.MenuSonVisible=false;
        this.iosLiseClickState=true;
        //console.log(e.offsetX,e.offsetY)
      }
    },
    //canvas鼠标抬起事件
    canvasUp(e){
      document.body.style.cursor="default";
      if(this.isSizeChange==false){
        return
      }
      if(this.selectType==3&&!e.altKey&&!e.shiftKey){
        if(this.selectWidth<0){
          this.iosLiseClick.offsetX += this.selectWidth;
          this.selectWidth *= -1
        }
        if(this.selectHeight<0){
          this.iosLiseClick.offsetY += this.selectHeight;
          this.selectHeight *= -1
        }
        this.doCounts(this.iosLiseClick);
      }
      else if(this.isEnlarge==true || e.altKey){
        if(this.selectWidth<0){
          this.iosLiseClick.offsetX += this.selectWidth
          this.selectWidth *= -1
        }
        if(this.selectHeight<0){
          this.iosLiseClick.offsetY += this.selectHeight;
          this.selectHeight *= -1
        }
        this.enlargeDraw();
        this.isEnlarge=false;
      }
      this.iosLiseClickState=false;
      //console.log(e.offsetX,e.offsetY);
      let x = e.offsetX;
      let y = e.offsetY;
      x-=this.iosLiseClick.offsetX;
      y-=this.iosLiseClick.offsetY;
      //this.iosLiseClick=e;
      this.changeSize(x,y)
      this.iosLiseClick={};
      if(this.isPointJump){//联动模式
        if(this.temporaryPoint.id!=undefined||this.pointNow.length!=0) {//井选中联动
          let drillObj = {};
          drillObj.type = 1;
          if (this.pointNow.length != 0) {
            let well = [];
            let wellData = [];
            well.push("GIS_Sel_Well");
            console.log("wells:",JSON.parse(JSON.stringify(this.pointNow[0].text)));
            let len = this.pointNow.length;
            for (let i = 0; i < len; i++) {
              wellData.push(this.pointNow[i].text);
            }
            well.push(wellData);
            well.push("jz");
            this.$store.state.wellData = [];
            this.$store.state.wellData = well;
            drillObj.value = JSON.parse(JSON.stringify(this.pointNow))
          }else{
            drillObj.value = JSON.parse(JSON.stringify(this.temporaryPoint))
          }
          this.$store.state.drillObj=drillObj;
        }
      }
    },
    //矢量井选择
    doCounts(e){
      if(this.selectType==3&&this.iosLiseClickState!=true){
        return
      }
      let canvasX = e.offsetX;
      let canvasY = e.offsetY;

      let canvasX1 = 0;
      let canvasY1 = 0;
      let canvasX2 = 0;
      let canvasY2 = 0;
      if(this.selectType==3&&this.iosLiseClickState==true) {
        canvasX1 = JSON.parse(JSON.stringify(this.iosLiseClick.offsetX));
        canvasY1 = JSON.parse(JSON.stringify(this.iosLiseClick.offsetY));
        canvasX2 = canvasX1 + this.selectWidth;
        canvasY2 = canvasY1 + this.selectHeight;
      }

      let c3 = this.$refs.iosLise;
      let ctx3=c3.getContext("2d");
      ctx3.save();
      ctx3.rect(0,0,this.canvasWidth,this.canvasHeight);
      ctx3.clip();
      ctx3.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
      ctx3.scale(this.canvasWidthNum,this.canvasHeightNum);
      ctx3.scale(this.big,this.big);
      const transform = ctx3.getTransform();
      const imatrix = transform.invertSelf();
      if(imatrix.is2D){
        const {a,b,c,
          d,e,f} = imatrix;
        canvasX = canvasX*a+canvasY*c+e;
        canvasY = canvasX*b+canvasY*d+f;

        canvasX1 = canvasX1*a+canvasY1*c+e;
        canvasY1 = canvasX1*b+canvasY1*d+f;
        canvasX2 = canvasX2*a+canvasY2*c+e;
        canvasY2 = canvasX2*b+canvasY2*d+f;
      }
      ctx3.restore();
      // console.log("moving",canvasX,canvasY,this.points)
      this.clearCanvas();
      let minX = 0;
      let maxX = 0;
      let minY = 0;
      let maxY = 0;
      // let num = this.big;
      // let moveX = this.vectorMoveXX;
      // let moveY = this.vectorMoveYY;
      // moveX/=num;
      // moveY/=num;
      for(let i in this.points){
        let pointX = this.points[i].x;
        let pointY = this.points[i].y;
        pointX-=this.dataLeft;
        pointY-=this.dataBottom;
        pointX*=this.canvasWidthNum;
        pointY*=this.canvasHeightNum;
        pointX=parseInt(pointX);
        pointY=parseInt(pointY);
        if(this.selectType==1||this.selectType==2){
          let x = e.offsetX;
          let y = e.offsetY;
          // let offset = 1.414;
          // let scalNum = (Math.min(this.canvasHeightNum,this.canvasWidthNum));
          // if(scalNum<=0.001){
          //   offset = 1;
          // }
          // else if(scalNum<=0.01){
          //   offset = 2;
          // }
          // else{
          //   offset =  3;
          // }
          // if(this.isGisNeedNewPointSizeNow){
          //   offset = this.pointSize*scalNum;
          // }
          // x/=num;
          // y/=num;
          // x+=moveX;
          // y+=moveY;
          // minX = pointX-offset;
          // maxX = pointX+offset;
          // minY = pointY-offset;
          // maxY = pointY+offset;

          minX = this.points[i].x-this.pointSize/2;
          maxX = this.points[i].x+this.pointSize/2;
          minY = this.points[i].y-this.pointSize/2;
          maxY = this.points[i].y+this.pointSize/2;
          if(canvasX>minX && canvasX <maxX && canvasY>minY && canvasY < maxY){
            this.doCountDraw(pointX,pointY,x,y,this.points[i],this.points[i].text);
            this.temporaryPoint=JSON.parse(JSON.stringify(this.points[i]));
            this.pointIsCheck = true;
            return
          }else{
            this.clearCanvas();
            this.pointIsCheck = false;
            this.temporaryPoint={}

          }
        }
        else if(this.selectType==3&&this.iosLiseClickState==true){
          // minX = JSON.parse(JSON.stringify(this.iosLiseClick.offsetX));
          // maxX = JSON.parse(JSON.stringify(this.iosLiseClick.offsetX));
          // let selectWidth = this.selectWidth;
          // let selectHeight = this.selectHeight;
          // maxX += selectWidth;
          // minY = JSON.parse(JSON.stringify(this.iosLiseClick.offsetY));
          // maxY = JSON.parse(JSON.stringify(this.iosLiseClick.offsetY));
          // maxY += selectHeight;
          // minX/=num;
          // maxX/=num;
          // minY/=num;
          // maxY/=num;
          // minX+=moveX;
          // maxX+=moveX;
          // minY+=moveY;
          // maxY+=moveY;
          minX = canvasX1;
          maxX = canvasX2;
          minY = canvasY1;
          maxY = canvasY2;
          if(maxY<minY){
            // if(pointX>minX && pointX<maxX && pointY<minY && pointY>maxY){
            if(this.points[i].x>minX && this.points[i].x<maxX && this.points[i].y<minY && this.points[i].y>maxY){
              this.doCountDraw(pointX,pointY,0,0,this.points[i],this.points[i].text);
              this.temporaryPoint=JSON.parse(JSON.stringify(this.points[i]));
              this.pointNow.push(JSON.parse(JSON.stringify(this.points[i])))
              this.pointIsCheck = true;
            }
          }else{
            // if(pointX>minX && pointX<maxX && pointY>minY && pointY<maxY){
            if(this.points[i].x>minX && this.points[i].x<maxX && this.points[i].y>minY && this.points[i].y<maxY){
              this.doCountDraw(pointX,pointY,0,0,this.points[i],this.points[i].text);
              this.temporaryPoint=JSON.parse(JSON.stringify(this.points[i]));
              this.pointNow.push(JSON.parse(JSON.stringify(this.points[i])))
              this.pointIsCheck = true;
            }
          }
        }
      }
      this.iosLiseClick={};
      this.selectWidth=0;
      this.selectHeight=0;
      // this.num++;
    },
    //井选择绘制
    doCountDraw(pointX,pointY,x,y,point,text){
      console.log(pointX,pointY,x,y,point,text)
      //console.log(11111)

      let c = this.$refs.pointShow;
      let ctx=c.getContext("2d");
      if(this.selectType===1){
        ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
      }
      ctx.save();
      ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
      //ctx3.stroke();
      ctx.clip();
      ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
      ctx.scale(this.canvasWidthNum,this.canvasHeightNum);
      ctx.scale(this.big,this.big);
      // let num1 = (this.dataRight-this.dataLeft)/800;
      // let calcNum1 = (this.dataRight-this.dataLeft)/800;
      // let num1 = calcNum1;
      // if(num1>30){
      //   num1 = 30
      // }
      // if(num1*this.canvasWidthNum<1){
      //   num1=1/this.canvasWidthNum;
      // }
      // if(num1*this.big>calcNum1*4){
      //   num1 = calcNum1*4/this.big;
      // }
      // if(num1<0.01){
      //   num1 = 0.1;
      // }
      let num1 = this.pointSize;
      console.log("pointdraw:",num1)
      if(this.isGis) {
        // let calcNum1 = (this.dataRight - this.dataLeft) / 80;
        // num1 = calcNum1;
        // if (num1 > 35) {
        //   num1 = 35
        // }
        // if (num1 * this.canvasWidthNum < 1) {
        //   num1 = 1 / this.canvasWidthNum;
        // }
        // if (num1 * this.big > calcNum1 * 4) {
        //   num1 = calcNum1 * 4 / this.big;
        // }
        // if (num1 < 0.01) {
        //   num1 = 0.1;
        // }
        num1 = 1/(Math.min(this.canvasHeightNum,this.canvasWidthNum));
      }
      if(this.isGisNeedNewPointSizeNow){
        num1 = this.pointSize;
      }
      //console.log(num1)
      //let num1 = 5;
      //ctx.strokeStyle='black';
      let font = num1*2;
      // font*=this.big;
      // font*=this.canvasWidthNum;
      if(this.big==1){
        font=15
      }
      font+="px '微软雅黑'";
      ctx.font = font;
      //let text = this.points[i].text;
      //console.log(ctx.measureText(text))
      // let num = ctx.measureText(text).width/2;
      //ctx.fillStyle=this.points[i].color;
      //ctx.fillStyle="black";
      ctx.fillStyle="#0F0";
      // ctx.strokeStyle="#0F0";
      // ctx.lineWidth=9
      ctx.beginPath();
      if(this.big!=1){
        pointX*=this.big;
        pointY*=this.big;
        if(this.beginX!=0&&this.beginY!=0){
          pointX-=this.beginX;
          pointY-=this.beginY;
        }
        // if(x!=0&&y!=0){
        //   ctx.arc(x-this.vectorMoveXX,y-this.vectorMoveYY,(num1+2)*this.canvasWidthNum*this.big,0,2*Math.PI);
        // }else{
        //   ctx.arc(pointX-this.vectorMoveXX,pointY-this.vectorMoveYY,(num1+2)*this.canvasWidthNum*this.big,0,2*Math.PI);
        // }
        ctx.arc(point.x,point.y,num1+num1/3,0,2*Math.PI);
        ctx.stroke();
        ctx.fill();

        {
          let txtWidth = ctx.measureText(text).width;
          // const txtHeight = ctx.measureText(text).actualBoundingBoxAscent + ctx.measureText(text).actualBoundingBoxDescent
          ctx.textBaseline = "bottom";
          ctx.fillText(text,point.x-txtWidth/2,point.y-num1);
          // ctx.strokeText(text,point.x-txtWidth/2,point.y-num1);
        }
        ctx.restore();
      }
      else{
        //ctx.arc(pointX-this.vectorMoveXX,pointY-this.vectorMoveYY,num1*this.canvasWidthNum*2,0,2*Math.PI);
        ctx.restore();
        this.doCountDrawSon(pointX,pointY,text);
      }
      // let n = 5*this.big;
      // //ctx.fillStyle=this.points[i].color;
      // ctx.fillStyle="black";
      // if(this.big==1){
      //   if(pointY-n-25<=0){
      //     ctx.textBaseline = "top";
      //     ctx.fillText(text,pointX-this.vectorMoveXX-num+1,pointY-this.vectorMoveYY+n);
      //   }else{
      //     ctx.textBaseline = "bottom";
      //     ctx.fillText(text,pointX-this.vectorMoveXX-num+1,pointY-this.vectorMoveYY-n);
      //   }
      // }
      // ctx.closePath();
      // //ctx.stroke();
      // ctx.fill();
      //ctx.restore();
      //this.pointNow=JSON.parse(JSON.stringify(this.points[i]));
      //this.pointNow.pointX=JSON.parse(JSON.stringify(pointX));
      //this.pointNow.pointY=JSON.parse(JSON.stringify(pointY));
    },
    doCountDrawSon(pointX,pointY,text){
      let c = this.$refs.pointShow;
      let ctx=c.getContext("2d");
      ctx.arc(pointX-this.vectorMoveXX,pointY-this.vectorMoveYY,5,0,2*Math.PI);
      ctx.fill();
      let font = 5;
      if(this.big==1){
        font=15
      }
      font+="px '微软雅黑'";
      ctx.font = font;
      let num = ctx.measureText(text).width/2;
      let n = 5
      ctx.fillStyle="#0F0";
      // ctx.strokeStyle="#FF0";
      if(this.big==1)
      {
        if(pointY-n-25<=0){
          ctx.textBaseline = "top";
          ctx.fillText(text,pointX-this.vectorMoveXX-num+1,pointY-this.vectorMoveYY+n);
          // ctx.strokeText(text,pointX-this.vectorMoveXX-num+1,pointY-this.vectorMoveYY+n);
        }
        else{
          ctx.textBaseline = "bottom";
          ctx.fillText(text,pointX-this.vectorMoveXX-num+1,pointY-this.vectorMoveYY-n);
          // ctx.strokeText(text,pointX-this.vectorMoveXX-num+1,pointY-this.vectorMoveYY-n);
        }
      }
      ctx.closePath();
    },
    //位图井选择
    doCount(e){
      let num = 0;
      if(this.sizeChangeType==0){
        num = this.scale;
      }else{
        num = this.big;
      }
      let c = this.$refs.pointShow;
      let ctx=c.getContext("2d");
      let x = e.offsetX;
      let y = e.offsetY;
      this.iosLiseClick.offsetX=e.offsetX;
      this.iosLiseClick.offsetY=e.offsetY;
      // let w = 5;
      // w *= num;
      x/=num;
      y/=num;
      let bx = this.beginX;
      let by = this.beginY;
      bx/=num;
      by/=num;
      x+=bx;
      y+=by;
      if(this.sizeChangeType==1){
        let moveX = this.vectorMoveXX;
        let moveY = this.vectorMoveYY;
        moveX/=num;
        moveY/=num;
        x+=moveX;
        y+=moveY;
      }
      for(let i in this.points){
        let pointX = this.points[i].x;
        let pointY = this.points[i].y;
        // if(this.sizeChangeType==1){
        //   console.log(this.vectorMoveXX,this.vectorMoveYY)
        //   //pointX+=this.vectorMoveXX;
        //   //pointY+=this.vectorMoveYY;
        //
        //   console.log(this.vectorMoveXX,this.vectorMoveYY)
        // }
        pointX-=this.dataLeft;
        pointY-=this.dataBottom;
        pointX*=this.canvasWidthNum;
        pointY*=this.canvasHeightNum
        pointX=parseInt(pointX);
        pointY=parseInt(pointY);
        // let xxx = this.vectorMoveXX;
        // xxx/=num;
        // xxx/=num;
        // let yyy = this.vectorMoveYY;
        // yyy/=num;
        // yyy/=num;
        if(x>pointX-10&&x<pointX+10&&y>pointY-10&&y<pointY+10){
          //console.log("begin",this.beginX,this.beginY)
          //console.log("move",moveX,moveY)
          //console.log("point",pointX,pointY)
          //console.log("xy",x,y)
          //ctx.clearRect(0,0,600,400)

          ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
          //ctx.strokeStyle='black';
          ctx.font = "25px '微软雅黑'";
          let text = this.points[i].text;
          ctx.fillStyle=this.points[i].color;
          ctx.beginPath();
          if(this.scale!=1){
            pointX*=this.scale;
            pointY*=this.scale;
            if(this.beginX!=0&&this.beginY!=0){
              pointX-=this.beginX;
              pointY-=this.beginY;
            }
            console.log("绘制1",pointX,pointY)
            ctx.arc(pointX,pointY,40*this.scale,0,2*Math.PI);
          }else{
            console.log(pointX,pointY)
            console.log("绘制2",pointX,pointY)
            ctx.arc(pointX,pointY,40*this.scale,0,2*Math.PI);
          }

          let num = ctx.measureText(text).width/2;
          let n = 40*this.scale;
          ctx.fillStyle=this.points[i].color;

          if(pointY-n-25<=0){
            ctx.textBaseline = "top";
            ctx.fillText(text,pointX-num,pointY+n+2);
          }else{
            ctx.textBaseline = "bottom";
            ctx.fillText(text,pointX-num,pointY-n);
          }
          ctx.stroke();
          ctx.fill();
          this.pointNow.push(this.points[i]);
          //this.pointNow.pointX=pointX;
          //this.pointNow.pointY=pointY;
          return
        }else{
          //ctx.clearRect(0,0,600,400)
          ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
          this.pointNow=[];
        }
      }
      this.num++;
    },
    //井选择右键
    canvasMenu(){
      //JSON.stringify(this.pointNow)!="{}"
      if(this.pointNow.length!=0){
        //this.pointNow.y = this.pointNow.y*-1;
        for(let i in this.pointNow){
          this.pointNow[i].y *= -1;
        }
        this.pointDialogVisible=true;
        console.log(this.pointNow)
      }
    },
    //区块选中绘制
    blockCheck(){
      let c = this.$refs.blockDraw;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
      ctx.save();
      //ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
      //ctx.clip();
      ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
      ctx.scale(this.canvasWidthNum,this.canvasHeightNum);
      ctx.scale(this.big,this.big);
      ctx.globalAlpha=0.3;
      //ctx.globalCompositeOperation="source-atop";
      ctx.fillStyle="#99FFFF";
      for(let i in this.blkBoundary){
        if(i ==0){
          ctx.moveTo(this.blkBoundary[i].x,this.blkBoundary[i].y)
        }
        ctx.lineTo(this.blkBoundary[i].x,this.blkBoundary[i].y)
      }
      ctx.closePath();
      ctx.stroke();
      ctx.fill();
      ctx.restore();
    },
    //判断区块是否选中
    blockIsCheck(e){
      let c = this.$refs.blockDraw;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
      ctx.save();
      for(let i in this.blkBoundary){
        if(i ==0){
          ctx.moveTo(this.blkBoundary[i].x,this.blkBoundary[i].y)
        }
        ctx.lineTo(this.blkBoundary[i].x,this.blkBoundary[i].y)
      }
      ctx.closePath();
      let x = e.offsetX;
      let y = e.offsetY;
      let num = this.big;
      let moveX = this.vectorMoveXX;
      let moveY = this.vectorMoveYY;
      console.log(moveY)
      let left = this.mapData.boundary.left
      x /= (this.canvasWidthNum*num);
      y /= (this.canvasHeightNum*num);
      x += left;
      y = this.mapData.boundary.bottom+y;
      x+=moveX/(this.canvasWidthNum*num);
      y+=moveY/(this.canvasHeightNum*num);
      if(ctx.isPointInPath(x,y)){
        //console.log(e.offsetX,e.offsetY)
        this.clearCanvas();
        this.clearPoint();
        this.clearBlock();
        ctx.beginPath();
        ctx.restore();
        this.blockCheck();
        if(this.pointNow[0]!=undefined){
          this.pointDraw()
        }
        this.isBlockCheck = true;
      }else{
        this.clearCanvas();
        this.clearPoint();
        this.clearBlock();
        ctx.beginPath();
        ctx.restore();
        if(this.pointNow[0]!=undefined){
          this.pointDraw()
        }
        this.isBlockCheck = false;
      }
    },
    //canvas鼠标移动事件
    canvasMove(e){
      if(this.visible){
        return
      }

      if(this.pointShow&&!this.iosLiseClickState&&this.isEnlarge!=true&&!this.isBlock&&!e.altKey){
        var now = + new Date();//防抖
        if(now -this.currentTime > 30){
          if(this.sizeChangeType==0){
            // console.log("count")
            this.doCount(e);
          }else{
            // console.log("counts")
            this.doCounts(e)
          }
          this.currentTime = now;
        }
        //节流
        // var This = this;
        // clearTimeout(This.timer);
        // if(This.flag){
        //   if(!This.timer){
        //     this.doCount(e);
        //   }
        //   This.timer = setTimeout(()=>{
        //     This.timer = null;
        //   },100)
        // }else{
        //   This.timer = setTimeout(()=>{
        //     this.doCount(e);
        //   },100)
        // }
        this.$nextTick(()=>{
          if(this.blkBoundary[0]!=undefined&&this.blockShow&&!this.pointIsCheck){
            // //JSON.stringify(this.blockPoint)!='{}'
            //暂时屏蔽区块选择
            // this.blockIsCheck(e);
            // //ctx.restore();
          }
        })
      }
      // if(this.iosLiseClickState==true){
      //   //console.log(this.iosLiseClick.offsetX,this.iosLiseClick.offsetY)
      //   //console.log(e.offsetX,e.offsetY)
      //   let x =e.offsetX;
      //   let y =e.offsetY;
      //   // if(this.scale!=1){
      //   //   this.changeSize(x,y);
      //   // }
      // }
      if(this.isBlock&&this.iosLiseClickState==false){
        //自定义井绘制鼠标移动跟随
        // if(this.blockPoint.length>0){
        //   console.log(this.dataTop,this.dataBottom)
        //   console.log(this.vectorMoveXX,this.vectorMoveYY)
        //   let x = e.offsetX;
        //   let y = e.offsetY;
        //   let num = this.big;
        //   let moveX = this.vectorMoveXX;
        //   let moveY = this.vectorMoveYY;
        //   let left = this.mapData.boundary.left
        //   x /= this.canvasWidthNum;
        //   y /= this.canvasHeightNum;
        //   x /= num;
        //   y /= num;
        //   x += left;
        //   y = this.mapData.boundary.bottom+y;
        //   // y += top;
        //   x += moveX;
        //   y += moveY;
        //   let c = this.$refs.blockDraw;
        //   let ctx=c.getContext("2d");
        //   ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight)
        //   console.log(this.pointNow)
        //   ctx.save();
        //   ctx.rect(0,0,this.canvasWidth,this.canvasHeight);
        //   //ctx.stroke();
        //   ctx.clip();
        //   ctx.translate(-this.canvasMoveX*this.big-this.vectorMoveXX,-this.canvasMoveY*this.big-this.vectorMoveYY);
        //   ctx.scale(this.canvasWidthNum,this.canvasHeightNum);
        //   ctx.scale(this.big,this.big);
        //   ctx.beginPath();
        //   ctx.moveTo(this.blockPoint[this.blockPoint.length-1].x,this.blockPoint[this.blockPoint.length-1].y)
        //   ctx.lineTo(x,y)
        //   ctx.stroke();
        //   ctx.restore();
        // }
      }
      if(this.iosLiseClickState==false){
        return
      }
      if(this.selectType==3&&this.iosLiseClickState==true&&this.isEnlarge!=true&&!e.shiftKey&&!e.altKey){
        let selectWidth = 0;
        let selectHeight = 0;
        selectWidth = e.offsetX;
        selectWidth -= this.iosLiseClick.offsetX;
        selectHeight = e.offsetY;
        selectHeight -= this.iosLiseClick.offsetY;
        let c = this.$refs.pointShow;
        let ctx=c.getContext("2d");
        ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
        ctx.beginPath();
        ctx.rect(this.iosLiseClick.offsetX, this.iosLiseClick.offsetY, selectWidth, selectHeight);
        ctx.stroke();
        this.selectWidth = selectWidth;
        this.selectHeight = selectHeight;
      }
      if(this.isEnlarge==true || e.altKey){
        let selectWidth = 0;
        let selectHeight = 0;
        selectWidth = e.offsetX;
        selectWidth -= this.iosLiseClick.offsetX;
        selectHeight = e.offsetY;
        selectHeight -= this.iosLiseClick.offsetY;
        let c = this.$refs.pointShow;
        let ctx=c.getContext("2d");
        ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
        ctx.beginPath();
        ctx.rect(this.iosLiseClick.offsetX, this.iosLiseClick.offsetY, selectWidth, selectHeight);
        ctx.stroke();
        console.log(selectWidth,selectHeight)
        this.selectWidth = selectWidth;
        this.selectHeight = selectHeight;
      }
      if(this.isMoveMode==true && this.big>1 && this.isEnlarge==false && this.isBlock==false && !(this.selectType==3&&!e.shiftKey) && !e.altKey){
        document.body.style.cursor="grab";
        let selectWidth = 0;
        let selectHeight = 0;
        selectWidth = e.offsetX;
        selectWidth -= this.moveBeginAnchor.offsetX;
        selectHeight = e.offsetY;
        selectHeight -= this.moveBeginAnchor.offsetY;
        this.$refs.scrollbarX.setScrollLeft( this.moveBeginAnchor.scrollX*this.canvasWidth/100-selectWidth)
        this.$refs.scrollbarY.setScrollTop( this.moveBeginAnchor.scrollY*this.canvasHeight/100-selectHeight)
      }
    },
    updateMapData(){
      this.isGisNeedNewPointSizeNow = false;
      this.$emit('refreshData');
      this.clearCanvas();
      this.clearPoint();
      this.clearBlock();
      this.$emit('refreshData');
      this.vectorBack();
    },
    //绘图刷新
    refresh(){
      this.clearCanvas();
      this.clearPoint();
      this.clearBlock();
      this.draw();
    },
    //打开导出界面
    openFiles(){
      this.filesDialogVisible=true;
      this.fileName=this.iosLiseName;
    },
    //缩放加拖拽
    changeSize(x,y){
      if(this.sizeChangeType==1){
        return
      }
      if(this.isSizeChange==false){
        return
      }
      // if(x==0&&y==0){
      //   return
      // }
      // if(this.scale==1){
      //   return
      // }
      let cc = this.$refs.iosLise;
      let ct=cc.getContext("2d");
      let image = new Image();
      image.src= this.url;
      ct.clearRect(1,1,this.canvasWidth,this.canvasHeight)
      //ct.clearRect(1,1,599,399);
      let scale = this.scale;//缩放比例
      scale=parseFloat(Number(scale).toPrecision(12));
      let beginX = this.beginX;//可视区域左上角x
      let beginY = this.beginY;//可视区域左上角y
      // let endX = this.endX;//可视宽度
      // let endY = this.endY;//可视高度
      let endX = this.endX;//可视宽度
      let endY = this.endY;//可视高度
      beginX/=scale;
      beginY/=scale;
      endX/=scale;
      endY/=scale;
      // let maxX = 600;//可视区域左上角x最大值
      // let maxY = 400;//可视区域左上角y最大值//
      let maxX = this.canvasWidth;//可视区域左上角x最大值
      let maxY = this.canvasHeight;//可视区域左上角y最大值

      if(x!=undefined&&y!=undefined&&this.scale>1){
        let mouseMoveX = x;
        let mouseMoveY = y;
        maxX-=endX;
        maxY-=endY;
        console.log("鼠标便宜了",mouseMoveX,mouseMoveY);
        mouseMoveX/=scale;
        mouseMoveY/=scale;
        console.log("鼠标真实",mouseMoveX,mouseMoveY);
        beginX+=mouseMoveX;
        beginY+=mouseMoveY;
        console.log(beginX,beginY)
        console.log(endX,endY)
        if(beginX<0){
          beginX=0
        }
        if(beginY<0){
          beginY=0
        }
        if(beginX>maxX){
          let mX = 600;
          console.log("beginX"+beginX+"endX"+endX+"maxX"+maxX)
          mX-=endX;
          beginX=maxX;
          console.log("x大了",mX)
        }
        if(beginY>maxY){
          beginY=maxY;
        }
      }else{
        beginX=1;
        beginY=1;
      }
      this.$nextTick(()=>{
        console.log(11111)
        ct.clearRect(0,0,this.canvasWidth,this.canvasHeight);
        //console.log(image,beginX,beginY,endX,endY);
        ct.globalCompositeOperation="source-over";
        ct.drawImage(image,beginX,beginY,endX,endY,1,1,this.canvasWidth,this.canvasHeight);
        console.log(22222)
        beginX*=scale;
        beginY*=scale;
        this.beginX=beginX;
        this.beginY=beginY;
      },100)
      //ctx.putImageData(imgData,0,0);
    },
    //缩放提示返回值
    tooltip(val){
      if(val==1){
        return "正常"
      }
      if(val>1){
        let text = "放大为";
        let num = val;
        num=parseFloat(Number(num).toPrecision(12))
        text +=num;
        text+="倍";
        return text
      }
      if(val<1){
        let text = "缩小为";
        let num = 1;
        num -=val;
        num=parseFloat(Number(num).toPrecision(12))
        text+=num;
        text+="倍";
        return text
      }
      this.draw();
      return parseFloat(Number(val).toPrecision(12))
    },
    clearCanvas(){
      let c = this.$refs.pointShow;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
    },
    clearPoint(){
      let c = this.$refs.pointCheck;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
    },
    clearBlock(){
      let c = this.$refs.blockDraw;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
    },
    //导出
    files(){
      var myCanvas = this.$refs.iosLise;
      // this.big = this.big+10;
      var link = document.createElement("a");
      // var imgData =myCanvas.toDataURL({format: 'png', quality:1, width:this.canvasWidth, height:this.canvasHeight});
      var imgData =myCanvas.toDataURL("image/png");
      imgData = changedpi.changeDpiDataUrl(imgData,300)
      //var strDataURI = imgData.substr(22, imgData.length);
      var blob = this.dataURLtoBlob(imgData);
      var objurl = URL.createObjectURL(blob);
      link.download = this.fileName;
      link.download+=".png";
      link.href = objurl;
      link.click();
      this.filesDialogVisible=false;
    },
    //导出配套函数
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type:mime});
    },

    //点击 设置 按钮（图层管理）
    layerDataSet(index,row){
      console.log(index);
      console.log(row);
      this.layerIndex=index;
      if (row.dataType=="dataSrc")
        this.isLayerDataSrc=true;
      else if (row.dataType=="localFile"){
        this.$refs.upload.click();
        this.theHeaderFiles=JSON.parse(JSON.stringify(this.layer_tableData[index].header));
      }
    },
    //excel文件上传
    takeExcelInfo() {
      this.myFiles = this.$refs.upload.files;
      this.curFileName = "";
      this.excel();
    },
    //excel文件上传
    excel() {
      if (!this.$refs.upload.files) {
        return
      }
      let files = this.$refs.upload.files;
      this.curFileName = files[0].name;
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        try {
          let data = e.target.result;
          const workbook = XLSX.read(data, {type: "binary"});
          let sheetNames = workbook.SheetNames;
          let workSheet = workbook.Sheets[sheetNames];
          let xlsData = XLSX.utils.sheet_to_json(workSheet);
          let xlsHeader = [];
          let xlsHeaderList = {};//记录数据表头信息，用于判断 xlsHeader 添加重复的表头数据
          for (let j = 0; j < xlsData.length; j++) {
            for (let i in xlsData[j]) {
              if (!(i in xlsHeaderList)) {
                xlsHeader.push({
                  isPrimary: false,
                  to: "",
                  type: "string",
                  from: i,
                  label: i
                })
                xlsHeaderList[i] = "";
              }
            }
          }
          //实现上传字段相同名称自动选择
          this.theHeaderFiles.forEach(item => {
            xlsHeader.forEach(Item => {
              if (item.label == Item.label) {
                item.to = Item.label
              }
            })
          })
          this.xlsData = xlsData;
          this.xlsHeader = xlsHeader;
          this.$refs.upload.value = "";
          this.importDialogVisible = true;
          console.log("上传表头：",xlsHeader)
          console.log("上传数据",xlsData)
          console.log(this.theHeaderFiles)
        } catch {
          return false
        }
      }
      if (files.length != 0) {
        fileReader.readAsBinaryString(files[0])
      }
    },
    //数据导入下拉监听
    dataChange(val) {
      let num = 0;
      let num1 = 0;
      console.log(val)
      for (let i in this.theHeaderFiles) {
        if (val == this.theHeaderFiles[i].COLUMN_NAME) {
          num++;
          if (num > 1) {
            ElMessage("目标字段不得重复")
            this.theHeaderFiles[i].COLUMN_NAME = "";
          }
        }
      }
      for (let i in this.theHeaderFiles) {
        console.log(this.theHeaderFiles[i])
        if (val == this.theHeaderFiles[i].to) {
          num1++;
          if (num1 > 1) {
            ElMessage("上传字段不得重复")
            this.theHeaderFiles[i].to = "";
          }
        }
      }
      console.log(this.theHeaderFiles)
    },
    //数据预览
    dataModify() {
      console.log(this.xlsHeader)
      console.log(this.xlsData)
      console.log(this.theHeaderFiles)
      for (let i in this.theHeaderFiles){
        console.log(this.theHeaderFiles[i].to)
        if (this.theHeaderFiles[i].to==undefined || this.theHeaderFiles[i].to==""){
          ElMessage("有未填写信息,请填写完毕后预览数据")
          return
        }
      }
      this.modifyDialogVisible = true;
    },
    refreshByData(){
      let isodata = this.mapData;
      let w = this.$el.offsetWidth;
      w*=0.916666666667
      w-=200;
      let h = this.$el.offsetParent.offsetHeight;
      h-=45;
      h-=48;
      h-=28;
      let dataBottom = isodata.boundary.bottom;
      let dataTop = isodata.boundary.top;
      let dataLeft = isodata.boundary.left;
      let dataRight = isodata.boundary.right;
      let ch = dataTop;
      ch -= dataBottom;
      let cw = dataRight;
      cw -= dataLeft;
      let aspectRatio = w;
      aspectRatio/=h;
      console.log(ch,cw)
      if(aspectRatio<cw/ch){
        let y = cw;
        y /= aspectRatio;
        y-= ch;
        y/=2;
        isodata.boundary.top+=y;
        isodata.boundary.bottom-=y;
        isodata.boundary.x = 0;
        isodata.boundary.y = y;
      }else
      {
        console.log(2)
        let x = ch;
        x*=aspectRatio;
        x-= cw;
        x/=2;
        console.log(x)
        isodata.boundary.left-=x;
        isodata.boundary.right+=x;
        isodata.boundary.x = x;
        isodata.boundary.y = 0;
      }
      isodata.height=this.$el.offsetParent.offsetHeight;
      isodata.baseMap= {};
      // isodata.blkBoundary = [];
      this.getData();
    },
    //数据预览 确认按钮
    modifyOk(){
      let data=[];//构建对应图层的表数据
      let scatterMinVal = 99999999;
      let scatterMaxVal = -99999999;
      let jbDict = {};

      for (let j=0; j < this.xlsData.length; j++) {
        let dataOne = {};//一条表数据
        for (let i = 0; i < this.theHeaderFiles.length; i++) {
          let fieldVaule = this.theHeaderFiles[i].value;//图层字段id
          let to = this.theHeaderFiles[i].to;//上传文件对应字段
          let value=this.xlsData[j][to];//对应值

          if (value==undefined)
            value="";
          console.log("builddata",fieldVaule,value)
          if(this.layerIndex>=0&& this.layerIndex<=3)
          {
            if (value!="" && fieldVaule=="y"){
              value = value*-1;
            }
          }
          if(this.layerIndex>=0&& this.layerIndex<=3)
          {
            if (value!="" && fieldVaule=="x"){
              // value = value*-1;
            }
          }
          dataOne[fieldVaule]=value;
          let absValue = Math.abs(value);//取绝对值
          if(this.layerIndex===3 && fieldVaule==="value"){//找散点最大最小值
            if(absValue>scatterMaxVal) scatterMaxVal = absValue;
            if(absValue<scatterMaxVal) scatterMinVal = absValue;
          }
        }
        data.push(dataOne);
        if(this.layerIndex === 0 && dataOne["type"]!==undefined && dataOne["color"]!==undefined){
          if(jbDict[dataOne["type"]] == undefined) jbDict[dataOne["type"]]=dataOne["color"];
        }
      }
      if(this.layerIndex === 0){
        this.jbMap = jbDict;
        this.jbAry = Object.keys(jbDict);
      }
      this.layer_tableData[this.layerIndex].data=data;
      if(scatterMaxVal !== -99999999 && scatterMinVal !== 99999999 && this.layerIndex === 3){
        this.scatterDataMaxValue = scatterMaxVal;
        this.scatterDataMinValue = scatterMinVal;
      }

      if(this.myFiles.length >0){
        this.layer_tableData[this.layerIndex].fileName = this.myFiles[0].name;
      }
      else{
        this.layer_tableData[this.layerIndex].fileName = this.curFileName.length==0?"已设置":this.curFileName;
      }
      this.importDialogVisible = false;
      this.modifyDialogVisible = false;

      let mapData=this.mapData;
      let object=this.layer_tableData[this.layerIndex].name;
      //井位数据
      if (object == "points"){
        mapData[object] = JSON.parse(JSON.stringify(data));
      }
      //边界数据
      if (object == "blkBoundary"){
        this.blkBoundary=data;
      }
      // 断层数据
      if (object == "faults"){
        mapData[object]=[];//清空mapData的断层数据
        let boundaryObj={};//封装多条断层数据
        let dataCopy=JSON.parse(JSON.stringify(data));
        //根据断层名称区分同一断层数据
        dataCopy.forEach(item=>{
          boundaryObj[item.name]={};
          boundaryObj[item.name].type=item.type;
          boundaryObj[item.name].point=[]
        })
        //添加断层数据
        dataCopy.forEach(item=>{
          let name=item.name;
          delete item.name;
          delete item.type;
          boundaryObj[name].point.push(item);
        })
        //将封装好的断层数据赋值mapData
        for (let key in boundaryObj){
          mapData[object].push(boundaryObj[key]);
        }
      }
      console.log("boundMap",mapData,data)
      //获取x，y最大最下值
      let left=mapData.boundary.left==0 ? data[0].x : mapData.boundary.left;
      let right=mapData.boundary.right==0 ? data[0].x : mapData.boundary.right;
      let top=mapData.boundary.left==0 ? data[0].y : mapData.boundary.top;
      let bottom=mapData.boundary.bottom==0 ? data[0].y : mapData.boundary.bottom;
      data.forEach(item=>{
        if (item.x<left)
          left=item.x;
        if (item.x>right)
          right=item.x;
        if (item.y>top)
          top=item.y;
        if (item.y<bottom)
          bottom=item.y;
      });
      console.log("left:",left)
      console.log("right:",right)
      console.log("top:",top)
      console.log("bottom:",bottom)
      // let extendWidth = (right-left)/5;
      // left -=extendWidth;
      // right += extendWidth;
      //构建x，y最大最小值确定边界数据
      mapData.boundary={
        left:left,
        right:right,
        top:top,
        bottom:bottom,
      };
      console.log("boundMap2",mapData)
      this.clearCanvas();
      this.clearPoint();
      this.clearBlock();
      this.refreshByData();
      console.log("mapData:",mapData);
      console.log("layer_tableData",this.layer_tableData[this.layerIndex]);

    },
    //数据查看按钮 todo 弃用
    overView(){
      let layer_tableData=this.layer_tableData;
      let header=[];//表头
      let tableDataArray=[];//表数据数组
      let tableData=[];//表数据
      //获取所有图层的表头和报表数据
      for (let i=0;i<layer_tableData.length;i++){
        layer_tableData[i].header.forEach(item=>{
          header.push(item);
        });
        if (layer_tableData[i].data.length!=0)
          tableDataArray.push(layer_tableData[i].data)
      }
      if (tableDataArray.length!=0){
        tableData = tableDataArray[0];
        for (let i = 1; i < tableDataArray.length; i++) {
          let item1 = tableData.length > tableDataArray[i].length ? tableData : tableDataArray[i];
          let item2 = tableData.length > tableDataArray[i].length ? tableDataArray[i] : tableData;
          tableData = item1.map((value, index) => {
            return {...value, ...item2[index]}
          })
        }
      }
      console.log(header);
      console.log(tableDataArray);
      console.log(tableData);

      this.overViewHeader=header;
      this.overViewData=tableData;
      this.overViewDialogVisible=true;
    },
    //双击表格触发——修改内容
    editData(row, column){
      if(column.property=="time"){
        return
      }
      row[column.property + "isShow"] = true;//显示编辑框
      this.$nextTick(() => {
        this.$refs[column.property] && this.$refs[column.property].focus(); //聚焦编辑框
      })
    },
    //编辑框失去焦点后触发，隐藏编辑框
    alterData (row, column) {
      row[column.property + "isShow"] = false;
      console.log(row,column);
    },
    //色标模板设置按钮
    setColorTemplate(){
      let cacheColorTemplate = localStorage.getItem("isoColorTemplate");
      // console.log(this.colorCodeTemp)
      if(cacheColorTemplate != null && cacheColorTemplate != undefined && cacheColorTemplate != "") {
        this.colorTemplate = JSON.parse(cacheColorTemplate);
        this.colorTemplateCopy = JSON.parse(JSON.stringify(this.colorTemplate));
      }
      // console.log("curtab",this.colorCodeTemp == 0)
      this.colorTemplateValue=this.colorCodeTemp;
      this.colorSetDialogVisible = true;
    },
    //添加模板 ——色标模板设置
    addColorTemplate(){
      let len=this.colorTemplate.length;
      if (len>=5){
        ElMessage.info("最多支持5个色标模板");
        return
      }

      ElMessageBox.confirm("请选择模板类型", '注意', {
        distinguishCancelAndClose: true,
        confirmButtonText: '区间模板',
        cancelButtonText: '序号模板',
        type: 'warning',
      }).then(() => {
            let temp={
              value:len+1,
              label:"模板"+(len+1),
              type:2,
              data:[]
            }
            this.colorTemplate.push(temp);
          }
      ).catch((action) => {
        if(action == "cancel") {
          let temp={
            value:len+1,
            label:"模板"+(len+1),
            type:1,
            data:[]
          }
          this.colorTemplate.push(temp);
        }
      })
    },
    //删除模板 ——色标模板设置
    deleteColorTemplate(){
      this.colorTemplate.pop();
    },
    //模板添加颜色 ——色标模板设置
    addColor(){
      let templateType = this.colorTemplate[this.colorTemplateValue-1].type;
      if(templateType === undefined) templateType = 1;
      let data=this.colorTemplate[this.colorTemplateValue-1].data;
      let len=data.length;
      if(templateType === 1) {
        if (len >= 5) {
          ElMessage.info("最多支持5个色标");
          return
        }
      }
      let temp={
        number:(data.length+1).toString(),
        color:""
      }
      if(templateType !== 1){
        temp={
          number:(data.length+1).toString(),
          label:(data.length+1).toString(),
          beginNumber:"",
          endNumber:"",
          color:""
        }
      }
      data.push(temp);
    },
    //模板删除颜色 ——色标模板设置
    deleteColor(){
      this.colorTemplate[this.colorTemplateValue-1].data.pop();
    },
    resetColorTemp(){
      this.colorTemplate = JSON.parse(JSON.stringify(this.colorDefaultTemplate));
    },
    //选择色标模板
    selectcoloTemp(){
      this.colorCode=[];
      this.colorTemplate.forEach(item=>{
        if (this.colorCodeTemp==item.value){
          item.data.forEach(ite=>{
            this.colorCode.push(ite.color);
          })
        }
      })
      console.log(this.colorCodeTemp);
      console.log(this.colorCode);

      localStorage.setItem("isoColorTemplate",JSON.stringify(this.colorTemplate));
    },
  },
  watch:{
    "$store.state.mouseWheel":{
      handler(){
        this.visible=false;
        this.MenuSonVisible=false;

      },
      deep:true
    },
    "$store.state.wellData":{
      handler(){
        if(this.$store.state.wellData.length>1){
          return
        }
        if(!this.isPointJump){
          return
        }
        this.pointJump();
      },
      deep:true
    },
    //监听色标颜色插值
    colorCode:{
      handler(){
        if(this.colorCode.length<=1){
          this.colorCodeShow=false;
          this.surfaceShow=false;
        }
        this.configOk();
      },
      deep:true
    },
    mapData:{
      handler(){
        // this.imageTop = this.mapData.boundary.bottom * -1;
        // this.imageTop -= this.mapData.boundary.y;
        // this.imageBottom = this.mapData.boundary.top * -1;
        // this.imageBottom += this.mapData.boundary.y;
        // this.imageLeft = this.mapData.boundary.left;
        // this.imageLeft += this.mapData.boundary.x;
        // this.imageRight = this.mapData.boundary.right;
        // this.imageRight -= this.mapData.boundary.x;
        // this.dataLeft = this.mapData.boundary.left;
        // this.dataRight = this.mapData.boundary.right;
        // this.dataTop = this.mapData.boundary.top;
        // this.dataBottom = this.mapData.boundary.bottom;
        // this.isoRegion = this.mapData.isoRegions;
        // this.linesData = this.mapData.isoLines;
        // this.fault = this.mapData.faults;
        // this.points = this.mapData.points;
        // this.iosLiseName = this.mapData.mapName;
        // //this.imageShow = this.mapData.imageShow;
        // //this.imageShow = true;
        // this.iosLiseHeight = 800;
        // console.log("mapData:",this.mapData);
        // this.initMap();
        // console.log("--------",this.$refs.isoBig)
        // this.$refs.isoBig.$el.click();
        // this.$refs.isoSmall.$el.click();
        // this.getDataSource();
      },
      deep:true
    },
    sizeChangeType(){
      this.$refs.scrollbarY.setScrollTop(0);
      this.$refs.scrollbarX.setScrollLeft(0);
      this.vectorMoveXX=0;
      this.vectorMoveYY=0;
      this.big=1;
      this.scale=1;
    },
    pointDialogVisible(){
      let c = this.$refs.pointShow;
      let ctx=c.getContext("2d");
      ctx.clearRect(0,0,this.canvasWidth,this.canvasHeight);
    },
    //监听等值线
    linesShow(){
      if(this.linesShow==false){
        this.labelShow=false;
      }
      this.configOk();
    },
    selectType(){
      let cc = this.$refs.pointShow;
      let ct=cc.getContext("2d");
      ct.clearRect(0,0,this.canvasWidth,this.canvasHeight)
      this.selectHeight=0;
      this.selectWidth=0;
      this.clearCanvas();
      this.clearPoint();
      this.pointNow=[];
      this.temporaryPoint={}
      this.isEnlarge=false;
    },
    scale(){
      let bx = 600;
      let by =400;
      let x=600;
      let y =400;
      x/=this.scale;
      y/=this.scale;
      bx-=x;
      by-=y;
      bx/=2;
      by/=2;
      this.beginY=by;
      this.beginX=bx;
      console.log(bx,by)
      this.changeSize();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
        this.MenuSonVisible=false;
        this.menuSon=[];
      }else{
        document.body.removeEventListener('click', this.closeMenu)
        this.MenuSonVisible=false;
        this.menuSon=[];
      }
    },
    configWgDialogVisible(){
      if(this.configWgDialogVisible==false){
        this.configWgNum=true;
      }
    },
    encryptionNum(){
      if(this.encryptionNum<=0){
        this.encryptionNum=0
      }else{
        this.encryptionNum=Math.trunc(this.encryptionNum)
      }
    },
    gridSpacing(){
      if(this.gridSpacing<=0){
        this.gridSpacing=0
      }else{
        this.gridSpacing=Math.trunc(this.gridSpacing)
      }
    },
    smoothNum(){
      if(this.smoothNum<=0){
        this.smoothNum=0
      }else{
        this.smoothNum=Math.trunc(this.smoothNum)
      }
    },
    valueReliability(){
      if(this.valueReliability<=0){
        this.valueReliability=0
      }else{
        this.valueReliability=Math.trunc(this.valueReliability)
      }
    },
    gridMax(){
      if(this.gridMax<=0){
        // this.gridMax=0
      }else{
        // this.gridMax=Math.trunc(this.gridMax)
      }
    },
    gridMin(){
      if(this.gridMin<=0){
        // this.gridMin=0
      }else{
        // this.gridMin=Math.trunc(this.gridMin)
      }
    },
    gradInterval(){
      if(this.gradInterval<=0){
        // this.gradInterval=0
      }else{//取消间隔必须为整数的限制
        //this.gradInterval=Math.trunc(this.gradInterval)
      }
    },
    start(){
      if(this.start<=0){
        this.start=0
      }else{
        this.start=Math.trunc(this.start)
      }
    },
    taggingSpacing(){
      if(this.taggingSpacing<=0){
        this.taggingSpacing=0
      }else{
        this.taggingSpacing=Math.trunc(this.taggingSpacing)
      }
    },
    decimalPosition(){
      if(this.decimalPosition<=0){
        this.decimalPosition=0
      }else{
        this.decimalPosition=Math.trunc(this.decimalPosition)
      }
    },
    imageTop(){
      if(this.imageTop<=0){
        this.imageTop=0
      }
      // if((-1*this.imageTop)<this.dataBottom){
      //   this.imageTop= (-1*this.dataBottom)
      // }
    },
    imageBottom(){
      if(this.imageBottom<=0){
        this.imageBottom=0
      }
      // if((-1*this.imageBottom)>this.dataTop){
      //   this.imageBottom = (-1*this.dataTop)
      // }
    },
    imageLeft(){
      if(this.imageLeft<=0){
        this.imageLeft=0
      }

    },
    imageRight(){
      if(this.imageRight<=0){
        this.imageRight=0
      }
    },

    //监听图层控制数据变化
    layer_tableData:{
      handler(){
        console.log(this.layer_tableData);
        this.pointShow=this.layer_tableData[0].show;//井位
        this.faultShow=this.layer_tableData[1].show;//断层
        this.blockShow=this.layer_tableData[2].show;//边界
        this.imageShow=this.layer_tableData[4].show;//底图
        this.isIosLiseName=this.layer_tableData[5].show;//底图
        this.configOk();
      },
      deep:true
    },
    //监听图层属性下单各个数据变化
    linesWidth(){
      this.configOk();
    },
    faultLineWidth(){
      this.configOk();
    },
    pointSize(){
      this.isGisNeedNewPointSizeNow = true;
      this.configOk();
    },
    colorCodeSpacing(){
      this.configOk();
    },
    surfaceShow(){
      this.configOk();
    },
    labelShow(){
      this.configOk();
    },
    linesColor(){
      this.configOk();
    },
    faultColor(){
      this.configOk();
    },
    colorCodeShow(){
      this.configOk();
    },
    czSymbolWidth(){
      this.icCzNeedNewSize = true;
      this.configOk();
    },
    czSymbolHeight(){
      this.icCzNeedNewSize = true;
      this.configOk();
    },
    czSymbolShow(){
      this.configOk();
    },
    czSymbolColorInc(){
      this.configOk();
    },
    czSymbolColorDec(){
      this.configOk();
    },

    czSymbolMaxVal(){
      this.configOk();
    },
    czSymbolMaxNeed(){
      this.configOk();
    },
    czSymbolMinVal(){
      this.configOk();
    },
    czSymbolMinNeed(){
      this.configOk();
    },
    tlSymbolWidth(){
      this.configOk();
    },
    tlSymbolHeight(){
      this.configOk();
    },
    tlSymbolSize(){
      this.configOk();
    },
    tlFontSize(){
      this.configOk();
    },
    tlTileSize(){
      this.configOk();
    },
    tlColCnt(){
      this.configOk();
    },
    tlGapSize(){
      this.configOk();
    },
    tlShow(){
      this.configOk();
    },
  }
}
</script>

<style scoped>
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/input[type="number"]{
  -moz-appearance: textfield;
}
/deep/.cc1 .el-slider__bar{
  background:transparent;
}
/deep/.switchDemo{
  margin-left: 10px;
}
/deep/.switchDemo .el-switch__label--left {
  left: 4px;
}
/deep/.switchDemo .el-switch__label--right {
  right: 4px;
}
/deep/.switchDemo .el-switch__label{
  position: absolute;
  z-index: 111;
  color: #fff;
}
/deep/.switchDemo .el-switch__label span{
  font-size: 12px;
}
/deep/.switchDemo .el-switch__button{
  z-index: 222;
}
.scrollbar-flex-content {
  display: flex;
}
.scrollbar-demo-item-1 {
  flex-shrink: 0;
  display: flex;
  width: 100px;
  height: 1px;
}
.scrollbar-demo-item {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 50px;
}
.title{
  text-align:center;
}
.a1{
  position:relative;
  top:-15px;
}
.xxx{
  --left:"0";
  position:absolute;
  top:0;
  left:var(--left);
}
.cc1{
  position:relative;
  transform:scaleY(-1);
  top:-45px;
}
.cc2{
  position:absolute;
  direction:rtl;
}
.contextMenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  border:1px solid gainsboro;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextMenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextMenu li:hover{
  background-color: rgb(3, 125, 243);;
  color: white;
}

/deep/.el-table__header tr,
/deep/.el-table__header th {
  padding: 0;
  height: 35px;
}
/deep/.el-table__body tr,
/deep/.el-table__body td {
  padding: 0;
  height: 50px;
}
.el-form-item {
  height:30px;
}
</style>